import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";

const translations = {
  es: {
    brand_tagline: "Conserva lo que más importa",
    nav_features: "Funciones",
    nav_pricing: "Planes",
    nav_about: "Acerca",
    nav_login: "Entrar",
    cta_start: "Comenzar",
    cta_secure_legacy: "Asegura tu Legado",
    cta_learn: "Saber más",

    hero_title_1: "Tu legado,",
    hero_title_2: "para siempre.",
    hero_sub:
      "La primera plataforma del mundo que combina cofre cifrado, mensajes del futuro, Fe de Vida y herencia digital. Para que lo que más importa, nunca se pierda.",

    section_problem_label: "El problema",
    section_problem_title: "Lo que se pierde, no vuelve.",
    section_problem_body:
      "Cada año, millones de familias pierden contraseñas, fotos, criptomonedas y recuerdos digitales para siempre. No existe una solución completa. Hasta hoy.",

    stat_crypto: "en criptomonedas perdidas",
    stat_families: "de familias sin acceso a cuentas",
    stat_planning: "sin planificación digital",

    section_solution_label: "La solución",
    section_solution_title: "Una sola plataforma. Todo protegido.",

    feature_vault: "El Cofre",
    feature_vault_d:
      "Contraseñas, documentos y secretos cifrados con AES-256. Toggle Cápsula para lo que solo se revela al morir.",
    feature_messages: "Mensajes del Futuro",
    feature_messages_d:
      "Texto, audio y video para fechas concretas, al fallecer, o como historia familiar.",
    feature_heirs: "Herencia Digital",
    feature_heirs_d:
      "Activos bancarios, crypto, redes sociales y dispositivos entregados automáticamente a tus herederos.",
    feature_pol: "Fe de Vida",
    feature_pol_d:
      "El sistema que activa todo automáticamente cuando ya no estás.",

    pricing_title: "Planes que se adaptan a ti",
    plan_free: "Gratuito",
    plan_personal: "Premium",
    plan_lifetime: "De por Vida",
    plan_popular: "Más popular",

    dash_welcome: "Bienvenido",
    dash_quickactions: "Acciones rápidas",
    dash_pol: "Fe de Vida",
    dash_pol_next: "Próximo registro",
    dash_pol_checkin: "Confirmar que estoy vivo",
    dash_status_alive: "Activo",
    dash_status_pending: "Pendiente",
    pol_state_active: "Activo",
    pol_state_pending: "Pendiente de confirmar",
    pol_state_grace: "En período de gracia",
    pol_state_overdue: "Vencido",

    /* Plans — updated feature list (Iter 34) */
    pricing_top_tier_owned: "Ya tienes el plan superior",
    feat_vault: "Cofre cifrado (AES-256) hasta 50 entradas",
    feat_vault_unlimited: "Cofre cifrado (AES-256) ilimitado",
    feat_messages: "Mensajes del Futuro (texto, audio, vídeo, archivo) hasta 20",
    feat_messages_unlimited: "Mensajes del Futuro ilimitados (texto, audio, vídeo, archivo)",
    feat_heirs: "Hasta 5 herederos con reparto porcentual",
    feat_heirs_unlimited: "Herederos ilimitados con reparto porcentual",
    feat_contacts: "Contactos de confianza",
    feat_assets: "Activos digitales (bancos, cripto, redes, dispositivos) hasta 30",
    feat_assets_unlimited: "Activos digitales ilimitados (bancos, cripto, redes, dispositivos)",
    feat_pol: "Fe de Vida completa",
    feat_pol_full: "Fe de Vida completa con alertas",
    feat_will: "Testamento y Albacea",
    feat_ice: "Documento En Caso de Emergencia (ICE) con 20 secciones",
    feat_ice_full: "Documento En Caso de Emergencia (ICE) completo con 20 secciones",
    feat_ice_pdf: "Exportar ICE a PDF",
    feat_share: "Envío seguro al albacea con código de verificación",
    feat_share_panel: "Panel de enlaces compartidos con revocación",
    feat_export_gdpr: "Exportación total de tus datos (GDPR Art. 20)",
    pricing_lifetime_founders_badge: "Edición Founders · plazas limitadas",
    plan_free_sub: "Empieza sin coste, sin tarjeta",
    plan_free_billed_never: "Sin pagos · Sin tarjeta",
    plan_free_cta_default: "Plan actual",
    plan_free_cta_signup: "Empezar gratis",
    plan_free_feat_vault: "Cofre cifrado AES-256 (5 elementos)",
    plan_free_feat_pol: "Fe de Vida completa",
    plan_free_feat_heir: "1 heredero",
    plan_free_feat_contact: "1 contacto de confianza",
    plan_free_feat_assets: "3 activos digitales",
    plan_free_feat_storage: "1 GB de almacenamiento",
    plan_free_feat_messages_blocked: "Mensajes del Futuro",
    plan_free_feat_ice_blocked: "Documento ICE",
    plan_free_feat_will_blocked: "Testamento y Albacea",
    plans_cancel_anytime: "Cancela cuando quieras",
    pricing_per_month_short: "/mes",
    plans_native_billing_notice: "Gestiona tu plan desde keepsoul.app · Toca cualquier plan para abrirlo en el navegador.",
    feat_contacts_unlimited: "Contactos de confianza ilimitados",
    feat_assets_unlimited_v2: "Activos digitales ilimitados (bancos, cripto, redes, dispositivos, seguros)",
    feat_pol_configurable: "Fe de Vida completa y configurable",
    feat_executor_checklist: "Checklist guiado para el albacea",
    feat_storage_premium: "Almacenamiento cifrado: 10 GB",
    feat_storage_lifetime: "Almacenamiento cifrado: 25 GB",
    feat_languages: "4 idiomas (ES, EN, ZH, KO)",
    feature_will: "Testamento y Albacea",
    feature_will_d:
      "Designa albacea, define instrucciones legales y entrega el plan con código de verificación.",
    feature_ice: "En Caso de Emergencia (ICE)",
    feature_ice_d:
      "Documento completo de 20 secciones con exportación a PDF y panel de enlaces compartidos con revocación.",

    nav_dashboard: "Inicio",
    nav_vault: "El Cofre",
    nav_messages: "Mensajes",
    nav_pol: "Fe de Vida",
    nav_heirs: "Herencia",
    nav_assets: "Activos Digitales",
    nav_capsule: "Cápsula",
    nav_historia: "Historia",
    nav_settings: "Ajustes",
    nav_logout: "Salir",

    vault_title: "El Cofre",
    vault_subtitle: "Tus secretos más valiosos, cifrados para siempre.",
    vault_add: "Añadir al Cofre",
    vault_empty: "Tu cofre está vacío. Comienza guardando lo que más importa.",

    cat_password: "Contraseña",
    cat_document: "Documento",
    cat_photo: "Foto / Recuerdo",
    cat_crypto: "Cripto",
    cat_asset: "Activo",

    msg_title: "Mensajes del Futuro",
    msg_subtitle: "Palabras que viajarán en el tiempo.",
    msg_add: "Crear mensaje",
    msg_empty: "Aún no has escrito mensajes. El futuro espera tus palabras.",
    msg_recipient: "Nombre del destinatario",
    msg_recipient_email: "Email del destinatario",
    msg_subject: "Asunto",
    msg_body: "Tu mensaje",
    msg_date: "Fecha de entrega",
    msg_type_label: "Tipo de mensaje",
    msg_cat_date_label: "Fecha concreta",
    msg_cat_date_hint: "Cumpleaños, boda, fecha clave…",
    msg_cat_death_label: "Al fallecer",
    msg_cat_death_hint: "Se entregará cuando Fe de Vida confirme tu partida.",
    msg_cat_historia_label: "Historia familiar",
    msg_cat_historia_hint: "Recuerdo, anécdota, momento de vida. Forma parte del archivo que recibirán tus herederos.",
    msg_date_required: "Selecciona una fecha de entrega",
    msg_assign_heirs_label: "Herederos también",

    heir_title: "Herencia Digital",
    heir_subtitle: "Designa quién recibirá cada parte de tu legado.",
    heir_add: "Añadir heredero",
    heir_relationship: "Relación",
    heir_share: "Porcentaje",
    heir_empty: "Aún no has nombrado herederos.",
    heir_relationship_ph: "Hijo, Esposa, Hermano…",
    heir_emails_label: "Emails del heredero (añade varios por seguridad)",
    heir_email_primary_ph: "email principal",
    heir_email_backup_ph: "email backup",
    heir_email_primary_tag: "primario",
    heir_remove_email: "Quitar email",
    heir_add_email: "Añadir otro email",
    heir_emails_help: "El sistema enviará la herencia a todos estos emails para máxima seguridad.",
    heir_phone_label: "Teléfono SMS",
    heir_phone_view_label: "Teléfono (SMS backup)",
    heir_at_least_one_email: "Añade al menos un email",
    heir_email_invalid: "Email no válido: {EMAIL}",
    heir_share_range_err: "El porcentaje debe estar entre 1 y 100.",
    heir_share_overflow_err: "Superas el 100% del legado. Disponible: {REMAINING}%.",
    heir_share_assigned: "Repartido: {N}%",
    heir_share_remaining: "Pendiente: {N}%",
    heir_share_warning: "Has asignado menos del 100%. El {N}% restante quedará sin destinatario. ¿Quieres revisar?",
    heir_share_available: "(disponible: {N}%)",
    heir_notify_label: "Avisar al heredero por email ahora",
    heir_notify_help: "Por defecto no se envía nada. Si lo activas, se enviará un correo neutro informando que has incluido a esta persona en tu plan de legado digital. NO revela el contenido.",
    heir_status_complete: "Completo",
    heir_status_pending: "Pendiente",
    heir_emails_count: "Emails",
    heir_tooltip_emails: "Emails configurados",
    heir_tooltip_sms: "SMS backup",
    heir_tooltip_farewell: "Mensaje de despedida",
    heir_tooltip_assets: "Activos digitales",
    heir_tooltip_vault: "Items del Cofre",
    heir_tooltip_messages: "Mensajes",
    heir_tooltip_capsule: "Cápsula",
    heir_farewell_title: "Mensaje de despedida",
    heir_farewell_desc: "Lo primero que recibirá cuando ya no estés. Puedes grabar un audio, video, escribir un texto o adjuntar un archivo personal.",
    heir_farewell_input_label: "Tu despedida",
    heir_nothing_assigned: "Aún no le has asignado nada. Ve al Cofre, Mensajes, Cápsula o Activos Digitales y selecciona a {NAME}.",
    heir_will_receive: "Recibirá automáticamente",
    heir_assigned_assets: "Activos digitales",
    heir_assigned_vault: "Del Cofre",
    heir_assigned_messages: "Mensajes",
    heir_assigned_capsule: "Cápsula",
    heir_link_digital_assets: "Activos Digitales",

    vault_category_label: "Categoría",
    vault_capsule_badge: "Cápsula",
    vault_capsule_tooltip: "Cápsula — solo se revela tras tu fallecimiento",

    media_kind_text: "Texto",
    media_kind_audio: "Audio",
    media_kind_video: "Vídeo",
    media_kind_file: "Archivo",

    contacts_title: "Contactos de confianza",
    contacts_subtitle:
      "Estas personas confirmarán tu Fe de Vida si dejas de responder.",
    contacts_add: "Añadir contacto",
    contacts_empty_title: "Aún no tienes contactos de confianza",
    contacts_empty_body:
      "Sin contactos de confianza, el sistema no puede activar tu herencia automáticamente. Añade al menos 2 personas de confianza —familiares cercanos, amigos íntimos o tu abogado— que puedan confirmar tu estado si dejas de responder a las Fe de Vida.",

    capsule_title: "Cápsula Nuclear",
    capsule_subtitle:
      "Información que solo se revelará tras tu partida. El último abrazo.",
    capsule_add: "Sellar contenido",

    historia_title: "Historia",
    historia_subtitle:
      "Graba tu voz y tus historias. Para que jamás te olviden.",
    historia_add: "Nueva entrada",

    pol_title: "Fe de Vida",
    pol_subtitle: "El corazón del sistema.",
    pol_interval: "Intervalo (días)",
    pol_save: "Guardar",
    pol_last: "Última confirmación",
    pol_next: "Próxima confirmación",

    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    confirm: "Confirmar",
    add: "Añadir",
    close: "Cerrar",
    edit: "Editar",
    view: "Ver",
    show: "Mostrar",
    hide: "Ocultar",
    copy: "Copiar",
    copied: "Copiado",
    saved: "✓ Guardado correctamente",
    deleted: "Eliminado",
    confirm_delete: "¿Eliminar este elemento? No se puede deshacer.",
    name: "Nombre",
    email: "Email",
    phone: "Teléfono",
    title: "Título",
    notes: "Notas",
    content: "Contenido",
    username: "Usuario",
    url: "URL / Sitio web",
    optional: "Opcional",
    created_at: "Creado el",

    plan_current: "Tu plan",
    plan_change: "Cambiar plan",
    plan_view: "Ver planes",
    plan_active: "Plan activo",
    plan_select: "Seleccionar",
    plans_title: "Elige tu plan",
    plans_sub: "Cambia cuando quieras. Lo que importa siempre estará a salvo.",
    plan_saved: "Plan actualizado",

    login_title: "Entra en KeepSoul",
    login_sub: "Tu legado te espera. Accede con email o con Google.",
    login_google: "Continuar con Google",
    login_secure: "Protegido por cifrado de nivel bancario. AES-256 en reposo.",
    login_create: "Crea tu cuenta",
    login_create_sub: "Empieza a proteger lo que más importa",
    auth_name: "Nombre",
    auth_email: "Email",
    auth_password: "Contraseña",
    auth_min8: "Mínimo 8 caracteres",
    auth_password_hint: "Mín. 12 caracteres con mayúsculas, números y símbolo",
    auth_signup_btn: "Crear cuenta",
    auth_login_btn: "Entrar",
    auth_have_account: "¿Ya tienes cuenta? Entra aquí",
    auth_no_account: "¿No tienes cuenta? Crea una",
    auth_welcome: "Bienvenido",
    auth_created: "¡Cuenta creada!",
    auth_forgot: "¿Olvidaste tu contraseña?",
    auth_continue_google: "Continuar con Google",
    auth_need_help: "¿Necesitas ayuda?",
    auth_generic_error: "Ha ocurrido un error. Inténtalo de nuevo.",
    consent_terms_required: "Debes aceptar los Términos y Condiciones para crear una cuenta.",
    consent_privacy_required: "Debes aceptar la Política de Privacidad para crear una cuenta.",
    consent_terms_label: "He leído y acepto los",
    consent_terms_link: "Términos y Condiciones",
    consent_privacy_label: "He leído y acepto la",
    consent_privacy_link: "Política de Privacidad",
    consent_marketing_label: "Acepto recibir comunicaciones comerciales de KeepSoul (opcional).",
    cookie_banner_title: "Privacidad y cookies",
    cookie_banner_msg: "Usamos cookies técnicas necesarias para que la app funcione. No usamos cookies analíticas ni publicitarias por defecto. Puedes elegir qué aceptas.",
    cookie_banner_more: "Ver Política de Cookies",
    cookie_accept_all: "Aceptar todas",
    cookie_reject_all: "Rechazar todas",
    cookie_configure: "Configurar",
    cookie_modal_title: "Configurar cookies",
    cookie_modal_intro: "Elige qué tipo de cookies aceptas. Las técnicas necesarias no se pueden desactivar porque son imprescindibles para el funcionamiento del servicio.",
    cookie_cat_necessary: "Cookies técnicas necesarias",
    cookie_cat_necessary_desc: "Imprescindibles para iniciar sesión, recordar idioma y el propio consentimiento de cookies. No se pueden desactivar.",
    cookie_cat_analytics: "Cookies analíticas",
    cookie_cat_analytics_desc: "Permiten medir el uso del sitio de forma anónima para mejorarlo. Actualmente no se utilizan, pero podrían activarse en el futuro previa solicitud de tu consentimiento.",
    cookie_always_on: "Siempre activas",
    cookie_save_prefs: "Guardar preferencias",
    auth_session_lost: "Cuenta creada pero no se pudo iniciar sesión automáticamente. Por favor inicia sesión manualmente con tu email y contraseña.",

    setup_title: "Tu legado",
    setup_complete: "completo",
    setup_step_vault: "Añadir tu primera contraseña al Cofre",
    setup_step_msg: "Programar tu primer mensaje",
    setup_step_heir: "Configurar tus herederos",
    setup_step_contact: "Añadir un contacto de confianza",
    setup_step_assign: "Asignar items a tus herederos",
    setup_step_pol: "Configurar Fe de Vida",

    tour_title: "Bienvenido a KeepSoul",
    tour_sub: "Te explicamos en 30 segundos cómo funciona tu legado digital",
    tour_step1_t: "El Cofre",
    tour_step1_d: "Todo lo importante, cifrado y protegido. Contraseñas, criptos, documentos, fotos. Marca cualquier item como Cápsula para que solo se revele tras tu partida.",
    tour_step2_t: "Mensajes",
    tour_step2_d: "Palabras que llegarán cuando tú ya no estés. Programa videos, cartas o audios para fechas exactas, momentos clave o como historia familiar para tus seres queridos.",
    tour_step3_t: "Herencia",
    tour_step3_d: "Cada persona recibe exactamente lo que le corresponde. Asigna a tus herederos cada parte de tu legado: cuentas, contraseñas, recuerdos. Sin disputas, sin pérdidas.",
    tour_step4_t: "Fe de Vida",
    tour_step4_d: "El sistema que lo activa todo automáticamente. Cada cierto tiempo confirmas que estás bien. Si dejas de responder, tus contactos de confianza autorizan la entrega del legado.",
    tour_cta: "Empezar a configurar",
    tour_skip: "Saltar tutorial",
    tour_back: "Atrás",
    tour_next: "Siguiente",

    install_title: "Instala KeepSoul",
    install_sub: "Como una app en tu pantalla",
    install_btn: "Instalar",
    install_ios_title: "Instala KeepSoul en tu iPhone",
    install_ios_steps: "Toca Compartir y luego \"Añadir a pantalla de inicio\"",

    save_success: "Guardado en tu Cofre",
    saved_secure: "Cifrado y a salvo",

    landing_compare_title: "Por qué KeepSoul gana",
    landing_compare_sub: "La única plataforma que lo combina todo.",
    cta_final_title: "Hay cosas que no se pueden recuperar.",
    cta_final_sub: "Pero sí pueden conservarse. Empieza hoy.",

    // Pricing (used by Landing.jsx, Plans.jsx, Settings.jsx)
    pricing_no_card: "Sin tarjeta para empezar · Sin renovación automática sorpresa · Cancela cuando quieras",
    pricing_start_free: "Prueba KeepSoul antes de decidir",
    pricing_personal_sub: "Lo elige la mayoría de usuarios de KeepSoul",
    plans_personal_monthly_equiv: "Equivale a 3,25€ al mes — menos que un café",
    plans_free_explore_hint: "Pensado para conocer la plataforma. Cuando estés listo, pasa al plan Personal.",
    pricing_lifetime_label: "De por Vida",
    pricing_lifetime_launch: "🔥 Oferta de lanzamiento",
    pricing_lifetime_sub: "Pago único — sin renovaciones",
    pricing_lifetime_once: " pago único",
    pricing_lifetime_limited: "Limitado a 100 plazas fundadores",
    pricing_per_month: "/mes",
    pricing_per_year: "/año",
    pricing_billed_annually: "facturado anualmente",
    pricing_billed_monthly: "facturado mensualmente",
    pricing_billed_once: "pago único",
    plans_bridge_text: "¿Quieres ir más allá del acceso? El plan Fundadores incluye propiedad real de la empresa.",
    plan_founders_badge: "EDICIÓN FUNDADORES",
    plan_founders_title: "Fundador KeepSoul",
    plan_founders_subtitle: "Propiedad real · Legado eterno",
    plan_founders_slots: "{N} de {TOTAL} plazas disponibles",
    plan_founders_separator: "TODO LO DEL PLAN DE POR VIDA, MÁS:",
    plan_founders_feat_1: "Todo ILIMITADO — sin restricciones",
    plan_founders_feat_2: "Cofre, mensajes, herederos y activos sin tope",
    plan_founders_feat_3: "Sin pagos mensuales nunca",
    plan_founders_feat_4: "Acceso prioritario a nuevas funciones beta",
    plan_founders_feat_5: "Estatus de Fundador #XXX permanente en tu perfil",
    plan_founders_feat_6: "Comunidad privada de fundadores con acceso directo al equipo",
    plan_founders_feat_7: "1 participación real en KeepSoul S.L. — 0,01% del capital social",
    plan_founders_feat_8: "Derecho a dividendos a partir del año 5",
    plan_founders_feat_9: "Participación en precio de venta si hay adquisición (drag-along / tag-along)",
    plan_founders_ownership_title: "¿Qué significa ser propietario?",
    plan_founders_ownership_body: "Al adquirir una plaza Fundador, no solo compras acceso vitalicio a KeepSoul — recibes una participación social real en KeepSoul S.L., con derechos legales reconocidos por la Ley de Sociedades de Capital española.\n\n🌍 El mercado: La gestión de legado digital es un sector de $89B estimado para 2028, con crecimiento anual del 22%. Cada año, 3,8 millones de personas fallecen en Europa dejando activos digitales sin gestionar.\n\n📈 Proyección a 5 años (escenario conservador):\n· 2026: 2.000 usuarios · ARR €168.000 · Dividendo pool: €8.400\n· 2027: 8.000 usuarios · ARR €768.000 · Dividendo pool: €38.400\n· 2028: 25.000 usuarios · ARR €2.700.000 · Dividendo pool: €135.000\n· 2029: 60.000 usuarios · ARR €6.480.000 · Dividendo pool: €324.000\n· 2030: 120.000 usuarios · ARR €14.400.000 · Dividendo pool: €720.000\nDividendo acumulado pool 5% (2026–2030): €1.225.800\n\nEn caso de adquisición: valoración €10M → tu 0,01% = €1.000 · valoración €30M → €3.000\n\n⚖️ Marco legal resumido:\n· Compraventa bajo RDL 1/2010 (Ley de Sociedades de Capital)\n· 1 participación = 0,01% del capital social de KeepSoul S.L.\n· Dividendos cuando el órgano de administración los acuerde\n· Restricción de transmisión los primeros 5 años (derecho de tanteo)\n· Drag-along: si se vende el 100%, participas en el precio\n· Tag-along: si se vende el paquete mayoritario, puedes sumarte\n· Acceso lifetime garantizado. Si hay cierre: 24 meses de servicio o reembolso de €195\n\n⚠️ Las proyecciones son orientativas y no constituyen garantía de retorno.",
    plan_founders_legal_link: "📄 Ver bases legales completas, proyecciones y prospecto →",
    plan_founders_cta: "Convertirme en Fundador →",
    plan_founders_trust: "🔒 Participación registrada en escritura notarial · Solo 500 plazas",
    /* Founders public page */
    founders_page_badge: "PROGRAMA FUNDADORES — EDICIÓN LIMITADA",
    founders_page_label: "Programa Fundadores",
    founders_page_h1: "Sé propietario de KeepSoul.",
    founders_page_h1_sub: "500 plazas. Una sola vez. Para siempre.",
    founders_page_cta_reserve: "Reservar mi plaza",
    founders_page_cta_prospect: "Leer el prospecto completo",
    founders_stat_spots: "Plazas totales",
    founders_stat_price: "Precio único",
    founders_stat_capital: "Del capital social",
    founders_stat_lifetime: "Acceso lifetime",
    founders_problem_label: "POR QUÉ EXISTE KEEPSOUL",
    founders_problem_title: "Cada año, miles de millones de euros desaparecen.",
    founders_problem_body: "Contraseñas perdidas. Criptomonedas inaccesibles. Cuentas olvidadas. Mensajes que nunca llegaron. Cuando alguien fallece sin un legado digital organizado, su familia hereda el caos. KeepSoul es la primera bóveda digital de legado que combina almacenamiento cifrado AES-256 con entrega automática al fallecer — orquestada por un sistema de verificación de vida activa.",
    founders_market_label: "TAMAÑO DEL MERCADO",
    founders_market_title: "Un sector de billones sin resolver.",
    founders_projection_label: "PROYECCIÓN 2026–2031",
    founders_projection_title: "El camino hacia la rentabilidad.",
    founders_projection_sub: "Escenario conservador. Sin acuerdos B2B con aseguradoras ni bancos.",
    founders_projection_disclaimer: "* Proyecciones orientativas. No constituyen garantía de retorno. Los dividendos dependen de rentabilidad real y decisión del órgano de administración.",
    founders_acquisition_upside: "Valoración €10M → tu 0,01% = €1.000 · Valoración €30M → €3.000 · Valoración €100M → €10.000",
    founders_includes_label: "LO QUE RECIBES",
    founders_includes_title: "Tu plaza de Fundador.",
    founders_includes_left_title: "Acceso a la plataforma",
    founders_includes_platform_1: "Todo ILIMITADO en KeepSoul — sin restricciones nunca",
    founders_includes_platform_2: "Cofre, mensajes, herederos y activos sin tope",
    founders_includes_platform_3: "Sin pagos mensuales ni anuales nunca",
    founders_includes_platform_4: "Acceso prioritario a funciones beta",
    founders_includes_platform_5: "Insignia 'Fundador #XXX' permanente en tu perfil",
    founders_includes_platform_6: "Canal privado de fundadores con acceso directo al equipo",
    founders_includes_right_title: "Propiedad de la empresa",
    founders_includes_ownership_1: "1 participación social real en KeepSoul S.L.",
    founders_includes_ownership_2: "0,01% del capital social registrado en escritura notarial",
    founders_includes_ownership_3: "Derecho a dividendos a partir del año 5",
    founders_includes_ownership_4: "Participación en precio de venta si hay adquisición",
    founders_includes_ownership_5: "Derecho de tag-along en venta del paquete mayoritario",
    founders_includes_ownership_6: "Acceso al pacto de socios y estatutos sociales",
    founders_legal_label: "MARCO JURÍDICO",
    founders_legal_title: "Transparencia total.",
    founders_legal_intro: "Esta oferta está estructurada conforme a la legislación vigente. No es crowdfunding, no es un token, no es un préstamo participativo. Es propiedad societaria real.",
    founders_timeline_label: "HOJA DE RUTA",
    founders_timeline_title: "Los próximos cinco años.",
    founders_faq_label: "PREGUNTAS FRECUENTES",
    founders_faq_title: "Todo lo que necesitas saber.",
    founders_cta_title: "Tu plaza te espera.",
    founders_cta_subtext: "Pago único · Sin renovaciones · Propiedad real",
    founders_cta_trust: "🔒 Contrato firmado digitalmente en 72h · Participación notarial · Solo 500 plazas",
    founders_of: "de",
    founders_spots_available: "plazas disponibles",
    founders_footer_disclaimer: "Esta página no constituye una oferta pública de valores ni está sujeta a supervisión de la CNMV. Las participaciones sociales de sociedades limitadas no cotizadas no son valores negociables en mercados regulados.",
    msg_no_body: "Este mensaje sólo contiene contenido multimedia.",
    msg_your_message: "TU MENSAJE",
    msg_attachment_label: "ADJUNTO",
    auth_show_password: "Mostrar contraseña",
    auth_hide_password: "Ocultar contraseña",
    pol_banner_active: "Activo",
    pol_banner_active_sub: "Tu legado está protegido. Próxima confirmación: {DATE}.",
    pol_banner_due: "¡Confirmación requerida pronto!",
    pol_banner_due_sub: "Confirma que estás vivo antes del {DATE} para evitar la activación.",
    pol_banner_risk: "⚠ Tu legado podría activarse",
    pol_banner_risk_sub: "Han pasado más días del esperado. Confirma ahora.",
    pol_banner_cta: "Confirmar que estoy vivo",
    pol_banner_config: "Configurar →",
    pol_view_details: "Ver detalles →",
    pricing_save_yearly: "Ahorras {AMOUNT} al año",
    pricing_billing_monthly: "Mensual",
    pricing_billing_annual: "Anual",
    pricing_lifetime_savings: "(equivalente a 38 años de plan mensual)",
    pricing_cta_start_free: "Empezar gratis",
    pricing_cta_start_personal: "Empezar con Premium",
    pricing_cta_claim_lifetime: "Reclamar oferta De por Vida",
    pricing_cta_lifetime_short: "Reclamar oferta",
    pricing_current: "Plan actual",
    pricing_lifetime_permanent: "Tu plan es permanente",
    pricing_cancel_from_settings: "Cancela desde Ajustes",
    pricing_change_via_support: "Cambio gestionado por soporte",
    pricing_sold_out: "Oferta agotada",
    pricing_legal: "Todos los precios IVA incluido · Cancela cuando quieras desde Ajustes · Cifrado AES-256 · GDPR",
    pricing_lifetime_slots: "Quedan {N} de {TOTAL} plazas",
    plans_popular: "Más popular",
    plans_lifetime_feat_1: "Todo lo de Personal para siempre",
    plans_lifetime_feat_2: "Sin pagos mensuales nunca",
    plans_lifetime_feat_3: "Estatus Fundador KeepSoul",
    plans_lifetime_feat_4: "Acceso prioritario a nuevas funciones",
    plans_free_feat_1: "3 elementos en el Cofre",
    plans_free_feat_2: "1 mensaje del futuro",
    plans_free_feat_3: "1 heredero",
    plans_free_feat_4: "Fe de Vida básica",
    plans_free_feat_5: "100 MB",
    plans_free_feat_6: "2 contactos de confianza",
    plans_free_feat_7: "100 MB almacenamiento",
    plans_personal_feat_1: "100 elementos en el Cofre",
    plans_personal_feat_2: "20 mensajes del futuro",
    plans_personal_feat_3: "3 herederos",
    plans_personal_feat_4: "Activos digitales completos",
    plans_personal_feat_5: "10 GB almacenamiento",
    plans_personal_feat_6: "Contactos ilimitados",
    plans_personal_feat_7: "5 contactos de confianza",
    plans_personal_feat_8: "30 activos digitales",
    plans_personal_feat_9: "Fe de Vida completa",
    plans_lifetime_full_feat_1: "Todo ILIMITADO — sin restricciones",
    plans_lifetime_full_feat_2: "Cofre, mensajes, herederos y activos sin tope",
    plans_lifetime_full_feat_3: "Sin pagos mensuales nunca",
    plans_lifetime_full_feat_4: "Limitado a {N} usuarios",
    plans_lifetime_full_feat_5: "Acceso prioritario a nuevas funciones",
    plans_lifetime_full_feat_6: "Estatus de Fundador KeepSoul",
    plans_lifetime_sold_out_msg: "Oferta agotada — vuelve pronto",
    plans_lifetime_slots_avail: "🔥 {N} de {TOTAL} plazas disponibles",
    plans_lifetime_payment_once: "Pago único — sin renovaciones nunca",
    plans_billing_annual_save: "-17%",
    discount_have_code: "¿Tienes un código de descuento? (opcional)",
    discount_applied: "Código aplicado:",
    discount_full_free: "¡Plan gratis al 100%!",
    discount_apply: "Aplicar",
    discount_validating: "Validando…",
    discount_will_apply: "El código se aplicará al plan que selecciones.",

    // Setup / onboarding progress (Dashboard)
    setup_progress_title: "Tu legado",
    setup_progress_done: "completo",
    setup_pct_remaining: "{N}% por completar",
    setup_done_msg: "¡Listo! Tu legado está configurado.",

    // === Dashboard / LegacyHealth ===
    dh_title: "Salud del Legado",
    dh_status_excellent: "Excelente",
    dh_status_good: "Bueno",
    dh_status_attention: "Necesita atención",
    dh_status_critical: "Crítico",
    dh_heir_no_msg: "{N} heredero sin mensaje de despedida",
    dh_heir_no_msg_plural: "{N} herederos sin mensaje de despedida",
    dh_heir_no_msg_sub: "Graba o escribe unas palabras para que reciban algo personal.",
    dh_heir_no_msg_cta: "Ir a Herederos",
    dh_few_contacts: "Solo {N} contacto de confianza",
    dh_few_contacts_sub: "Recomendamos 3 personas para que 2 puedan confirmar en caso de duda.",
    dh_few_contacts_cta: "Añadir contacto",
    dh_no_assets: "Sin activos digitales registrados",
    dh_no_assets_sub: "Bancos, redes sociales, criptos: lo que no esté aquí se perderá.",
    dh_no_assets_cta: "Añadir activo",
    dh_pol_title: "Fe de Vida",
    dh_pol_next: "Próximo registro:",
    dh_pol_confirm: "Confirmar Fe de Vida",
    dh_pol_state_alive: "Activa",
    dh_pol_state_alert: "Atención requerida",
    dh_pol_state_pending: "Pendiente",

    // === Vault ===
    vault_title: "El Cofre",
    vault_sub: "Tus secretos más valiosos, cifrados para siempre.",
    vault_add: "Añadir al Cofre",
    vault_type_password: "CONTRASEÑA",
    vault_type_capsule: "CÁPSULA",
    vault_type_note: "NOTA",
    vault_type_credential: "CREDENCIAL",

    // === Settings / plan card ===
    set_change_plan: "Cambiar plan",
    set_current_plan: "Plan actual",
    set_pay_recover_q: "¿Pagaste y no se activó tu plan?",
    set_pay_recover_link: "Recuperar pago",
    set_cancel_sub: "Cancelar suscripción",
    set_storage_label: "Almacenamiento",
    set_storage_help: "{PCT}% usado · vídeos y audios cifrados AES-256",
    set_share_title: "Compartir KeepSoul",
    set_share_sub: "Invita a tu familia a proteger su legado",
    set_pol_card_title: "Fe de Vida",
    set_pol_card_sub: "Configurar registros y contactos",
    set_assets_card_title: "Activos Digitales",
    set_assets_card_sub: "Bancos, redes, crypto, dispositivos",
    set_plan_usage_title: "Uso de tu plan",
    set_usage_vault: "Items del Cofre",
    set_usage_messages: "Mensajes programados",
    set_usage_heirs: "Herederos",
    set_usage_contacts: "Contactos confianza",
    set_per_month: "/mes",
    set_per_year: "/año",
    set_pay_once: "pago único",
    set_no_recent_payments: "No encontramos pagos confirmados a tu nombre en los últimos 7 días",
    set_recover_error: "No pudimos comprobar tus pagos. Escríbenos a support@keepsoul.app",
    set_upgrade_plan: "amplía tu plan",
    // Digital Assets
    da_subtitle: "Cuentas, dispositivos, criptomonedas y seguros que se entregarán automáticamente a tus herederos. Este es el mapa de lo que existe — los secretos viven solo en el Cofre cifrado.",
    da_cred_placeholder: "En el Cofre de KeepSoul · 1Password · Gestor del navegador · Papel en caja fuerte…",
    da_cred_hint: "Solo describe dónde están. No escribas la contraseña aquí.",
    da_cred_hint_link: "Guárdala cifrada en el Cofre →",
    da_cred_hint_crypto: "NUNCA pegues aquí la seed phrase ni la clave privada — guárdalas cifradas en el Cofre.",
    da_legacy_tag: "Heredado",
    da_legacy_password: "Contraseña (guardada anteriormente)",
    da_legacy_pin: "PIN (guardado anteriormente)",
    da_legacy_seed: "Seed phrase (guardada anteriormente)",
    da_add: "Añadir",
    da_empty_for: "Aún no has añadido {LABEL}.",
    da_assigned_to: "Asignado a",
    da_heir: "heredero",
    da_heirs: "herederos",
    da_no_heirs_assigned: "Sin herederos asignados",
    da_warn_sensitive: "Esta información es extremadamente sensible. Está cifrada con AES-256 y solo se revelará tras confirmación de fallecimiento.",
    da_warn_seed: "Nunca compartas esto con nadie. Solo se descifrará para tu heredero asignado tras Fe de Vida confirmada.",
    da_security_note: "Este dato está cifrado con AES-256-GCM en reposo. Solo se revelará automáticamente al heredero asignado cuando Fe de Vida confirme tu fallecimiento.",
    da_assign_heirs: "Asignar a herederos",
    da_label_title: "Título / Etiqueta",
    da_title_ph: "Ej: {EXAMPLE}",
    da_eg_bank: "BBVA cuenta principal",
    da_eg_social: "Instagram personal",
    da_eg_generic: "Etiqueta corta",
    da_instruction_ph: "Qué quieres que haga el heredero con esto…",
    da_edit_asset: "Editar activo",
    da_view_notes: "Notas",
    da_view_instruction: "Instrucción",
    da_view_encryption: "Cifrado AES-256-GCM en reposo · Solo se entregará automáticamente al heredero cuando Fe de Vida confirme tu fallecimiento.",
    select: "Selecciona",
    vault_field_password: "Contraseña",
    vault_capsule_label: "Cápsula",
    vault_capsule_desc: "Solo se revelará tras mi fallecimiento. Marca esta opción para items que tu heredero solo recibirá cuando Fe de Vida confirme tu partida.",
    hap_default_label: "Herederos que reciben esto",
    hap_no_heirs_yet: "Aún no has añadido herederos. Ve a 'Herencia' para añadir uno primero.",
    hap_no_assignment_warning: "Sin heredero asignado, este elemento NO se entregará automáticamente.",

    // === Landing — sections ===
    lp_problem: "EL PROBLEMA",
    lp_problem_title: "Lo que se pierde, no vuelve.",
    lp_problem_sub: "Cada año, millones de familias pierden contraseñas, fotos, criptomonedas y recuerdos digitales para siempre. No existía una solución completa. Hasta hoy.",
    lp_stat_crypto: "en criptomonedas perdidas",
    lp_stat_passwords: "de claves olvidadas al morir el dueño",
    lp_stat_accounts: "cuentas que quedan en el limbo digital",
    lp_solution: "LA SOLUCIÓN",
    lp_feature_vault: "Cofre Cifrado",
    lp_feature_vault_desc: "Contraseñas, claves de cripto y secretos cifrados con AES-256.",
    lp_feature_msg: "Mensajes del Futuro",
    lp_feature_msg_desc: "Audios, vídeos y cartas que se entregan en la fecha que tú elijas.",
    lp_feature_pol: "Fe de Vida automática",
    lp_feature_pol_desc: "Si dejas de confirmar, se activa el protocolo de herencia digital.",
    lp_feature_heirs: "Herencia Digital",
    lp_feature_heirs_desc: "Designa herederos y reparte tu legado de forma segura.",
    lp_feature_ai: "IA de Legado",
    lp_feature_ai_desc: "Conversa con tu legado: cuenta historias, asistente personal.",
    lp_feature_zk: "Cifrado AES-256-GCM en reposo",
    lp_feature_zk_desc: "Tus datos sensibles se almacenan cifrados con AES-256-GCM. Solo se entregan a tus herederos cuando se activa el protocolo.",
    lp_how_title: "El sistema que se activa automáticamente cuando ya no estás aquí.",

    // Legacy Health signals (keyed by backend `k`)
    lh_label: "Salud del legado",
    lh_loading: "Analizando tu legado…",
    lh_all_good: "Todo en orden. ¡Buen trabajo!",
    lh_well_protected: "Tu legado está bien protegido",
    lh_resending: "Enviando…",
    lh_grade_excellent: "Excelente",
    lh_grade_good: "Bueno",
    lh_grade_fair: "Mejorable",
    lh_grade_weak: "Débil",
    sig_email_unverified_title: "Confirma tu email",
    sig_email_unverified_detail: "Hasta que confirmes tu email tu legado no se puede entregar.",
    sig_email_unverified_cta: "Reenviar email",
    sig_heirs_no_farewell_title: "{N} herederos sin mensaje de despedida",
    sig_heirs_no_farewell_title_1: "{N} heredero sin mensaje de despedida",
    sig_heirs_no_farewell_detail: "Graba o escribe unas palabras para que reciban algo personal.",
    sig_heirs_no_farewell_cta: "Ir a Herederos",
    sig_no_heirs_title: "Aún no has añadido herederos",
    sig_no_heirs_detail: "Sin herederos, no podemos entregar tu legado a nadie.",
    sig_no_heirs_cta: "Añadir heredero",
    sig_no_contacts_title: "Sin contactos de confianza",
    sig_no_contacts_detail: "Necesitas al menos 1 contacto para validar tu Fe de Vida.",
    sig_no_contacts_cta: "Configurar Fe de Vida",
    sig_contacts_low_title: "Solo {N} contactos de confianza",
    sig_contacts_low_title_1: "Solo {N} contacto de confianza",
    sig_contacts_low_detail: "Recomendamos 3 personas para que 2 puedan confirmar en caso de duda.",
    sig_contacts_low_cta: "Añadir contacto",
    sig_vault_empty_title: "Tu Cofre está vacío",
    sig_vault_empty_detail: "Guarda al menos una contraseña o documento importante.",
    sig_vault_empty_cta: "Ir al Cofre",
    sig_no_messages_title: "Sin mensajes programados",
    sig_no_messages_detail: "Escribe un mensaje para alguien — un cumpleaños, una despedida…",
    sig_no_messages_cta: "Crear mensaje",
    sig_no_assets_title: "Sin activos digitales registrados",
    sig_no_assets_detail: "Bancos, redes sociales, criptos: lo que no esté aquí se perderá.",
    sig_no_assets_cta: "Añadir activo",
    sig_stale_title: "Tu legado lleva {N} días sin actualizar",
    sig_stale_detail: "Revisa que todo siga vigente: claves, herederos, mensajes.",
    sig_stale_cta: "Revisar",
    sig_pol_overdue_title: "Fe de Vida vencida",
    sig_pol_overdue_detail: "Confirma tu Fe de Vida cuanto antes para evitar la alerta a tus contactos.",
    sig_pol_overdue_cta: "Confirmar ahora",
    sig_pol_soon_title: "Fe de Vida en {N} días",
    sig_pol_soon_detail: "Recuerda confirmar antes de la fecha.",
    sig_pol_soon_cta: "Ir a Fe de Vida",

    setup_done_msg_old: "_dup_",

    // ExampleHint blocks (decorative usage suggestions at the bottom of each section)
    hint_vault_title: "Qué guardar aquí",
    hint_vault_1: "Por ejemplo, guarda las <strong>claves de tus carteras de criptomonedas</strong> (seed phrase) para que tu familia pueda recuperar tu Bitcoin.",
    hint_vault_2: "O las <strong>contraseñas de tus cuentas bancarias y servicios importantes</strong> (Gmail, Apple ID, Netflix…) para que cierren o transfieran lo que necesiten.",
    hint_vault_3: "Cifrado con AES-256-GCM en reposo. Tú accedes a tu Cofre cuando quieras desde tu cuenta. Cuando se active el protocolo Fe de Vida, el contenido que hayas asignado se entregará a los herederos que designes.",
    hint_messages_title: "Mensajes que dejan huella",
    hint_messages_1: "Por ejemplo, programa <strong>20 mensajes para tu hijo</strong>, uno para cada cumpleaños hasta los 40. Que reciba un audio tuyo el día que cumpla 25, otro al casarse, otro cuando nazca su primer hijo.",
    hint_messages_2: "O graba un vídeo para tu pareja recordando vuestra primera cita, y programa que llegue cada aniversario.",
    hint_messages_3: "También puedes dejar una carta para abrir el día que tu nieto se gradúe. El amor no caduca.",
    hint_heirs_title: "Quién será tu heredero digital",
    hint_heirs_1: "Por ejemplo, designa a <strong>tu hijo mayor</strong> para que reciba las claves del vault y los datos bancarios, y a tu hermana para que reciba los mensajes personales.",
    hint_heirs_2: "Cada heredero recibe solo lo que tú le asignas — puedes mezclar y repartir como prefieras.",
    hint_heirs_3: "Cuando tu Fe de Vida confirme tu fallecimiento, KeepSoul les enviará un email seguro con el acceso a su parte del legado.",
    hint_assets_title: "Activos que no deben perderse",
    hint_assets_1: "Por ejemplo, registra tu <strong>cuenta bancaria principal</strong> con el IBAN y el número de teléfono asociado, para que tu pareja sepa dónde está el dinero.",
    hint_assets_2: "O tu cartera de <strong>criptomonedas</strong> (Binance, MetaMask, Ledger) con instrucciones de recuperación cifradas.",
    hint_assets_3: "También cuentas de redes sociales para que las cierren o memorialicen, planes de pensiones, seguros de vida, cuentas de Hacienda…",
      /* Landing additions (auto-translated) */
    nav_founders: "Fundadores",
    nav_security: "Seguridad",
    nav_signup_cta: "Empezar gratis",
    nav_back_home: "Inicio",
    nav_dashboard_short: "Ir al dashboard",
    landing_trust_aes: "🔒 Cifrado AES-256",
    landing_trust_gdpr: "🇪🇺 Conforme con GDPR",
    landing_trust_zk: "🛡️ Zero knowledge",
    landing_trust_founders: "⭐ 500 fundadores",
    landing_how_label: "CÓMO FUNCIONA",
    landing_how_title: "Tres pasos. Un legado.",
    landing_how_1_title: "Guarda",
    landing_how_1_body: "Añade contraseñas, documentos, mensajes y activos digitales en tu bóveda cifrada.",
    landing_how_2_title: "Designa",
    landing_how_2_body: "Nombra a tus herederos y decide qué recibe cada uno, y cuándo.",
    landing_how_3_title: "Entrega automática",
    landing_how_3_body: "KeepSoul verifica periódicamente que estás bien. Si no respondes, entrega tu legado automáticamente.",
    landing_security_label: "SEGURIDAD",
    landing_security_title: "Tu legado, sólo en tus manos.",
    landing_security_aes_title: "AES-256-GCM",
    landing_security_aes_body: "El mismo estándar que usan bancos y gobiernos para proteger información crítica.",
    landing_security_gdpr_title: "GDPR · LOPDGDD",
    landing_security_gdpr_body: "Cumplimiento total con la normativa europea y española de protección de datos.",
    landing_security_zk_title: "Zero-Knowledge",
    landing_security_zk_body: "Los datos se cifran antes de salir de nuestros servidores. Ni siquiera nosotros podemos verlos.",
    landing_proof_label: "POR QUÉ KEEPSOUL",
    landing_proof_title: "Construido para lo que importa.",
    landing_proof_stat1_value: "€14.000M",
    landing_proof_stat1_label: "en criptomonedas perdidas por fallecimiento sin planificación",
    landing_proof_stat2_value: "68%",
    landing_proof_stat2_label: "de adultos europeos sin plan de legado digital",
    landing_proof_stat3_value: "3 min",
    landing_proof_stat3_label: "tiempo medio para proteger tus primeros activos",
    landing_final_subtle: "Ya somos 500+ fundadores · Cifrado AES-256 · GDPR",
    landing_footer_tagline: "Protege lo que importa.",
    landing_footer_col_product: "Producto",
    landing_footer_col_legal: "Legal",
    landing_footer_col_support: "Soporte",
    landing_footer_about: "© 2026 KeepSoul · Murcia, España",
    upgrade_modal_title: "Has llegado al límite de tu plan",
    upgrade_modal_body: "El plan gratuito incluye {LIMIT} {ITEM}. Actualiza a Premium para continuar sin límites.",
    upgrade_modal_cta: "Ver planes →",
    upgrade_modal_dismiss: "Ahora no",
    payment_success_banner: "🎉 ¡Pago completado! Tu plan {PLAN} está ahora activo.",
    payment_success_founder: "🏛️ ¡Bienvenido, Fundador #{N}! Tu participación en KeepSoul está confirmada. Recibirás tu contrato en 72h.",
    payment_cancelled_banner: "Pago cancelado. Tu plan no ha cambiado.",
    payment_dismiss: "Cerrar",
    /* Founders funds-allocation + table headers (auto-translated) */
    founders_proj_col_year: "Año",
    founders_proj_col_users: "Usuarios activos",
    founders_proj_col_arpu: "ARPU mensual",
    founders_proj_col_arr: "ARR estimado",
    founders_proj_col_div: "Dividendo pool 5%",
    founders_proj_total: "TOTAL",
    founders_proj_cumulative: "acumulado",
    founders_arpu_note: "= ingreso medio mensual por usuario de pago (Average Revenue Per User). Combina suscriptores mensuales y anuales. No todos los usuarios activos pagan: una parte usa el plan gratuito.",
    founders_funds_label: "DESTINO DE LOS FONDOS",
    founders_funds_title: "Cada euro, al crecimiento.",
    founders_funds_intro: "El 100% del capital captado en el Programa Fundadores se reinvierte directamente en hacer crecer KeepSoul. No es un gasto: es combustible para convertir un producto sólido en un referente del sector.",
    founders_funds_marketing_title: "Marketing y adquisición",
    founders_funds_marketing_body: "Campañas de captación, posicionamiento SEO, contenido y presencia en los mercados clave de España y LATAM para darnos a conocer.",
    founders_funds_product_title: "Producto y tecnología",
    founders_funds_product_body: "Nuevas funciones, mejoras de seguridad, escalado de infraestructura y desarrollo continuo de la plataforma.",
    founders_funds_alliances_title: "Alianzas y expansión",
    founders_funds_alliances_body: "Acuerdos con notarías, gestorías, aseguradoras y bancos. Apertura a nuevos países e idiomas.",
    founders_funds_legal_title: "Estructura legal y operativa",
    founders_funds_legal_body: "Constitución de la SL, cumplimiento normativo, soporte y operaciones del día a día.",
    founders_funds_closing: "Tu inversión no se queda parada. Trabaja para llevar a KeepSoul hasta lo más alto — y a ti contigo.",
    /* Landing: remove-zk replacements (auto-translated) */
    landing_trust_encrypted: "🔐 Cifrado en reposo",
    landing_final_subtle_no_founders: "Cifrado AES-256 · GDPR · Hecho en Murcia, España",
    landing_security_atrest_title: "Cifrado en reposo",
    landing_security_atrest_body: "Tus datos sensibles se cifran en nuestros servidores con AES-256-GCM antes de almacenarse. Si alguien accediera a la base de datos, no vería más que ruido.",
    /* Bug 3 batch (auto-translated) */
    confirm_email_missing_token: "Falta el token de confirmación.",
    confirm_email_error_default: "No se pudo confirmar el email.",
    confirm_email_loading_title: "Confirmando tu email…",
    confirm_email_loading_body: "Un momento, por favor.",
    confirm_email_success_title: "¡Email confirmado!",
    confirm_email_success_body: "Tu legado digital está ahora activo. Inicia sesión y configura tu Fe de Vida para empezar a proteger lo que más importa.",
    confirm_email_go_dashboard: "Ir a mi panel",
    confirm_email_go_login: "Iniciar sesión",
    confirm_email_error_title: "No se pudo confirmar",
    confirm_email_error_help: "El enlace puede haber expirado o ya ha sido usado. Inicia sesión y pide un nuevo email de confirmación desde tu panel.",
    login_email_confirmed_banner: "Tu email ha sido confirmado correctamente. Inicia sesión para entrar a tu panel.",
    login_tab_email: "Email",
    login_any_email_hint: "Funciona con cualquier email (Gmail, Outlook, ProtonMail, etc.)",
    settings_share_copied: "Mensaje copiado al portapapeles ✨",
    settings_share_failed: "No se pudo compartir",
    settings_downgrade_confirm: "¿Cancelar tu suscripción y volver al plan Gratuito? Mantendrás tu cuenta y datos.",
    settings_downgrade_done: "Suscripción cancelada. Plan Gratuito activo.",
    settings_generic_error: "Error",
    settings_delete_done: "Cuenta eliminada. Te hemos enviado un email de confirmación.",
    settings_delete_failed: "Error eliminando cuenta",
    settings_export_google_warn: "Tu cuenta usa Google. Crea una contraseña en Ajustes antes de exportar.",
    settings_export_started: "Descarga iniciada. Guárdalo en un lugar seguro.",
    pol_confirmed_toast: "Fe de Vida confirmada ✓",
    discount_applied_full: "¡Plan activado al 100%!",
    evb_already_verified: "Tu email ya está confirmado. Recarga la página.",
    /* EmailVerifyBanner */
    evb_title: "Confirma tu email para activar tu legado",
    evb_body_prefix: "Te enviamos un enlace a",
    evb_body_suffix: "Hasta que lo confirmes, la Fe de Vida y la entrega del legado están desactivadas.",
    evb_sending: "Enviando…",
    evb_resend_cta: "Reenviar email",
    evb_resent_to: "Email de confirmación enviado a {email}",
    evb_resend_failed: "No se pudo enviar el email",
    /* Bug 3 extra (auto-translated) */
    pol_demo_email_sent: "Email demo enviado a {EMAIL}. Revisa tu bandeja en unos minutos.",
    historia_no_audio_first: "Graba o sube un audio primero",
    historia_transcribe_done: "Transcripción completa ✓",
    historia_transcribe_failed: "No se pudo transcribir",
    settings_export_link_sent: "Enlace enviado a {EMAIL}. Tienes 60 min para descargarlo.",
    media_video_too_long: "Vídeo demasiado largo. Máximo 60 min.",
    media_video_low_res: "Vídeo en baja resolución ({W}×{H}). Se subirá igualmente, pero recomendamos al menos 720p para tus recuerdos.",
    media_audio_limit_30min: "Se alcanzó el límite de 30 min.",
    media_mic_denied: "Permiso de micrófono denegado. Actívalo en Ajustes de tu navegador.",
    media_mic_failed: "No se pudo iniciar la grabación. Comprueba el micrófono.",
    media_file_too_large: "Este archivo es demasiado grande. Máximo {MB}MB.",
    media_file_added: "Archivo añadido",
    media_file_uploaded: "✓ {NAME} subido",
    media_upload_failed: "Error al subir el archivo",
    /* Bug 3 settings extra (auto-translated) */
    settings_export_link_failed: "No se pudo enviar el enlace.",
    settings_password_incorrect: "Contraseña incorrecta.",
    settings_unauthorized: "No autorizado.",
    settings_export_too_many_requests: "Has solicitado demasiados enlaces. Inténtalo más tarde.",
    settings_export_your_email_fallback: "tu email",
    pol_demo_failed_default: "No se pudo enviar el demo",
    /* Bug 3 set2 (auto-translated) */
    settings_portal_open_failed: "No se pudo abrir el portal de gestión. Si crees que es un error, escríbenos a support@keepsoul.app.",
    settings_export_failed: "No se pudo exportar.",
    settings_export_not_authorized: "No autorizado para exportar.",
    settings_export_quota_exhausted: "Has agotado tus descargas de hoy. Inténtalo más tarde.",
    /* Bug 3 auth pages (auto-translated) */
    auth_back_to_login: "Volver al login",
    fp_title: "Recupera tu contraseña",
    fp_subtitle: "Introduce tu email y te enviaremos un enlace para restablecerla.",
    fp_email_label: "Email",
    fp_email_placeholder: "tu@email.com",
    fp_sending: "Enviando…",
    fp_send_cta: "Enviar instrucciones",
    fp_check_email_title: "Revisa tu email",
    fp_check_email_body_prefix: "Si",
    fp_check_email_body_suffix: "está registrada, te hemos enviado un enlace para restablecer tu contraseña. Comprueba también la carpeta de spam.",
    fp_need_help: "¿Necesitas ayuda?",
    rp_missing_token: "Falta el token de recuperación en el enlace.",
    rp_min_12: "La contraseña debe tener al menos 12 caracteres",
    rp_need_lower: "Debe incluir al menos una minúscula",
    rp_need_upper: "Debe incluir al menos una mayúscula",
    rp_need_digit: "Debe incluir al menos un número",
    rp_need_symbol: "Debe incluir al menos un símbolo (!@#$...)",
    rp_mismatch: "Las contraseñas no coinciden",
    rp_success_toast: "Contraseña actualizada correctamente",
    rp_link_expired: "Este enlace ha expirado. Solicita uno nuevo.",
    rp_link_used_or_invalid: "Este enlace ya se ha usado o no es válido.",
    rp_update_failed: "No se pudo actualizar la contraseña.",
    rp_done_title: "¡Listo!",
    rp_done_body: "Contraseña actualizada correctamente. Te redirigimos al login…",
    rp_invalid_link_title: "Enlace no válido",
    rp_request_new_link: "Solicitar nuevo enlace",
    rp_new_password_h1: "Nueva contraseña",
    rp_hint: "Mín. 12 caracteres con mayúsculas, números y un símbolo.",
    rp_confirm_label: "Confirmar contraseña",
    rp_updating: "Actualizando…",
    rp_update_cta: "Actualizar contraseña",
    rp_new_password_label: "Nueva contraseña",
    /* Premium relaunch + plans welcome (Iter 22) */
    plans_welcome_title: "¡Cuenta verificada! Elige tu plan",
    plans_welcome_sub: "Si tienes un código de descuento, aplícalo antes de elegir tu plan.",
    plans_skip_for_now: "Saltar por ahora",
    plans_discount_section_title: "¿Tienes un código de descuento?",
    plans_discount_placeholder: "Introduce tu código aquí",
    plans_discount_apply: "Aplicar",
    plans_discount_success_short: "Código aplicado correctamente",
    plans_discount_invalid_short: "Código no válido",
    plans_personal_monthly_equiv_v2: "Equivale a 5,83€ al mes — 2 meses gratis",
    plans_yearly_save_v2: "Ahorras 14€ al año",
    /* Paywall (Iter 24) */
    paywall_title: "Desbloquea KeepSoul",
    paywall_body: "Elige un plan para empezar a proteger lo que más importa: tus contraseñas, mensajes y legado digital.",
    paywall_cta: "Ver planes",
    paywall_hint: "Premium €39/año · De por Vida €149",
    paywall_locked_badge: "Bloqueado",
    /* Vault auto-lock (Iter 29) */
    vault_lock_setting_title: "Bloqueo automático del Cofre",
    vault_lock_setting_body: "Te pediremos tu contraseña de KeepSoul antes de mostrar tus secretos, y bloquearemos el Cofre tras X minutos de inactividad.",
    vault_lock_enabled: "Activado",
    vault_lock_disabled: "Desactivado",
    vault_lock_minutes_label: "Bloquear tras (min):",
    vault_lock_title: "Cofre bloqueado",
    vault_lock_body: "Por seguridad, el Cofre se ha bloqueado tras {MIN} minutos de inactividad. Introduce tu contraseña para volver a verlo.",
    vault_lock_pwd_placeholder: "Tu contraseña de KeepSoul",
    vault_lock_pwd_required: "Introduce tu contraseña",
    vault_lock_pwd_wrong: "Contraseña incorrecta",
    vault_lock_no_password: "Esta cuenta usa Google y no tiene contraseña local",
    vault_lock_failed: "No se pudo desbloquear. Inténtalo de nuevo",
    vault_lock_cta: "Desbloquear",
    vault_lock_unlocking: "Desbloqueando…",

    /* Digital Assets — list/grid toggle (Iter 28) */
    da_view_grid: "Vista de tarjetas",
    da_view_list: "Vista de lista",
    da_list_empty: "Aún no has añadido activos digitales. Empieza por una cuenta bancaria o red social.",
    da_list_col_name: "Activo",
    da_list_col_category: "Categoría",
    da_list_col_heir: "Heredero asignado",
    da_list_no_heir: "Sin asignar",

    /* Will & Executor (Iter 30) */
    nav_will: "Testamento",
    nav_ice: "En caso de emergencia",
    will_title: "Testamento y Albacea",
    will_subtitle: "Indica dónde se guarda tu testamento legal y quién es el albacea encargado.",
    will_info_banner: "KeepSoul no guarda tu testamento. Esta página solo señala a tu familia dónde encontrarlo y quién debe ejecutarlo.",
    will_exists_q: "¿Existe un testamento?",
    will_exists_yes: "Sí",
    will_exists_no: "No",
    will_exists_unknown: "No lo sé",
    will_location_label: "Ubicación / custodia",
    will_location_ph: "Notaría López, Calle Mayor 12, Madrid · Despacho de abogados Pérez · Caja fuerte en casa…",
    will_location_hint: "Notaría, abogado, ubicación física u otra persona que lo custodie.",
    will_executor_section: "Albacea (Executor)",
    will_executor_section_hint: "La persona legalmente designada para ejecutar tus últimas voluntades.",
    will_executor_name: "Nombre completo",
    will_executor_relationship: "Relación contigo",
    will_executor_relationship_ph: "Hermana, abogado, amigo cercano…",
    will_executor_phone: "Teléfono",
    will_executor_email: "Email",
    will_notes: "Notas adicionales",
    will_notes_ph: "Cualquier información relevante sobre el testamento o el albacea.",
    will_instructions_title: "Instrucciones para el albacea",
    will_instructions_hint: "Texto libre con lo que quieres que tu albacea haga. Aparecerá también en el documento ICE.",
    will_instructions_ph: "Por favor, contacta primero con mi pareja María y luego abre el sobre que está en mi escritorio…",
    saving: "Guardando…",

    /* ICE Document (Iter 30) */
    ice_title: "En Caso de Emergencia",
    ice_subtitle: "Resumen único con todo lo que tu albacea y herederos necesitan saber.",
    ice_print: "Imprimir / Guardar PDF",
    ice_print_short: "Guardar PDF",
    ice_warning: "Este documento contiene datos sensibles. Imprímelo solo cuando sea estrictamente necesario y guárdalo en lugar seguro.",
    ice_empty: "No hay datos suficientes para generar el documento. Empieza por añadir tu testamento, herederos o activos digitales.",
    ice_cover_title: "Propietario",
    ice_owner_name: "Nombre",
    ice_owner_email: "Email",
    ice_generated_at: "Generado el",
    ice_will_title: "Testamento y Albacea",
    ice_will_missing: "El propietario indica que NO existe testamento legal.",
    ice_will_unknown: "El propietario no ha indicado si existe un testamento.",
    ice_no_executor: "Aún no has designado un albacea.",
    ice_add_executor: "Añadir albacea",
    ice_instructions_title: "Instrucciones para el albacea",
    ice_no_instructions: "Aún no has escrito instrucciones para tu albacea.",
    ice_add_instructions: "Escribir instrucciones",
    ice_heirs_title: "Herederos",
    ice_no_heirs: "Aún no has añadido herederos.",
    ice_assets_title: "Activos digitales",
    ice_no_assets: "Aún no has añadido activos digitales.",
    ice_assets_note: "Los datos sensibles (contraseñas, claves) NO aparecen aquí: vive solo dentro del Cofre cifrado de KeepSoul.",
    ice_vault_title: "Contenidos del Cofre",
    ice_no_vault: "El Cofre está vacío.",
    ice_vault_note: "Solo se listan los títulos. Los contenidos cifrados se entregarán a los herederos asignados a través de KeepSoul.",
    ice_cat_bank: "Cuentas bancarias",
    ice_cat_social: "Redes sociales",
    ice_cat_crypto: "Criptomonedas",
    ice_cat_email: "Cuentas de email",
    ice_cat_device: "Dispositivos",
    ice_cat_insurance: "Seguros y pensiones",
    ice_cat_other: "Otros",

    /* Physical documents (Iter 30 follow-up) */
    will_phys_title: "Documentos físicos importantes",
    will_phys_hint: "DNI/Pasaporte, escrituras, pólizas en papel, certificados originales… Indica solo DÓNDE están, no los guardes aquí.",
    will_phys_add: "Añadir documento",
    will_phys_empty: "Aún no has añadido documentos físicos.",
    will_phys_doc_label: "Documento",
    will_phys_doc_ph: "DNI · Escritura del piso · Póliza de vida MAPFRE…",
    will_phys_loc_label: "Dónde está / quién lo custodia",
    will_phys_loc_ph: "Cajón superior del escritorio · Caja fuerte banco BBVA sucursal X · Notaría López…",
    will_phys_notes_label: "Notas",
    will_phys_notes_ph: "Llave en la maceta del balcón, código 1234…",
    ice_phys_title: "Documentos físicos importantes",
    ice_no_phys: "Aún no se han listado documentos físicos.",
    ice_add_phys: "Añadir documentos",
    ice_phys_loc: "Ubicación",
    delete: "Eliminar",

    /* ICE Editor — Phase 2 (Iter 31) */
    yes: "Sí",
    no: "No",
    will_no_will_warning: "Sin un testamento, el nombramiento del albacea puede requerir aprobación legal. Te recomendamos crear un testamento con un profesional (notario o abogado).",
    ice_legal_notice: "Este documento NO es un testamento. Deberías tener un testamento aparte. Este documento solo permite al albacea localizar la información necesaria. El testamento y la ley local tienen siempre la autoridad.",
    ice_mode_edit: "Editar",
    ice_mode_summary: "Resumen",
    /* Personal */
    ice_sec_personal: "Datos personales",
    ice_sec_personal_hint: "Tus datos básicos de identificación.",
    ice_p_full_name: "Nombre completo",
    ice_p_id_number: "DNI / Documento de identidad",
    ice_p_phone_home: "Teléfono casa",
    ice_p_phone_work: "Teléfono trabajo / móvil",
    ice_p_passport: "Pasaporte",
    ice_p_nationality: "Nacionalidad",
    ice_p_residence: "Lugar de residencia",
    ice_p_email: "Email",
    /* Marital */
    ice_sec_marital: "Estado civil y pareja",
    ice_sec_marital_hint: "Datos del cónyuge o pareja actual.",
    ice_m_status: "Estado civil",
    ice_m_status_ph: "Soltero/a, Casado/a, Pareja de hecho, Divorciado/a, Viudo/a…",
    ice_m_spouse_name: "Nombre del cónyuge / pareja",
    ice_m_spouse_id: "DNI del cónyuge / pareja",
    ice_m_spouse_phone: "Teléfono",
    ice_m_spouse_email: "Email",
    /* Divorce */
    ice_sec_divorce: "Divorcio previo (si aplica)",
    ice_sec_divorce_hint: "Referencia a dónde está el acuerdo o sentencia.",
    ice_d_agreement_location: "Ubicación del acuerdo de divorcio",
    ice_d_agreement_ph: "Carpeta legal en el archivador · Despacho del abogado X · Juzgado nº…",
    ice_d_notes: "Notas",
    /* Heir overrides */
    ice_sec_heir_overrides: "Familiares y contactos a notificar",
    ice_sec_heir_overrides_hint: "Reutilizamos tus herederos. Indica si quieres notificarles y qué heredan según el testamento.",
    ice_no_heirs_yet: "Aún no has añadido herederos. Hazlo en la sección Herederos.",
    ice_h_notify: "Notificar",
    ice_h_bequest: "Qué hereda según el testamento (opcional)",
    ice_h_bequest_ph: "Casa familiar, 50% de las cuentas, joyas de mi madre…",
    ice_h_bequest_short: "Hereda",
    ice_h_do_not_notify: "No notificar",
    /* Children */
    ice_sec_children: "Hijos",
    ice_sec_children_hint: "Nombre y datos de contacto de cada hijo/a.",
    ice_c_name: "Nombre",
    ice_c_contact: "Contacto",
    ice_c_contact_ph: "Teléfono / email",
    ice_c_add: "Añadir hijo/a",
    ice_c_empty: "Aún no has añadido hijos.",
    /* Guardians */
    ice_sec_guardians: "Tutores legales de los hijos",
    ice_sec_guardians_hint: "Quién cuidaría de tus hijos menores si tú faltaras.",
    ice_g_name: "Nombre",
    ice_g_contact: "Contacto",
    ice_g_add: "Añadir tutor",
    ice_g_empty: "Aún no has añadido tutores.",
    /* Staff */
    ice_sec_staff: "Personal doméstico (opcional)",
    ice_sec_staff_hint: "Personas que trabajan contigo o en casa.",
    ice_s_name: "Nombre",
    ice_s_contact: "Contacto",
    ice_s_contact_ph: "Teléfono / email · Tipo de trabajo",
    ice_s_add: "Añadir",
    ice_s_empty: "Sin entradas.",
    /* Professional contacts */
    ice_sec_pro_contacts: "Contactos profesionales",
    ice_sec_pro_contacts_hint: "Médico, abogado, asesor financiero / gestor.",
    ice_pro_doctor: "Médico",
    ice_pro_lawyer: "Abogado",
    ice_pro_advisor: "Asesor financiero / gestor",
    ice_pro_name: "Nombre",
    ice_pro_contact: "Teléfono",
    ice_pro_email: "Email",
    /* Medical */
    ice_sec_medical: "Datos médicos",
    ice_sec_medical_hint: "Información que un médico de urgencias puede necesitar.",
    ice_med_insurance: "Mutua / Seguro médico",
    ice_med_member_id: "Nº de afiliación / póliza",
    ice_med_blood_type: "Grupo sanguíneo",
    ice_med_living_will: "¿Existe testamento vital?",
    ice_med_living_will_unknown: "No lo sé",
    /* Banking */
    ice_sec_banks: "Datos financieros — Banca",
    ice_sec_banks_hint: "Solo entidad y referencia. Las credenciales viven solo en el Cofre cifrado.",
    ice_b_entity: "Entidad",
    ice_b_reference: "Referencia",
    ice_b_auto_payments: "Domiciliaciones a cancelar",
    ice_b_auto_payments_ph: "Netflix, Spotify, gimnasio, hipoteca…",
    ice_b_add: "Añadir cuenta",
    ice_b_empty: "Aún no has añadido cuentas bancarias.",
    ice_b_no_creds: "Nunca escribas aquí contraseñas, claves o PINs. Solo entidad y referencia.",
    /* Investments */
    ice_sec_investments: "Datos financieros — Inversiones",
    ice_sec_investments_hint: "Acciones, fondos, bonos, criptomonedas, inmuebles…",
    ice_inv_type: "Tipo",
    ice_inv_type_ph: "Acciones, fondo, cripto, inmueble…",
    ice_inv_platform: "Plataforma / entidad",
    ice_inv_reference: "Referencia",
    ice_inv_add: "Añadir inversión",
    ice_inv_empty: "Aún no has añadido inversiones.",
    /* Valuables */
    ice_sec_valuables: "Activos, joyas y objetos de coleccionista",
    ice_sec_valuables_hint: "Descripción y valor estimado (campo libre).",
    ice_v_description: "Descripción",
    ice_v_description_ph: "Reloj heredado de mi abuelo · Cuadro de Sorolla firmado…",
    ice_v_estimated_value: "Valor estimado",
    ice_v_location: "Ubicación",
    ice_v_add: "Añadir",
    ice_v_empty: "Sin entradas.",
    /* Credentials location */
    ice_sec_credentials: "Ubicación de credenciales y accesos",
    ice_sec_credentials_hint: "DÓNDE guardas tus contraseñas y CÓMO puede acceder el albacea. NUNCA pongas contraseñas aquí.",
    ice_cred_type: "Tipo de gestor de contraseñas",
    ice_cred_type_choose: "Elige…",
    ice_cred_type_pm: "Gestor de contraseñas (1Password, Bitwarden, LastPass…)",
    ice_cred_type_browser: "Gestor del navegador (Chrome, Safari…)",
    ice_cred_type_paper: "Anotadas en papel",
    ice_cred_type_memory: "Solo en mi memoria",
    ice_cred_type_mixed: "Mixto",
    ice_cred_where: "Dónde están",
    ice_cred_where_ph: "1Password con email juan@... — clave maestra en sobre cerrado en notaría · Cuaderno azul en cajón del dormitorio…",
    ice_cred_how_to_access: "Cómo puede acceder el albacea",
    ice_cred_how_to_access_ph: "Mi pareja conoce la clave maestra. El sobre con el código de recuperación está en notaría López…",
    ice_cred_warning: "Importante: KeepSoul NO debe contener tus contraseñas reales aquí. Este campo es solo para describir DÓNDE y CÓMO puede acceder el albacea, no las contraseñas en sí.",
    /* Social */
    ice_sec_social: "Redes sociales",
    ice_sec_social_hint: "Plataforma y nombre de usuario (sin contraseña).",
    ice_soc_platform: "Plataforma",
    ice_soc_username: "Usuario",
    ice_soc_add: "Añadir",
    ice_soc_empty: "Sin entradas.",
    /* Funeral */
    ice_sec_funeral: "Disposiciones funerarias (opcional)",
    ice_sec_funeral_hint: "Tus deseos sobre el funeral.",
    ice_funeral_ph: "Incineración, no quiero flores, música de Coldplay…",
    ice_funeral_priority: "Aviso: si existe un testamento, el testamento tiene prioridad sobre estos deseos.",
    /* Notes */
    ice_sec_notes: "Notas adicionales",
    ice_sec_notes_hint: "Cualquier otra cosa que quieras dejar por escrito.",

    /* Inline validation messages (Iter 32) */
    val_invalid_email: "Email no válido",
    val_invalid_phone: "Teléfono no válido",

    /* Progress indicator (Iter 32) */
    ice_progress_label: "Completado",
    ice_progress_hint: "Cuantas más secciones rellenes, más útil será este documento para tu albacea.",
    ice_progress_done: "Documento completo. Te recomendamos revisarlo cada 6 meses.",

    /* Share with executor (Iter 32) */
    ice_share_btn: "Enviar al albacea",
    ice_share_modal_title: "Enviar al albacea",
    ice_share_modal_intro: "Hemos enviado un email a {email} con un enlace al documento. Para abrirlo necesita el código de 6 dígitos de abajo.",
    ice_share_code_label: "Código de acceso de un solo uso",
    ice_share_code_warning: "⚠️ NO envíes este código por email. Compártelo con tu albacea por teléfono o en persona. Sin él, el enlace es inútil.",
    ice_share_modal_link: "Enlace",
    ice_share_modal_expires: "Expira en",
    ice_share_done: "Hecho",
    ice_share_err_no_executor: "Primero define el email de tu albacea en la página Testamento.",
    ice_share_err_generic: "No se pudo crear el enlace. Inténtalo de nuevo.",
    ice_share_err_code_required: "Introduce el código de 6 dígitos.",
    ice_share_err_invalid_code: "El código no es correcto.",
    ice_share_err_not_found: "Este enlace no existe o ha sido revocado.",
    ice_share_err_expired: "Este enlace ha expirado.",
    ice_share_gate_title: "Documento En Caso de Emergencia",
    ice_share_gate_intro: "El propietario te ha enviado este enlace por email. Para abrir el documento, introduce el código de 6 dígitos que te ha dado por separado (por teléfono o en persona).",
    ice_share_gate_footer: "Si has fallado 5 veces el código, el enlace se bloqueará automáticamente y deberá enviarse uno nuevo.",
    ice_share_open: "Abrir documento",
    ice_share_viewing: "Estás viendo este documento como",
    copy: "Copiar",
    copied: "Copiado",

    /* Executor checklist — static guidance (Iter 32) */
    ice_checklist_title: "Próximos pasos para el albacea",
    ice_checklist_intro: "Una guía orientativa de las gestiones más comunes. Adáptala a la situación real y a las leyes locales.",
    ice_checklist_immediate: "Inmediato (primeras 48 horas)",
    ice_checklist_week: "Primera semana",
    ice_checklist_month: "Primer mes",
    ice_checklist_c_imm_1: "Solicita varios certificados de defunción (mínimo 5 copias) — los necesitarás para casi todos los trámites.",
    ice_checklist_c_imm_2: "Contacta a los familiares listados en este documento y avísales según las preferencias del propietario.",
    ice_checklist_c_imm_3: "Contacta a la funeraria y respeta las disposiciones funerarias indicadas, si existen.",
    ice_checklist_c_imm_4: "Localiza el testamento en la ubicación indicada y entrégalo al notario/abogado.",
    ice_checklist_c_wk_1: "Notifica a la mutua/seguro médico y a la Seguridad Social.",
    ice_checklist_c_wk_2: "Notifica al banco principal — pueden bloquear cuentas hasta que se complete la sucesión.",
    ice_checklist_c_wk_3: "Cancela las domiciliaciones recurrentes listadas (Netflix, gimnasio, etc.).",
    ice_checklist_c_wk_4: "Contacta al abogado del propietario, si está listado, para iniciar la sucesión.",
    ice_checklist_c_mo_1: "Tramita la herencia ante notario con los herederos listados.",
    ice_checklist_c_mo_2: "Cierra o memorializa cuentas de redes sociales según los deseos del propietario.",
    ice_checklist_c_mo_3: "Acceso al Cofre de KeepSoul — sigue las instrucciones de credenciales para recuperar contraseñas.",
    ice_checklist_c_mo_4: "Cancela tarjetas de crédito, suscripciones y servicios que aún estén activos.",
    ice_checklist_footer: "Esta lista NO sustituye el asesoramiento legal. Consulta siempre con un profesional para los pasos legales.",

    /* Active shares panel (Iter 33) */
    ice_shares_panel_title: "Enlaces compartidos",
    ice_shares_empty: "Aún no has enviado el documento a ningún albacea.",
    ice_shares_col_sent: "Enviado",
    ice_shares_col_expires: "Expira",
    ice_shares_col_views: "Visitas",
    ice_shares_col_failed: "Códigos erróneos",
    ice_share_status_active: "Activo",
    ice_share_status_expired: "Expirado",
    ice_share_status_revoked: "Revocado",
    ice_share_status_expired_hint: "Caducado — crea uno nuevo si lo necesitas.",
    ice_share_revoke: "Revocar",
    ice_share_revoke_title: "¿Revocar este enlace?",
    ice_share_revoke_intro: "El albacea ya no podrá abrir el documento con este enlace, ni siquiera con el código correcto. Esta acción es inmediata e irreversible.",
    ice_share_revoke_yes: "Sí, revocar",
    ice_share_revoke_cancel: "Cancelar",
    ice_share_revoked_toast: "Enlace revocado",
    refresh: "Recargar",
},
  en: {
    brand_tagline: "Keep what matters most",
    nav_features: "Features",
    nav_pricing: "Pricing",
    nav_about: "About",
    nav_login: "Sign in",
    cta_start: "Get started",
    cta_secure_legacy: "Secure Your Legacy",
    cta_learn: "Learn more",

    hero_title_1: "Your legacy,",
    hero_title_2: "preserved forever.",
    hero_sub:
      "The world's first platform combining an encrypted vault, future messages, Proof of Life and digital inheritance. So what matters most is never lost.",

    section_problem_label: "The problem",
    section_problem_title: "What is lost, never returns.",
    section_problem_body:
      "Every year, millions of families lose passwords, photos, cryptocurrencies and digital memories forever. No complete solution existed. Until now.",

    stat_crypto: "in lost cryptocurrencies",
    stat_families: "of families lack account access",
    stat_planning: "have no digital plan",

    section_solution_label: "The solution",
    section_solution_title: "One platform. Everything protected.",

    feature_vault: "The Vault",
    feature_vault_d:
      "Passwords, documents, and secrets encrypted with AES-256. Capsule toggle for what only reveals upon death.",
    feature_messages: "Future Messages",
    feature_messages_d:
      "Text, audio and video for specific dates, on passing, or as family history.",
    feature_heirs: "Digital Inheritance",
    feature_heirs_d:
      "Bank accounts, crypto, social media and devices delivered automatically to your heirs.",
    feature_pol: "Proof of Life",
    feature_pol_d:
      "The system that activates everything automatically when you're no longer here.",

    pricing_title: "Plans that fit you",
    plan_free: "Free",
    plan_personal: "Premium",
    plan_lifetime: "Lifetime",
    plan_popular: "Most popular",

    dash_welcome: "Welcome",
    dash_quickactions: "Quick actions",
    dash_pol: "Proof of Life",
    dash_pol_next: "Next check-in",
    dash_pol_checkin: "Confirm I'm alive",
    dash_status_alive: "Active",
    dash_status_pending: "Pending",
    pol_state_active: "Active",
    pol_state_pending: "Pending confirmation",
    pol_state_grace: "Grace period",
    pol_state_overdue: "Overdue",

    /* Plans — updated feature list (Iter 34) */
    pricing_top_tier_owned: "You already have the top plan",
    feat_vault: "Encrypted Vault (AES-256) up to 50 entries",
    feat_vault_unlimited: "Unlimited encrypted Vault (AES-256)",
    feat_messages: "Messages from the Future (text, audio, video, file) up to 20",
    feat_messages_unlimited: "Unlimited Messages from the Future (text, audio, video, file)",
    feat_heirs: "Up to 5 heirs with percentage allocation",
    feat_heirs_unlimited: "Unlimited heirs with percentage allocation",
    feat_contacts: "Trusted contacts",
    feat_assets: "Digital assets (banks, crypto, social, devices) up to 30",
    feat_assets_unlimited: "Unlimited digital assets (banks, crypto, social, devices)",
    feat_pol: "Full Proof of Life",
    feat_pol_full: "Full Proof of Life with alerts",
    feat_will: "Will & Executor",
    feat_ice: "In Case of Emergency (ICE) document with 20 sections",
    feat_ice_full: "Complete In Case of Emergency (ICE) document with 20 sections",
    feat_ice_pdf: "Export ICE to PDF",
    feat_share: "Secure delivery to executor with verification code",
    feat_share_panel: "Shared links panel with revocation",
    feat_export_gdpr: "Full export of your data (GDPR Art. 20)",
    pricing_lifetime_founders_badge: "Founders edition · limited seats",
    plan_free_sub: "Get started — no card required",
    plan_free_billed_never: "No payments · No card",
    plan_free_cta_default: "Current plan",
    plan_free_cta_signup: "Start free",
    plan_free_feat_vault: "Encrypted Vault AES-256 (5 items)",
    plan_free_feat_pol: "Full Proof of Life",
    plan_free_feat_heir: "1 heir",
    plan_free_feat_contact: "1 trusted contact",
    plan_free_feat_assets: "3 digital assets",
    plan_free_feat_storage: "1 GB storage",
    plan_free_feat_messages_blocked: "Messages from the Future",
    plan_free_feat_ice_blocked: "ICE document",
    plan_free_feat_will_blocked: "Will & Executor",
    plans_cancel_anytime: "Cancel anytime",
    pricing_per_month_short: "/mo",
    plans_native_billing_notice: "Manage your plan on keepsoul.app · Tap any plan to open it in your browser.",
    feat_contacts_unlimited: "Unlimited trusted contacts",
    feat_assets_unlimited_v2: "Unlimited digital assets (banks, crypto, social, devices, insurance)",
    feat_pol_configurable: "Full, configurable Proof of Life",
    feat_executor_checklist: "Guided checklist for the executor",
    feat_storage_premium: "Encrypted storage: 10 GB",
    feat_storage_lifetime: "Encrypted storage: 25 GB",
    feat_languages: "4 languages (ES, EN, ZH, KO)",
    feature_will: "Will & Executor",
    feature_will_d:
      "Name your executor, lay out legal instructions and deliver the plan with a verification code.",
    feature_ice: "In Case of Emergency (ICE)",
    feature_ice_d:
      "Full 20-section document with PDF export and a shared-links panel with revocation.",

    nav_dashboard: "Home",
    nav_vault: "Vault",
    nav_messages: "Messages",
    nav_pol: "Proof of Life",
    nav_heirs: "Inheritance",
    nav_assets: "Digital Assets",
    nav_capsule: "Capsule",
    nav_historia: "Story",
    nav_settings: "Settings",
    nav_logout: "Sign out",

    vault_title: "The Vault",
    vault_subtitle: "Your most valuable secrets, encrypted forever.",
    vault_add: "Add to Vault",
    vault_empty: "Your vault is empty. Begin by saving what matters most.",

    cat_password: "Password",
    cat_document: "Document",
    cat_photo: "Photo / Memory",
    cat_crypto: "Crypto",
    cat_asset: "Asset",

    msg_title: "Future Messages",
    msg_subtitle: "Words that travel through time.",
    msg_add: "Create message",
    msg_empty: "No messages yet. The future awaits your words.",
    msg_recipient: "Recipient name",
    msg_recipient_email: "Recipient email",
    msg_subject: "Subject",
    msg_body: "Your message",
    msg_date: "Delivery date",
    msg_type_label: "Message type",
    msg_cat_date_label: "Specific date",
    msg_cat_date_hint: "Birthday, wedding, key date…",
    msg_cat_death_label: "When I pass",
    msg_cat_death_hint: "Will be delivered when Proof of Life confirms your passing.",
    msg_cat_historia_label: "Family history",
    msg_cat_historia_hint: "Memory, anecdote, life moment. Part of the archive your heirs will receive.",
    msg_date_required: "Select a delivery date",
    msg_assign_heirs_label: "Also heirs",

    heir_title: "Digital Inheritance",
    heir_subtitle: "Designate who receives each part of your legacy.",
    heir_add: "Add heir",
    heir_relationship: "Relationship",
    heir_share: "Share %",
    heir_empty: "You haven't named any heirs yet.",
    heir_relationship_ph: "Son, Wife, Brother…",
    heir_emails_label: "Heir emails (add several for safety)",
    heir_email_primary_ph: "primary email",
    heir_email_backup_ph: "backup email",
    heir_email_primary_tag: "primary",
    heir_remove_email: "Remove email",
    heir_add_email: "Add another email",
    heir_emails_help: "The system will send the inheritance to all these emails for maximum safety.",
    heir_phone_label: "SMS phone",
    heir_phone_view_label: "Phone (SMS backup)",
    heir_at_least_one_email: "Add at least one email",
    heir_email_invalid: "Invalid email: {EMAIL}",
    heir_share_range_err: "The percentage must be between 1 and 100.",
    heir_share_overflow_err: "You exceed 100% of the legacy. Available: {REMAINING}%.",
    heir_share_assigned: "Assigned: {N}%",
    heir_share_remaining: "Pending: {N}%",
    heir_share_warning: "You have assigned less than 100%. The remaining {N}% will be left without a recipient. Do you want to review?",
    heir_share_available: "(available: {N}%)",
    heir_notify_label: "Notify the heir by email now",
    heir_notify_help: "Nothing is sent by default. If you enable this, a neutral email will be sent informing this person that you have included them in your digital legacy plan. Content is NOT revealed.",
    heir_status_complete: "Complete",
    heir_status_pending: "Pending",
    heir_emails_count: "Emails",
    heir_tooltip_emails: "Configured emails",
    heir_tooltip_sms: "SMS backup",
    heir_tooltip_farewell: "Farewell message",
    heir_tooltip_assets: "Digital assets",
    heir_tooltip_vault: "Vault items",
    heir_tooltip_messages: "Messages",
    heir_tooltip_capsule: "Capsule",
    heir_farewell_title: "Farewell message",
    heir_farewell_desc: "The first thing they'll receive when you're gone. You can record audio, video, write a text or attach a personal file.",
    heir_farewell_input_label: "Your farewell",
    heir_nothing_assigned: "You haven't assigned anything to them yet. Go to Vault, Messages, Capsule or Digital Assets and select {NAME}.",
    heir_will_receive: "Will automatically receive",
    heir_assigned_assets: "Digital assets",
    heir_assigned_vault: "From the Vault",
    heir_assigned_messages: "Messages",
    heir_assigned_capsule: "Capsule",
    heir_link_digital_assets: "Digital Assets",

    vault_category_label: "Category",
    vault_capsule_badge: "Capsule",
    vault_capsule_tooltip: "Capsule — only revealed after you're gone",

    media_kind_text: "Text",
    media_kind_audio: "Audio",
    media_kind_video: "Video",
    media_kind_file: "File",

    contacts_title: "Trusted contacts",
    contacts_subtitle:
      "These people will confirm your Proof of Life if you stop responding.",
    contacts_add: "Add contact",
    contacts_empty_title: "You don't have trusted contacts yet",
    contacts_empty_body:
      "Without trusted contacts, the system cannot activate your inheritance automatically. Add at least 2 people you trust —close family, intimate friends or your lawyer— who can confirm your status if you stop responding to Proof of Life check-ins.",

    capsule_title: "Nuclear Capsule",
    capsule_subtitle:
      "Content revealed only after you're gone. Your final embrace.",
    capsule_add: "Seal content",

    historia_title: "Story",
    historia_subtitle:
      "Record your voice and your stories. So you are never forgotten.",
    historia_add: "New entry",

    pol_title: "Proof of Life",
    pol_subtitle: "The heart of the system.",
    pol_interval: "Interval (days)",
    pol_save: "Save",
    pol_last: "Last check-in",
    pol_next: "Next check-in",

    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    confirm: "Confirm",
    add: "Add",
    close: "Close",
    edit: "Edit",
    view: "View",
    show: "Show",
    hide: "Hide",
    copy: "Copy",
    copied: "Copied",
    saved: "✓ Saved successfully",
    deleted: "Deleted",
    confirm_delete: "Delete this item? This cannot be undone.",
    name: "Name",
    email: "Email",
    phone: "Phone",
    title: "Title",
    notes: "Notes",
    content: "Content",
    username: "Username",
    url: "URL / Website",
    optional: "Optional",
    created_at: "Created on",

    plan_current: "Your plan",
    plan_change: "Change plan",
    plan_view: "View plans",
    plan_active: "Active plan",
    plan_select: "Select",
    plans_title: "Choose your plan",
    plans_sub: "Switch anytime. What matters most stays safe.",
    plan_saved: "Plan updated",

    login_title: "Enter KeepSoul",
    login_sub: "Your legacy awaits. Sign in with email or Google.",
    login_google: "Continue with Google",
    login_secure: "Protected by bank-grade encryption. AES-256 at rest.",
    login_create: "Create your account",
    login_create_sub: "Start protecting what matters most",
    auth_name: "Name",
    auth_email: "Email",
    auth_password: "Password",
    auth_min8: "Minimum 8 characters",
    auth_password_hint: "Min. 12 chars with uppercase, numbers and symbol",
    auth_signup_btn: "Create account",
    auth_login_btn: "Sign in",
    auth_have_account: "Already have an account? Sign in",
    auth_no_account: "Don't have an account? Create one",
    auth_welcome: "Welcome back",
    auth_created: "Account created!",
    auth_forgot: "Forgot your password?",
    auth_continue_google: "Continue with Google",
    auth_need_help: "Need help?",
    auth_generic_error: "An error occurred. Please try again.",
    consent_terms_required: "You must accept the Terms and Conditions to create an account.",
    consent_privacy_required: "You must accept the Privacy Policy to create an account.",
    consent_terms_label: "I have read and accept the",
    consent_terms_link: "Terms and Conditions",
    consent_privacy_label: "I have read and accept the",
    consent_privacy_link: "Privacy Policy",
    consent_marketing_label: "I agree to receive marketing communications from KeepSoul (optional).",
    cookie_banner_title: "Privacy and cookies",
    cookie_banner_msg: "We use strictly necessary cookies for the app to work. We do not use analytics or advertising cookies by default. You can choose what you accept.",
    cookie_banner_more: "View Cookie Policy",
    cookie_accept_all: "Accept all",
    cookie_reject_all: "Reject all",
    cookie_configure: "Configure",
    cookie_modal_title: "Configure cookies",
    cookie_modal_intro: "Choose what cookies you accept. Strictly necessary cookies cannot be disabled as they are essential for the service to operate.",
    cookie_cat_necessary: "Strictly necessary cookies",
    cookie_cat_necessary_desc: "Essential to log in, remember your language and your cookie consent. Cannot be disabled.",
    cookie_cat_analytics: "Analytics cookies",
    cookie_cat_analytics_desc: "Allow us to measure site usage anonymously to improve it. Currently not used, but may be activated in the future with your consent.",
    cookie_always_on: "Always on",
    cookie_save_prefs: "Save preferences",
    auth_session_lost: "Account created but couldn't sign in automatically. Please sign in manually with your email and password.",

    setup_title: "Your legacy",
    setup_complete: "complete",
    setup_step_vault: "Add your first password to the Vault",
    setup_step_msg: "Schedule your first future message",
    setup_step_heir: "Designate at least one heir",
    setup_step_contact: "Add a trusted contact",
    setup_step_assign: "Assign items to your heirs",
    setup_step_pol: "Configure Proof of Life",

    tour_title: "Welcome to KeepSoul",
    tour_sub: "In 30 seconds we'll explain how your digital legacy works",
    tour_step1_t: "The Vault",
    tour_step1_d: "Everything important, encrypted and protected. Passwords, crypto, documents, photos. Mark any item as Capsule to only reveal it after you're gone.",
    tour_step2_t: "Messages",
    tour_step2_d: "Words that will arrive when you no longer can. Schedule videos, letters, or audios for exact dates, key moments, or as a family story for your loved ones.",
    tour_step3_t: "Inheritance",
    tour_step3_d: "Each person receives exactly what belongs to them. Assign your heirs each piece of your legacy: accounts, passwords, memories. No disputes, no losses.",
    tour_step4_t: "Proof of Life",
    tour_step4_d: "The system that activates everything automatically. Every so often you confirm you're well. If you stop responding, your trusted contacts authorize the delivery of the legacy.",
    tour_cta: "Start setting up",
    tour_skip: "Skip tutorial",
    tour_back: "Back",
    tour_next: "Next",

    install_title: "Install KeepSoul",
    install_sub: "Like an app on your screen",
    install_btn: "Install",
    install_ios_title: "Install KeepSoul on your iPhone",
    install_ios_steps: "Tap Share then \"Add to Home Screen\"",

    save_success: "Saved to your Vault",
    saved_secure: "Encrypted and safe",

    landing_compare_title: "Why KeepSoul wins",
    landing_compare_sub: "The only platform that combines everything.",
    cta_final_title: "Some things cannot be recovered.",
    cta_final_sub: "But they can be preserved. Start today.",

    // Pricing
    pricing_no_card: "No card required to start · No surprise auto-renewals · Cancel anytime",
    pricing_start_free: "Try KeepSoul before deciding",
    pricing_personal_sub: "What most KeepSoul users choose",
    plans_personal_monthly_equiv: "That's €3.25 a month — less than a coffee",
    plans_free_explore_hint: "Designed to explore the platform. When you're ready, upgrade to Personal.",
    pricing_lifetime_label: "Lifetime",
    pricing_lifetime_launch: "🔥 Launch offer",
    pricing_lifetime_sub: "One-time payment — no renewals",
    pricing_lifetime_once: " one-time",
    pricing_lifetime_limited: "Limited to 100 founding seats",
    pricing_per_month: "/mo",
    pricing_per_year: "/yr",
    pricing_billed_annually: "billed annually",
    pricing_billed_monthly: "billed monthly",
    pricing_billed_once: "one-time payment",
    msg_no_body: "This message only contains media content.",
    msg_your_message: "YOUR MESSAGE",
    msg_attachment_label: "ATTACHMENT",
    auth_show_password: "Show password",
    auth_hide_password: "Hide password",
    pol_banner_active: "Active",
    pol_banner_active_sub: "Your legacy is protected. Next check-in: {DATE}.",
    pol_banner_due: "Confirmation needed soon!",
    pol_banner_due_sub: "Confirm you're alive before {DATE} to prevent activation.",
    pol_banner_risk: "⚠ Your legacy may activate",
    pol_banner_risk_sub: "More days have passed than expected. Confirm now.",
    pol_banner_cta: "I'm alive",
    pol_banner_config: "Configure →",
    pol_view_details: "View details →",
    pricing_save_yearly: "Save {AMOUNT} per year",
    pricing_billing_monthly: "Monthly",
    pricing_billing_annual: "Annual",
    pricing_lifetime_savings: "(equivalent to 38 years of the monthly plan)",
    pricing_cta_start_free: "Get started free",
    pricing_cta_start_personal: "Start Premium",
    pricing_cta_claim_lifetime: "Claim Lifetime offer",
    pricing_cta_lifetime_short: "Claim offer",
    pricing_current: "Current plan",
    pricing_lifetime_permanent: "Your plan is permanent",
    pricing_cancel_from_settings: "Cancel from Settings",
    pricing_change_via_support: "Plan change handled by support",
    pricing_sold_out: "Sold out",
    pricing_legal: "All prices include taxes · Cancel anytime from Settings · AES-256 encryption · GDPR",
    pricing_lifetime_slots: "{N} of {TOTAL} seats left",
    plans_popular: "Most popular",
    plans_lifetime_feat_1: "All Personal features, forever",
    plans_lifetime_feat_2: "Never any monthly payment",
    plans_lifetime_feat_3: "KeepSoul Founder status",
    plans_lifetime_feat_4: "Priority access to new features",
    plans_free_feat_1: "3 items in the Vault",
    plans_free_feat_2: "1 future message",
    plans_free_feat_3: "1 heir",
    plans_free_feat_4: "Basic Proof of Life",
    plans_free_feat_5: "100 MB",
    plans_free_feat_6: "2 trusted contacts",
    plans_free_feat_7: "100 MB storage",
    plans_personal_feat_1: "100 items in the Vault",
    plans_personal_feat_2: "20 future messages",
    plans_personal_feat_3: "3 heirs",
    plans_personal_feat_4: "Full digital assets",
    plans_personal_feat_5: "10 GB storage",
    plans_personal_feat_6: "Unlimited contacts",
    plans_personal_feat_7: "5 trusted contacts",
    plans_personal_feat_8: "30 digital assets",
    plans_personal_feat_9: "Full Proof of Life",
    plans_lifetime_full_feat_1: "Everything UNLIMITED — no restrictions",
    plans_lifetime_full_feat_2: "Vault, messages, heirs and assets with no caps",
    plans_lifetime_full_feat_3: "Never any monthly payment",
    plans_lifetime_full_feat_4: "Limited to {N} users",
    plans_lifetime_full_feat_5: "Priority access to new features",
    plans_lifetime_full_feat_6: "KeepSoul Founder status",
    plans_lifetime_sold_out_msg: "Sold out — check back soon",
    plans_lifetime_slots_avail: "🔥 {N} of {TOTAL} seats available",
    plans_lifetime_payment_once: "One-time payment — no renewals ever",
    plans_billing_annual_save: "-17%",
    discount_have_code: "Have a discount code? (optional)",
    discount_applied: "Code applied:",
    discount_full_free: "100% free!",
    discount_apply: "Apply",
    discount_validating: "Validating…",
    discount_will_apply: "The code will be applied to the plan you choose.",

    // Setup / onboarding progress
    setup_progress_title: "Your legacy",
    setup_progress_done: "complete",
    setup_pct_remaining: "{N}% to go",
    setup_done_msg: "Done! Your legacy is fully set up.",

    // === Dashboard / LegacyHealth ===
    dh_title: "Legacy Health",
    dh_status_excellent: "Excellent",
    dh_status_good: "Good",
    dh_status_attention: "Needs attention",
    dh_status_critical: "Critical",
    dh_heir_no_msg: "{N} heir without a farewell message",
    dh_heir_no_msg_plural: "{N} heirs without a farewell message",
    dh_heir_no_msg_sub: "Record or write a few words so they receive something personal.",
    dh_heir_no_msg_cta: "Go to Heirs",
    dh_few_contacts: "Only {N} trusted contact",
    dh_few_contacts_sub: "We recommend 3 people so 2 can confirm if there's any doubt.",
    dh_few_contacts_cta: "Add contact",
    dh_no_assets: "No digital assets registered",
    dh_no_assets_sub: "Banks, social media, crypto: whatever's not here will be lost.",
    dh_no_assets_cta: "Add asset",
    dh_pol_title: "Proof of Life",
    dh_pol_next: "Next check-in:",
    dh_pol_confirm: "Confirm Proof of Life",
    dh_pol_state_alive: "Active",
    dh_pol_state_alert: "Attention required",
    dh_pol_state_pending: "Pending",

    // === Vault ===
    vault_title: "The Vault",
    vault_sub: "Your most valuable secrets, encrypted forever.",
    vault_add: "Add to Vault",
    vault_type_password: "PASSWORD",
    vault_type_capsule: "CAPSULE",
    vault_type_note: "NOTE",
    vault_type_credential: "CREDENTIAL",

    // === Settings / plan card ===
    set_change_plan: "Change plan",
    set_current_plan: "Current plan",
    set_pay_recover_q: "Did you pay and your plan didn't activate?",
    set_pay_recover_link: "Recover payment",
    set_cancel_sub: "Cancel subscription",
    set_storage_label: "Storage",
    set_storage_help: "{PCT}% used · AES-256 encrypted videos & audios",
    set_share_title: "Share KeepSoul",
    set_share_sub: "Invite your family to protect their legacy",
    set_pol_card_title: "Proof of Life",
    set_pol_card_sub: "Configure check-ins and contacts",
    set_assets_card_title: "Digital Assets",
    set_assets_card_sub: "Banks, social media, crypto, devices",
    set_plan_usage_title: "Plan usage",
    set_usage_vault: "Vault items",
    set_usage_messages: "Scheduled messages",
    set_usage_heirs: "Heirs",
    set_usage_contacts: "Trusted contacts",
    set_per_month: "/mo",
    set_per_year: "/yr",
    set_pay_once: "one-time",
    set_no_recent_payments: "No confirmed payments found in your name in the last 7 days",
    set_recover_error: "We couldn't check your payments. Write to support@keepsoul.app",
    set_upgrade_plan: "upgrade your plan",
    da_subtitle: "Accounts, devices, cryptocurrencies and insurance that will be automatically delivered to your heirs. This is the map of what exists — secrets live only in the encrypted Vault.",
    da_cred_placeholder: "In the KeepSoul Vault · 1Password · Browser manager · Paper in a safe…",
    da_cred_hint: "Only describe WHERE they are. Do not type the password here.",
    da_cred_hint_link: "Store it encrypted in the Vault →",
    da_cred_hint_crypto: "NEVER paste the seed phrase or private key here — store them encrypted in the Vault.",
    da_legacy_tag: "Legacy",
    da_legacy_password: "Password (previously stored)",
    da_legacy_pin: "PIN (previously stored)",
    da_legacy_seed: "Seed phrase (previously stored)",
    da_add: "Add",
    da_empty_for: "You haven't added any {LABEL} yet.",
    da_assigned_to: "Assigned to",
    da_heir: "heir",
    da_heirs: "heirs",
    da_no_heirs_assigned: "No heirs assigned",
    da_warn_sensitive: "This information is extremely sensitive. It is encrypted with AES-256 and will only be revealed upon confirmation of death.",
    da_warn_seed: "Never share this with anyone. It will only be decrypted for your assigned heir once Proof of Life is confirmed.",
    da_security_note: "This data is encrypted at rest with AES-256-GCM. It will be revealed automatically to the assigned heir only when Proof of Life confirms your passing.",
    da_assign_heirs: "Assign to heirs",
    da_label_title: "Title / Label",
    da_title_ph: "E.g. {EXAMPLE}",
    da_eg_bank: "BBVA main account",
    da_eg_social: "Personal Instagram",
    da_eg_generic: "Short label",
    da_instruction_ph: "What do you want the heir to do with this…",
    da_edit_asset: "Edit asset",
    da_view_notes: "Notes",
    da_view_instruction: "Instruction",
    da_view_encryption: "AES-256-GCM encryption at rest · Will only be automatically delivered to your heir when Proof of Life confirms your passing.",
    select: "Select",
    vault_field_password: "Password",
    vault_capsule_label: "Capsule",
    vault_capsule_desc: "Only revealed after I pass away. Check this for items your heir will receive only when Proof of Life confirms your passing.",
    hap_default_label: "Heirs who receive this",
    hap_no_heirs_yet: "You haven't added any heirs yet. Go to 'Heirs' to add one first.",
    hap_no_assignment_warning: "With no heir assigned, this item will NOT be delivered automatically.",

    // === Landing — sections ===
    lp_problem: "THE PROBLEM",
    lp_problem_title: "What is lost, never returns.",
    lp_problem_sub: "Every year, millions of families lose passwords, photos, cryptocurrencies and digital memories forever. No complete solution existed. Until now.",
    lp_stat_crypto: "in lost cryptocurrencies",
    lp_stat_passwords: "of passwords forgotten when the owner dies",
    lp_stat_accounts: "accounts left in digital limbo",
    lp_solution: "THE SOLUTION",
    lp_feature_vault: "Encrypted Vault",
    lp_feature_vault_desc: "Passwords, crypto keys and secrets encrypted with AES-256.",
    lp_feature_msg: "Future Messages",
    lp_feature_msg_desc: "Audios, videos and letters delivered on the date you choose.",
    lp_feature_pol: "Automatic Proof of Life",
    lp_feature_pol_desc: "If you stop confirming, the digital inheritance protocol activates.",
    lp_feature_heirs: "Digital Inheritance",
    lp_feature_heirs_desc: "Designate heirs and distribute your legacy securely.",
    lp_feature_ai: "Legacy AI",
    lp_feature_ai_desc: "Chat with your legacy: tell stories, personal assistant.",
    lp_feature_zk: "AES-256-GCM at rest",
    lp_feature_zk_desc: "Your sensitive data is stored encrypted with AES-256-GCM. It is only released to your heirs when the protocol activates.",
    lp_how_title: "The system that activates everything automatically when you're no longer here.",

    // Legacy Health signals
    lh_label: "Legacy health",
    lh_loading: "Analyzing your legacy…",
    lh_all_good: "All set. Nice work!",
    lh_well_protected: "Your legacy is well protected",
    lh_resending: "Sending…",
    lh_grade_excellent: "Excellent",
    lh_grade_good: "Good",
    lh_grade_fair: "Could improve",
    lh_grade_weak: "Weak",
    sig_email_unverified_title: "Confirm your email",
    sig_email_unverified_detail: "Until you confirm your email, your legacy cannot be delivered.",
    sig_email_unverified_cta: "Resend email",
    sig_heirs_no_farewell_title: "{N} heirs without a farewell message",
    sig_heirs_no_farewell_title_1: "{N} heir without a farewell message",
    sig_heirs_no_farewell_detail: "Record or write a few words so they receive something personal.",
    sig_heirs_no_farewell_cta: "Go to Heirs",
    sig_no_heirs_title: "You haven't added any heirs yet",
    sig_no_heirs_detail: "Without heirs, we can't deliver your legacy to anyone.",
    sig_no_heirs_cta: "Add heir",
    sig_no_contacts_title: "No trusted contacts",
    sig_no_contacts_detail: "You need at least 1 contact to validate your Proof of Life.",
    sig_no_contacts_cta: "Set up Proof of Life",
    sig_contacts_low_title: "Only {N} trusted contacts",
    sig_contacts_low_title_1: "Only {N} trusted contact",
    sig_contacts_low_detail: "We recommend 3 people so 2 can confirm if there's any doubt.",
    sig_contacts_low_cta: "Add contact",
    sig_vault_empty_title: "Your Vault is empty",
    sig_vault_empty_detail: "Save at least one password or important document.",
    sig_vault_empty_cta: "Go to Vault",
    sig_no_messages_title: "No scheduled messages",
    sig_no_messages_detail: "Write a message for someone — a birthday, a farewell…",
    sig_no_messages_cta: "Create message",
    sig_no_assets_title: "No digital assets registered",
    sig_no_assets_detail: "Banks, social media, crypto: whatever's not here will be lost.",
    sig_no_assets_cta: "Add asset",
    sig_stale_title: "Your legacy hasn't been updated in {N} days",
    sig_stale_detail: "Check that everything is still up to date: passwords, heirs, messages.",
    sig_stale_cta: "Review",
    sig_pol_overdue_title: "Proof of Life overdue",
    sig_pol_overdue_detail: "Confirm your Proof of Life ASAP to avoid alerting your contacts.",
    sig_pol_overdue_cta: "Confirm now",
    sig_pol_soon_title: "Proof of Life in {N} days",
    sig_pol_soon_detail: "Remember to confirm before the date.",
    sig_pol_soon_cta: "Go to Proof of Life",

    // ExampleHint blocks
    hint_vault_title: "What to keep here",
    hint_vault_1: "For example, save the <strong>seed phrases of your crypto wallets</strong> so your family can recover your Bitcoin.",
    hint_vault_2: "Or the <strong>passwords to your bank accounts and important services</strong> (Gmail, Apple ID, Netflix…) so loved ones can close or transfer what they need.",
    hint_vault_3: "Encrypted at rest with AES-256-GCM. You access your Vault anytime from your account. When the Proof of Life protocol activates, the content you have assigned will be delivered to the heirs you designate.",
    hint_messages_title: "Messages that leave a mark",
    hint_messages_1: "For example, schedule <strong>20 messages for your child</strong>, one for each birthday until they turn 40. An audio of you on their 25th, another on their wedding day, another when their first child is born.",
    hint_messages_2: "Or record a video for your partner remembering your first date, and have it arrive every anniversary.",
    hint_messages_3: "You can also leave a letter to be opened the day your grandchild graduates. Love doesn't expire.",
    hint_heirs_title: "Who will inherit your digital legacy",
    hint_heirs_1: "For example, designate your <strong>eldest child</strong> to receive the vault keys and banking info, and your sister to receive the personal messages.",
    hint_heirs_2: "Each heir receives only what you assign — mix and match however you like.",
    hint_heirs_3: "When your Proof of Life confirms your passing, KeepSoul will send each heir a secure email with their part of the legacy.",
    hint_assets_title: "Assets that must not be lost",
    hint_assets_1: "For example, register your <strong>main bank account</strong> with the IBAN and linked phone number so your partner knows where the money is.",
    hint_assets_2: "Or your <strong>crypto wallets</strong> (Binance, MetaMask, Ledger) with encrypted recovery instructions.",
    hint_assets_3: "Also social-media accounts (to close or memorialize), pension plans, life insurance, tax records…",
      /* Founders Program (auto-translated) */
    plans_bridge_text: "Want to go beyond access? The Founders plan includes actual company ownership.",
    plan_founders_badge: "FOUNDERS EDITION",
    plan_founders_title: "KeepSoul Founder",
    plan_founders_subtitle: "Real ownership · Eternal legacy",
    plan_founders_slots: "{N} of {TOTAL} spots available",
    plan_founders_separator: "EVERYTHING IN THE LIFETIME PLAN, PLUS:",
    plan_founders_feat_1: "Everything UNLIMITED — no restrictions",
    plan_founders_feat_2: "Vault, messages, heirs, and assets without limits",
    plan_founders_feat_3: "No monthly payments ever",
    plan_founders_feat_4: "Priority access to new beta features",
    plan_founders_feat_5: "Permanent Founder #XXX badge on your profile",
    plan_founders_feat_6: "Private founders community with direct team access",
    plan_founders_feat_7: "1 real share in KeepSoul S.L. — 0.01% of share capital",
    plan_founders_feat_8: "Dividend rights starting year 5",
    plan_founders_feat_9: "Participation in sale price if there's an acquisition (drag-along / tag-along)",
    plan_founders_ownership_title: "What does ownership mean?",
    plan_founders_ownership_body: "By acquiring a Founder spot, you're not just buying lifetime access to KeepSoul — you receive a real equity stake in KeepSoul S.L., with legal rights recognized under Spanish Capital Companies Act.\n\n🌍 The market: Digital legacy management is an $89B sector estimated for 2028, with 22% annual growth. Every year, 3.8 million people pass away in Europe leaving unmanaged digital assets.\n\n📈 5-year projection (conservative scenario):\n· 2026: 2,000 users · ARR €168,000 · Dividend pool: €8,400\n· 2027: 8,000 users · ARR €768,000 · Dividend pool: €38,400\n· 2028: 25,000 users · ARR €2,700,000 · Dividend pool: €135,000\n· 2029: 60,000 users · ARR €6,480,000 · Dividend pool: €324,000\n· 2030: 120,000 users · ARR €14,400,000 · Dividend pool: €720,000\nCumulative 5% dividend pool (2026–2030): €1,225,800\n\nIn case of acquisition: €10M valuation → your 0.01% = €1,000 · €30M valuation → €3,000\n\n⚖️ Legal framework summary:\n· Purchase agreement under RDL 1/2010 (Capital Companies Act)\n· 1 share = 0.01% of KeepSoul S.L. share capital\n· Dividends when approved by the board of directors\n· Transfer restriction for the first 5 years (right of first refusal)\n· Drag-along: if 100% is sold, you participate in the price\n· Tag-along: if the majority stake is sold, you can join\n· Lifetime access guaranteed. If there's closure: 24 months of service or €195 refund\n\n⚠️ Projections are indicative and do not constitute a guarantee of return.",
    plan_founders_legal_link: "📄 View full legal terms, projections and prospectus →",
    plan_founders_cta: "Become a Founder →",
    plan_founders_trust: "🔒 Share registered in notarial deed · Only 500 spots",
    founders_page_badge: "FOUNDERS PROGRAM — LIMITED EDITION",
    founders_page_label: "Founders Program",
    founders_page_h1: "Own KeepSoul.",
    founders_page_h1_sub: "500 spots. One time. Forever.",
    founders_page_cta_reserve: "Reserve my spot",
    founders_page_cta_prospect: "Read the full prospectus",
    founders_stat_spots: "Total spots",
    founders_stat_price: "One-time price",
    founders_stat_capital: "Of share capital",
    founders_stat_lifetime: "Lifetime access",
    founders_problem_label: "WHY KEEPSOUL EXISTS",
    founders_problem_title: "Every year, billions of euros disappear.",
    founders_problem_body: "Lost passwords. Inaccessible cryptocurrencies. Forgotten accounts. Messages that never arrived. When someone passes away without an organized digital legacy, their family inherits chaos. KeepSoul is the first digital legacy vault that combines AES-256 encrypted storage with automatic delivery upon death — orchestrated by an active life verification system.",
    founders_market_label: "MARKET SIZE",
    founders_market_title: "A trillion-dollar unsolved sector.",
    founders_projection_label: "2026–2031 PROJECTION",
    founders_projection_title: "The path to profitability.",
    founders_projection_sub: "Conservative scenario. No B2B agreements with insurers or banks.",
    founders_projection_disclaimer: "* Indicative projections. Do not constitute a guarantee of return. Dividends depend on actual profitability and board decision.",
    founders_acquisition_upside: "€10M valuation → your 0.01% = €1,000 · €30M valuation → €3,000 · €100M valuation → €10,000",
    founders_includes_label: "WHAT YOU RECEIVE",
    founders_includes_title: "Your Founder spot.",
    founders_includes_left_title: "Platform access",
    founders_includes_platform_1: "Everything UNLIMITED in KeepSoul — no restrictions ever",
    founders_includes_platform_2: "Vault, messages, heirs, and assets without limits",
    founders_includes_platform_3: "No monthly or annual payments ever",
    founders_includes_platform_4: "Priority access to beta features",
    founders_includes_platform_5: "Permanent 'Founder #XXX' badge on your profile",
    founders_includes_platform_6: "Private founders channel with direct team access",
    founders_includes_right_title: "Company ownership",
    founders_includes_ownership_1: "1 real equity share in KeepSoul S.L.",
    founders_includes_ownership_2: "0.01% of share capital registered in notarial deed",
    founders_includes_ownership_3: "Dividend rights starting year 5",
    founders_includes_ownership_4: "Participation in sale price if there's an acquisition",
    founders_includes_ownership_5: "Tag-along right in sale of majority stake",
    founders_includes_ownership_6: "Access to shareholders' agreement and articles of association",
    founders_legal_label: "LEGAL FRAMEWORK",
    founders_legal_title: "Total transparency.",
    founders_legal_intro: "This offer is structured in accordance with applicable law. It is not crowdfunding, not a token, not a participating loan. It is real corporate ownership.",
    founders_timeline_label: "ROADMAP",
    founders_timeline_title: "The next five years.",
    founders_faq_label: "FREQUENTLY ASKED QUESTIONS",
    founders_faq_title: "Everything you need to know.",
    founders_cta_title: "Your spot awaits.",
    founders_cta_subtext: "One-time payment · No renewals · Real ownership",
    founders_cta_trust: "🔒 Contract digitally signed within 72h · Notarial share · Only 500 spots",
    founders_of: "of",
    founders_spots_available: "spots available",
    founders_footer_disclaimer: "This page does not constitute a public offering of securities and is not subject to CNMV supervision. Equity shares in non-listed limited companies are not securities tradable on regulated markets.",
    /* Landing additions (auto-translated) */
    nav_founders: "Founders",
    nav_security: "Security",
    nav_signup_cta: "Start free",
    nav_back_home: "Home",
    nav_dashboard_short: "Go to dashboard",
    landing_trust_aes: "🔒 AES-256 encryption",
    landing_trust_gdpr: "🇪🇺 GDPR compliant",
    landing_trust_zk: "🛡️ Zero knowledge",
    landing_trust_founders: "⭐ 100 founders",
    landing_how_label: "HOW IT WORKS",
    landing_how_title: "Three steps. One legacy.",
    landing_how_1_title: "Store",
    landing_how_1_body: "Add passwords, documents, messages and digital assets to your encrypted vault.",
    landing_how_2_title: "Designate",
    landing_how_2_body: "Name your heirs and decide what each one receives, and when.",
    landing_how_3_title: "Automatic delivery",
    landing_how_3_body: "KeepSoul periodically verifies you're well. If you don't respond, it delivers your legacy automatically.",
    landing_security_label: "SECURITY",
    landing_security_title: "Your legacy, only in your hands.",
    landing_security_aes_title: "AES-256-GCM",
    landing_security_aes_body: "The same standard used by banks and governments to protect critical information.",
    landing_security_gdpr_title: "GDPR · LOPDGDD",
    landing_security_gdpr_body: "Full compliance with European and Spanish data protection regulations.",
    landing_security_zk_title: "Zero-Knowledge",
    landing_security_zk_body: "Data is encrypted before leaving our servers. Not even we can see it.",
    landing_proof_label: "WHY KEEPSOUL",
    landing_proof_title: "Built for what matters.",
    landing_proof_stat1_value: "€14,000M",
    landing_proof_stat1_label: "in cryptocurrencies lost due to death without planning",
    landing_proof_stat2_value: "68%",
    landing_proof_stat2_label: "of European adults without a digital legacy plan",
    landing_proof_stat3_value: "3 min",
    landing_proof_stat3_label: "average time to protect your first assets",
    landing_final_subtle: "Already 500+ founders · AES-256 encryption · GDPR",
    landing_footer_tagline: "Protect what matters.",
    landing_footer_col_product: "Product",
    landing_footer_col_legal: "Legal",
    landing_footer_col_support: "Support",
    landing_footer_about: "© 2026 KeepSoul · Murcia, Spain",
    upgrade_modal_title: "You've reached your plan's limit",
    upgrade_modal_body: "The free plan includes {LIMIT} {ITEM}. Upgrade to Premium to continue without limits.",
    upgrade_modal_cta: "View plans →",
    upgrade_modal_dismiss: "Not now",
    payment_success_banner: "🎉 Payment completed! Your {PLAN} plan is now active.",
    payment_success_founder: "🏛️ Welcome, Founder #{N}! Your participation in KeepSoul is confirmed. You'll receive your contract within 72h.",
    payment_cancelled_banner: "Payment cancelled. Your plan has not changed.",
    payment_dismiss: "Close",
    /* Founders funds-allocation + table headers (auto-translated) */
    founders_proj_col_year: "Year",
    founders_proj_col_users: "Active users",
    founders_proj_col_arpu: "Monthly ARPU",
    founders_proj_col_arr: "Estimated ARR",
    founders_proj_col_div: "Dividend pool 5%",
    founders_proj_total: "TOTAL",
    founders_proj_cumulative: "cumulative",
    founders_arpu_note: "= ARPU (Average Revenue Per User): average monthly revenue per paying user. Combines monthly and annual subscribers. Not all active users pay: some use the free plan.",
    founders_funds_label: "USE OF FUNDS",
    founders_funds_title: "Every euro, working for growth.",
    founders_funds_intro: "100% of the capital raised through the Founders Programme is reinvested directly into growing KeepSoul. This isn't spending — it's fuel to turn a solid product into an industry benchmark.",
    founders_funds_marketing_title: "Marketing and acquisition",
    founders_funds_marketing_body: "Acquisition campaigns, SEO positioning, content and presence in key markets across Spain and LATAM to build brand awareness.",
    founders_funds_product_title: "Product and technology",
    founders_funds_product_body: "New features, security enhancements, infrastructure scaling and continuous platform development.",
    founders_funds_alliances_title: "Partnerships and expansion",
    founders_funds_alliances_body: "Agreements with notaries, legal advisers, insurers and banks. Opening to new countries and languages.",
    founders_funds_legal_title: "Legal and operational structure",
    founders_funds_legal_body: "Setting up KeepSoul S.L., regulatory compliance, support and day-to-day operations.",
    founders_funds_closing: "Your investment doesn't sit idle. It works to take KeepSoul to the top — and you along with it.",
    /* Landing: remove-zk replacements (auto-translated) */
    landing_trust_encrypted: "🔐 Encrypted at rest",
    landing_final_subtle_no_founders: "AES-256 encryption · GDPR · Made in Murcia, Spain",
    landing_security_atrest_title: "Encrypted at rest",
    landing_security_atrest_body: "Your sensitive data is encrypted on our servers with AES-256-GCM before being stored. If someone accessed the database, they would see nothing but noise.",
    /* Bug 3 batch (auto-translated) */
    confirm_email_missing_token: "Confirmation token is missing.",
    confirm_email_error_default: "Could not confirm email.",
    confirm_email_loading_title: "Confirming your email…",
    confirm_email_loading_body: "One moment, please.",
    confirm_email_success_title: "Email confirmed!",
    confirm_email_success_body: "Your digital legacy is now active. Log in and set up your Proof of Life to start protecting what matters most.",
    confirm_email_go_dashboard: "Go to my dashboard",
    confirm_email_go_login: "Log in",
    confirm_email_error_title: "Could not confirm",
    confirm_email_error_help: "The link may have expired or has already been used. Log in and request a new confirmation email from your dashboard.",
    login_email_confirmed_banner: "Your email has been confirmed successfully. Log in to access your dashboard.",
    login_tab_email: "Email",
    login_any_email_hint: "Works with any email (Gmail, Outlook, ProtonMail, etc.)",
    settings_share_copied: "Message copied to clipboard ✨",
    settings_share_failed: "Could not share",
    settings_downgrade_confirm: "Cancel your subscription and return to the Free plan? You'll keep your account and data.",
    settings_downgrade_done: "Subscription canceled. Free plan active.",
    settings_generic_error: "Error",
    settings_delete_done: "Account deleted. We've sent you a confirmation email.",
    settings_delete_failed: "Error deleting account",
    settings_export_google_warn: "Your account uses Google. Create a password in Settings before exporting.",
    settings_export_started: "Download started. Save it in a secure place.",
    pol_confirmed_toast: "Proof of Life confirmed ✓",
    discount_applied_full: "Plan activated at 100%!",
    evb_already_verified: "Your email is already confirmed. Reload the page.",
    /* EmailVerifyBanner */
    evb_title: "Confirm your email to activate your legacy",
    evb_body_prefix: "We sent a link to",
    evb_body_suffix: "Until you confirm it, the Proof of Life and legacy delivery are disabled.",
    evb_sending: "Sending…",
    evb_resend_cta: "Resend email",
    evb_resent_to: "Confirmation email sent to {email}",
    evb_resend_failed: "Could not send email",
    /* Bug 3 extra (auto-translated) */
    pol_demo_email_sent: "Demo email sent to {EMAIL}. Check your inbox in a few minutes.",
    historia_no_audio_first: "Record or upload audio first",
    historia_transcribe_done: "Transcription complete ✓",
    historia_transcribe_failed: "Could not transcribe",
    settings_export_link_sent: "Link sent to {EMAIL}. You have 60 min to download it.",
    media_video_too_long: "Video too long. Maximum 60 min.",
    media_video_low_res: "Low resolution video ({W}×{H}). It will upload anyway, but we recommend at least 720p for your memories.",
    media_audio_limit_30min: "30 min limit reached.",
    media_mic_denied: "Microphone permission denied. Enable it in your browser Settings.",
    media_mic_failed: "Could not start recording. Check your microphone.",
    media_file_too_large: "This file is too large. Maximum {MB}MB.",
    media_file_added: "File added",
    media_file_uploaded: "✓ {NAME} uploaded",
    media_upload_failed: "Failed to upload file",
    /* Bug 3 settings extra (auto-translated) */
    settings_export_link_failed: "Failed to send link.",
    settings_password_incorrect: "Incorrect password.",
    settings_unauthorized: "Unauthorized.",
    settings_export_too_many_requests: "You've requested too many links. Please try again later.",
    settings_export_your_email_fallback: "your email",
    pol_demo_failed_default: "Failed to send demo",
    /* Bug 3 set2 (auto-translated) */
    settings_portal_open_failed: "Could not open the management portal. If you believe this is an error, please write to us at support@keepsoul.app.",
    settings_export_failed: "Export failed.",
    settings_export_not_authorized: "Not authorized to export.",
    settings_export_quota_exhausted: "You have exhausted your downloads for today. Please try again later.",
    /* Bug 3 auth pages (auto-translated) */
    auth_back_to_login: "Back to login",
    fp_title: "Recover your password",
    fp_subtitle: "Enter your email and we'll send you a link to reset it.",
    fp_email_label: "Email",
    fp_email_placeholder: "you@email.com",
    fp_sending: "Sending…",
    fp_send_cta: "Send instructions",
    fp_check_email_title: "Check your email",
    fp_check_email_body_prefix: "If",
    fp_check_email_body_suffix: "is registered, we've sent you a link to reset your password. Please also check your spam folder.",
    fp_need_help: "Need help?",
    rp_missing_token: "Recovery token is missing from the link.",
    rp_min_12: "Password must be at least 12 characters",
    rp_need_lower: "Must include at least one lowercase letter",
    rp_need_upper: "Must include at least one uppercase letter",
    rp_need_digit: "Must include at least one number",
    rp_need_symbol: "Must include at least one symbol (!@#$...)",
    rp_mismatch: "Passwords don't match",
    rp_success_toast: "Password updated successfully",
    rp_link_expired: "This link has expired. Request a new one.",
    rp_link_used_or_invalid: "This link has already been used or is not valid.",
    rp_update_failed: "Could not update password.",
    rp_done_title: "All set!",
    rp_done_body: "Password updated successfully. Redirecting you to login…",
    rp_invalid_link_title: "Invalid link",
    rp_request_new_link: "Request new link",
    rp_new_password_h1: "New password",
    rp_hint: "Min. 12 characters with uppercase, numbers and a symbol.",
    rp_confirm_label: "Confirm password",
    rp_updating: "Updating…",
    rp_update_cta: "Update password",
    rp_new_password_label: "New password",
    /* Premium relaunch + plans welcome (Iter 22) */
    plans_welcome_title: "Account verified! Choose your plan",
    plans_welcome_sub: "Got a discount code? Apply it before choosing your plan.",
    plans_skip_for_now: "Skip for now",
    plans_discount_section_title: "Have a discount code?",
    plans_discount_placeholder: "Enter code here",
    plans_discount_apply: "Apply",
    plans_discount_success_short: "Code applied successfully!",
    plans_discount_invalid_short: "Invalid code",
    plans_personal_monthly_equiv_v2: "That's €5.83 a month — 2 months free",
    plans_yearly_save_v2: "Save €14 per year",
    /* Paywall (Iter 24) */
    paywall_title: "Unlock KeepSoul",
    paywall_body: "Choose a plan to start protecting what matters most: your passwords, messages and digital legacy.",
    paywall_cta: "View Plans",
    paywall_hint: "Premium €39/yr · Lifetime €149",
    paywall_locked_badge: "Locked",
    /* Vault auto-lock (Iter 29) */
    vault_lock_setting_title: "Vault auto-lock",
    vault_lock_setting_body: "We'll re-prompt your KeepSoul password before revealing items, and lock the Vault again after X minutes of inactivity.",
    vault_lock_enabled: "Enabled",
    vault_lock_disabled: "Disabled",
    vault_lock_minutes_label: "Lock after (min):",
    vault_lock_title: "Vault locked",
    vault_lock_body: "For safety, the Vault locked after {MIN} minutes of inactivity. Enter your password to view it again.",
    vault_lock_pwd_placeholder: "Your KeepSoul password",
    vault_lock_pwd_required: "Enter your password",
    vault_lock_pwd_wrong: "Wrong password",
    vault_lock_no_password: "This account uses Google sign-in and has no local password",
    vault_lock_failed: "Could not unlock. Try again",
    vault_lock_cta: "Unlock",
    vault_lock_unlocking: "Unlocking…",

    /* Digital Assets — list/grid toggle (Iter 28) */
    da_view_grid: "Card view",
    da_view_list: "List view",
    da_list_empty: "You haven't added any digital assets yet. Start with a bank account or social media.",
    da_list_col_name: "Asset",
    da_list_col_category: "Category",
    da_list_col_heir: "Assigned heir",
    da_list_no_heir: "Not assigned",

    /* Will & Executor (Iter 30) */
    nav_will: "Will",
    nav_ice: "In Case of Emergency",
    will_title: "Will & Executor",
    will_subtitle: "Tell your family where the legal will is kept and who is in charge of executing it.",
    will_info_banner: "KeepSoul does NOT store your will. This page only points your family to where it is and who must execute it.",
    will_exists_q: "Is there a will?",
    will_exists_yes: "Yes",
    will_exists_no: "No",
    will_exists_unknown: "I don't know",
    will_location_label: "Location / custodian",
    will_location_ph: "López Notary, Mayor St. 12, Madrid · Pérez Law Office · Safe at home…",
    will_location_hint: "Notary, lawyer, physical location or person who holds the document.",
    will_executor_section: "Executor",
    will_executor_section_hint: "The person legally designated to carry out your last wishes.",
    will_executor_name: "Full name",
    will_executor_relationship: "Relationship",
    will_executor_relationship_ph: "Sister, lawyer, close friend…",
    will_executor_phone: "Phone",
    will_executor_email: "Email",
    will_notes: "Additional notes",
    will_notes_ph: "Any relevant information about the will or the executor.",
    will_instructions_title: "Instructions for the executor",
    will_instructions_hint: "Free-form text with what you want your executor to do. It will also show up inside the ICE document.",
    will_instructions_ph: "Please contact my partner María first, then open the envelope on my desk…",
    saving: "Saving…",

    /* ICE Document (Iter 30) */
    ice_title: "In Case of Emergency",
    ice_subtitle: "A single summary with everything your executor and heirs need to know.",
    ice_print: "Print / Save as PDF",
    ice_print_short: "Save PDF",
    ice_warning: "This document contains sensitive data. Print it only when strictly needed and keep it in a safe place.",
    ice_empty: "Not enough data yet. Start by adding your will, heirs or digital assets.",
    ice_cover_title: "Owner",
    ice_owner_name: "Name",
    ice_owner_email: "Email",
    ice_generated_at: "Generated on",
    ice_will_title: "Will & Executor",
    ice_will_missing: "The owner has indicated that NO legal will exists.",
    ice_will_unknown: "The owner has not indicated whether a will exists.",
    ice_no_executor: "No executor has been designated yet.",
    ice_add_executor: "Add executor",
    ice_instructions_title: "Instructions for the executor",
    ice_no_instructions: "You haven't written any instructions for your executor yet.",
    ice_add_instructions: "Write instructions",
    ice_heirs_title: "Heirs",
    ice_no_heirs: "No heirs have been added yet.",
    ice_assets_title: "Digital assets",
    ice_no_assets: "No digital assets have been added yet.",
    ice_assets_note: "Sensitive data (passwords, keys) does NOT appear here: it lives only inside KeepSoul's encrypted Vault.",
    ice_vault_title: "Vault contents",
    ice_no_vault: "The Vault is empty.",
    ice_vault_note: "Only titles are listed. Encrypted contents are delivered to assigned heirs through KeepSoul.",
    ice_cat_bank: "Bank accounts",
    ice_cat_social: "Social media",
    ice_cat_crypto: "Cryptocurrencies",
    ice_cat_email: "Email accounts",
    ice_cat_device: "Devices",
    ice_cat_insurance: "Insurance and pensions",
    ice_cat_other: "Other",

    /* Physical documents (Iter 30 follow-up) */
    will_phys_title: "Important physical documents",
    will_phys_hint: "ID/passport, deeds, paper insurance policies, original certificates… Only point to WHERE they are — never store them here.",
    will_phys_add: "Add document",
    will_phys_empty: "No physical documents listed yet.",
    will_phys_doc_label: "Document",
    will_phys_doc_ph: "Passport · Property deed · MAPFRE life insurance policy…",
    will_phys_loc_label: "Where it is / who keeps it",
    will_phys_loc_ph: "Top desk drawer · BBVA branch safe deposit box · López notary…",
    will_phys_notes_label: "Notes",
    will_phys_notes_ph: "Spare key is in the balcony plant pot, code 1234…",
    ice_phys_title: "Important physical documents",
    ice_no_phys: "No physical documents listed yet.",
    ice_add_phys: "Add documents",
    ice_phys_loc: "Location",
    delete: "Delete",

    /* ICE Editor — Phase 2 (Iter 31) */
    yes: "Yes",
    no: "No",
    will_no_will_warning: "Without a will, designating an executor may require legal approval. We recommend creating a will with a professional (notary or lawyer).",
    ice_legal_notice: "This document is NOT a will. You should have a separate will. This document only helps the executor locate the necessary information. The will and local law always have authority.",
    ice_mode_edit: "Edit",
    ice_mode_summary: "Summary",
    /* Personal */
    ice_sec_personal: "Personal data",
    ice_sec_personal_hint: "Your basic identification details.",
    ice_p_full_name: "Full name",
    ice_p_id_number: "ID / National document",
    ice_p_phone_home: "Home phone",
    ice_p_phone_work: "Work / mobile phone",
    ice_p_passport: "Passport",
    ice_p_nationality: "Nationality",
    ice_p_residence: "Place of residence",
    ice_p_email: "Email",
    /* Marital */
    ice_sec_marital: "Marital status and partner",
    ice_sec_marital_hint: "Details about your spouse or current partner.",
    ice_m_status: "Marital status",
    ice_m_status_ph: "Single, Married, Domestic partnership, Divorced, Widowed…",
    ice_m_spouse_name: "Spouse / partner name",
    ice_m_spouse_id: "Spouse / partner ID",
    ice_m_spouse_phone: "Phone",
    ice_m_spouse_email: "Email",
    /* Divorce */
    ice_sec_divorce: "Previous divorce (if applicable)",
    ice_sec_divorce_hint: "Reference to where the agreement or court decision is kept.",
    ice_d_agreement_location: "Divorce agreement location",
    ice_d_agreement_ph: "Legal folder in the file cabinet · Lawyer X office · Court no…",
    ice_d_notes: "Notes",
    /* Heir overrides */
    ice_sec_heir_overrides: "Family and contacts to notify",
    ice_sec_heir_overrides_hint: "We reuse your heirs. Indicate whether to notify them and what they inherit per the will.",
    ice_no_heirs_yet: "You haven't added heirs yet. Add them in the Heirs section.",
    ice_h_notify: "Notify",
    ice_h_bequest: "What they inherit per the will (optional)",
    ice_h_bequest_ph: "The family home, 50% of accounts, my mother's jewelry…",
    ice_h_bequest_short: "Inherits",
    ice_h_do_not_notify: "Do not notify",
    /* Children */
    ice_sec_children: "Children",
    ice_sec_children_hint: "Name and contact details for each child.",
    ice_c_name: "Name",
    ice_c_contact: "Contact",
    ice_c_contact_ph: "Phone / email",
    ice_c_add: "Add child",
    ice_c_empty: "No children added yet.",
    /* Guardians */
    ice_sec_guardians: "Children's legal guardians",
    ice_sec_guardians_hint: "Who would take care of your minor children if you were gone.",
    ice_g_name: "Name",
    ice_g_contact: "Contact",
    ice_g_add: "Add guardian",
    ice_g_empty: "No guardians added yet.",
    /* Staff */
    ice_sec_staff: "Domestic staff (optional)",
    ice_sec_staff_hint: "People who work with you or in your home.",
    ice_s_name: "Name",
    ice_s_contact: "Contact",
    ice_s_contact_ph: "Phone / email · Type of work",
    ice_s_add: "Add",
    ice_s_empty: "No entries.",
    /* Professional contacts */
    ice_sec_pro_contacts: "Professional contacts",
    ice_sec_pro_contacts_hint: "Doctor, lawyer, financial advisor / accountant.",
    ice_pro_doctor: "Doctor",
    ice_pro_lawyer: "Lawyer",
    ice_pro_advisor: "Financial advisor / accountant",
    ice_pro_name: "Name",
    ice_pro_contact: "Phone",
    ice_pro_email: "Email",
    /* Medical */
    ice_sec_medical: "Medical data",
    ice_sec_medical_hint: "Information an emergency doctor may need.",
    ice_med_insurance: "Health insurance",
    ice_med_member_id: "Member / policy ID",
    ice_med_blood_type: "Blood type",
    ice_med_living_will: "Is there a living will?",
    ice_med_living_will_unknown: "I don't know",
    /* Banking */
    ice_sec_banks: "Financial data — Banking",
    ice_sec_banks_hint: "Only entity and reference. Credentials live only inside the encrypted Vault.",
    ice_b_entity: "Entity",
    ice_b_reference: "Reference",
    ice_b_auto_payments: "Auto-payments to cancel",
    ice_b_auto_payments_ph: "Netflix, Spotify, gym, mortgage…",
    ice_b_add: "Add account",
    ice_b_empty: "No bank accounts added yet.",
    ice_b_no_creds: "Never write passwords, keys or PINs here. Only entity and reference.",
    /* Investments */
    ice_sec_investments: "Financial data — Investments",
    ice_sec_investments_hint: "Stocks, funds, bonds, cryptocurrencies, real estate…",
    ice_inv_type: "Type",
    ice_inv_type_ph: "Stocks, fund, crypto, real estate…",
    ice_inv_platform: "Platform / entity",
    ice_inv_reference: "Reference",
    ice_inv_add: "Add investment",
    ice_inv_empty: "No investments added yet.",
    /* Valuables */
    ice_sec_valuables: "Assets, jewelry and collectibles",
    ice_sec_valuables_hint: "Description and estimated value (free text).",
    ice_v_description: "Description",
    ice_v_description_ph: "Watch inherited from my grandfather · Signed Sorolla painting…",
    ice_v_estimated_value: "Estimated value",
    ice_v_location: "Location",
    ice_v_add: "Add",
    ice_v_empty: "No entries.",
    /* Credentials location */
    ice_sec_credentials: "Credentials and access location",
    ice_sec_credentials_hint: "WHERE you keep your passwords and HOW the executor can access them. NEVER put passwords here.",
    ice_cred_type: "Type of password manager",
    ice_cred_type_choose: "Choose…",
    ice_cred_type_pm: "Password manager (1Password, Bitwarden, LastPass…)",
    ice_cred_type_browser: "Browser manager (Chrome, Safari…)",
    ice_cred_type_paper: "Written on paper",
    ice_cred_type_memory: "In my memory only",
    ice_cred_type_mixed: "Mixed",
    ice_cred_where: "Where they are",
    ice_cred_where_ph: "1Password with email john@... — master key in a sealed envelope at the notary · Blue notebook in bedroom drawer…",
    ice_cred_how_to_access: "How the executor can access them",
    ice_cred_how_to_access_ph: "My partner knows the master key. The envelope with the recovery code is at López notary…",
    ice_cred_warning: "Important: KeepSoul should NOT contain your real passwords here. This field is only to describe WHERE and HOW the executor can access them, not the passwords themselves.",
    /* Social */
    ice_sec_social: "Social media",
    ice_sec_social_hint: "Platform and username (no password).",
    ice_soc_platform: "Platform",
    ice_soc_username: "Username",
    ice_soc_add: "Add",
    ice_soc_empty: "No entries.",
    /* Funeral */
    ice_sec_funeral: "Funeral wishes (optional)",
    ice_sec_funeral_hint: "Your wishes about the funeral.",
    ice_funeral_ph: "Cremation, no flowers, Coldplay music…",
    ice_funeral_priority: "Note: if there is a will, the will takes priority over these wishes.",
    /* Notes */
    ice_sec_notes: "Additional notes",
    ice_sec_notes_hint: "Anything else you want to leave in writing.",

    /* Inline validation messages (Iter 32) */
    val_invalid_email: "Invalid email",
    val_invalid_phone: "Invalid phone",

    /* Progress indicator (Iter 32) */
    ice_progress_label: "Completion",
    ice_progress_hint: "The more sections you fill, the more useful this document will be for your executor.",
    ice_progress_done: "Document complete. We recommend reviewing it every 6 months.",

    /* Share with executor (Iter 32) */
    ice_share_btn: "Send to executor",
    ice_share_modal_title: "Send to executor",
    ice_share_modal_intro: "We have emailed {email} with a link to the document. To open it they need the 6-digit code below.",
    ice_share_code_label: "One-time access code",
    ice_share_code_warning: "⚠️ Do NOT email this code. Share it with your executor by phone or in person. Without it the link is useless.",
    ice_share_modal_link: "Link",
    ice_share_modal_expires: "Expires in",
    ice_share_done: "Done",
    ice_share_err_no_executor: "First add an executor email on the Will page.",
    ice_share_err_generic: "Could not create the link. Try again.",
    ice_share_err_code_required: "Enter the 6-digit code.",
    ice_share_err_invalid_code: "The code is incorrect.",
    ice_share_err_not_found: "This link does not exist or has been revoked.",
    ice_share_err_expired: "This link has expired.",
    ice_share_gate_title: "In Case of Emergency document",
    ice_share_gate_intro: "The owner has sent you this link by email. To open the document, enter the 6-digit code they gave you separately (by phone or in person).",
    ice_share_gate_footer: "If you fail the code 5 times, the link will be revoked automatically and a new one will need to be sent.",
    ice_share_open: "Open document",
    ice_share_viewing: "You are viewing this document as",
    copy: "Copy",
    copied: "Copied",

    /* Executor checklist (Iter 32) */
    ice_checklist_title: "Next steps for the executor",
    ice_checklist_intro: "An orientation guide for the most common tasks. Adapt it to the actual situation and local laws.",
    ice_checklist_immediate: "Immediate (first 48 hours)",
    ice_checklist_week: "First week",
    ice_checklist_month: "First month",
    ice_checklist_c_imm_1: "Request several death certificates (at least 5 copies) — you will need them for almost every step.",
    ice_checklist_c_imm_2: "Contact the family members listed in this document and notify them according to the owner's preferences.",
    ice_checklist_c_imm_3: "Contact the funeral home and respect the funeral wishes indicated, if any.",
    ice_checklist_c_imm_4: "Locate the will at the listed location and deliver it to the notary/lawyer.",
    ice_checklist_c_wk_1: "Notify the health insurance and Social Security.",
    ice_checklist_c_wk_2: "Notify the primary bank — they may freeze accounts until the estate is settled.",
    ice_checklist_c_wk_3: "Cancel recurring auto-payments listed (Netflix, gym, etc.).",
    ice_checklist_c_wk_4: "Contact the owner's lawyer, if listed, to start probate.",
    ice_checklist_c_mo_1: "Process the inheritance with a notary and the listed heirs.",
    ice_checklist_c_mo_2: "Close or memorialize social media accounts according to the owner's wishes.",
    ice_checklist_c_mo_3: "Access the KeepSoul Vault — follow the credentials instructions to recover passwords.",
    ice_checklist_c_mo_4: "Cancel credit cards, subscriptions and services still active.",
    ice_checklist_footer: "This list is NOT legal advice. Always consult a professional for legal steps.",

    /* Active shares panel (Iter 33) */
    ice_shares_panel_title: "Shared links",
    ice_shares_empty: "You haven't sent the document to any executor yet.",
    ice_shares_col_sent: "Sent",
    ice_shares_col_expires: "Expires",
    ice_shares_col_views: "Views",
    ice_shares_col_failed: "Failed codes",
    ice_share_status_active: "Active",
    ice_share_status_expired: "Expired",
    ice_share_status_revoked: "Revoked",
    ice_share_status_expired_hint: "Expired — create a new one if needed.",
    ice_share_revoke: "Revoke",
    ice_share_revoke_title: "Revoke this link?",
    ice_share_revoke_intro: "The executor will no longer be able to open the document with this link, even with the correct code. This is immediate and irreversible.",
    ice_share_revoke_yes: "Yes, revoke",
    ice_share_revoke_cancel: "Cancel",
    ice_share_revoked_toast: "Link revoked",
    refresh: "Refresh",
},
  zh: {
    brand_tagline: "守护最珍贵的回忆",
    nav_features: "功能",
    nav_pricing: "套餐",
    nav_about: "关于",
    nav_login: "登录",
    cta_start: "开始",
    cta_secure_legacy: "守护您的遗产",
    cta_learn: "了解更多",
    hero_title_1: "您的遗产,",
    hero_title_2: "永远留存。",
    hero_sub: "全球首个集加密保险库、未来信息、生存验证与数字继承于一体的平台。让最重要的事情永不丢失。",
    pricing_title: "适合您的套餐",
    plan_free: "免费版",
    plan_personal: "高级版",
    plan_lifetime: "终身版",
    plan_popular: "最受欢迎",

    // Navigation / Dashboard core
    dash_welcome: "欢迎",
    nav_dashboard: "主页",
    nav_vault: "保险库",
    nav_messages: "信息",
    nav_heirs: "继承人",
    nav_settings: "设置",
    nav_logout: "退出",
    plan_current: "当前套餐",
    dash_status_alive: "正常",
    dash_status_pending: "待确认",
    pol_state_active: "正常",
    pol_state_pending: "待确认",
    pol_state_grace: "宽限期内",
    pol_state_overdue: "已过期",

    /* Plans — updated feature list (Iter 34) */
    pricing_top_tier_owned: "您已拥有最高方案",
    feat_vault: "加密保险库 (AES-256),最多 50 项",
    feat_vault_unlimited: "无限加密保险库 (AES-256)",
    feat_messages: "未来留言(文字、音频、视频、文件)最多 20 条",
    feat_messages_unlimited: "无限未来留言(文字、音频、视频、文件)",
    feat_heirs: "最多 5 位继承人,可按比例分配",
    feat_heirs_unlimited: "无限继承人,可按比例分配",
    feat_contacts: "受信任的联系人",
    feat_assets: "数字资产(银行、加密货币、社交、设备)最多 30 项",
    feat_assets_unlimited: "无限数字资产(银行、加密货币、社交、设备)",
    feat_pol: "完整生命凭证",
    feat_pol_full: "完整生命凭证及提醒",
    feat_will: "遗嘱与执行人",
    feat_ice: "紧急情况文件 (ICE),共 20 个章节",
    feat_ice_full: "完整紧急情况文件 (ICE),共 20 个章节",
    feat_ice_pdf: "将 ICE 导出为 PDF",
    feat_share: "向执行人安全发送(带验证码)",
    feat_share_panel: "共享链接面板,可撤销",
    feat_export_gdpr: "完整导出您的全部数据 (GDPR 第 20 条)",
    pricing_lifetime_founders_badge: "创始版 · 名额有限",
    plan_free_sub: "免费开始,无需信用卡",
    plan_free_billed_never: "无需付款 · 无需信用卡",
    plan_free_cta_default: "当前套餐",
    plan_free_cta_signup: "免费开始",
    plan_free_feat_vault: "加密保险库 AES-256(5 项)",
    plan_free_feat_pol: "完整生命凭证",
    plan_free_feat_heir: "1 位继承人",
    plan_free_feat_contact: "1 位受信任联系人",
    plan_free_feat_assets: "3 项数字资产",
    plan_free_feat_storage: "1 GB 存储空间",
    plan_free_feat_messages_blocked: "未来留言",
    plan_free_feat_ice_blocked: "紧急情况文件 (ICE)",
    plan_free_feat_will_blocked: "遗嘱与执行人",
    plans_cancel_anytime: "随时取消",
    pricing_per_month_short: "/月",
    plans_native_billing_notice: "请在 keepsoul.app 管理您的套餐 · 点击任一套餐将在浏览器中打开。",
    feat_contacts_unlimited: "无限受信任的联系人",
    feat_assets_unlimited_v2: "无限数字资产(银行、加密货币、社交、设备、保险)",
    feat_pol_configurable: "完整且可配置的生命凭证",
    feat_executor_checklist: "执行人引导清单",
    feat_storage_premium: "加密存储:10 GB",
    feat_storage_lifetime: "加密存储:25 GB",
    feat_languages: "4 种语言 (ES、EN、ZH、KO)",
    feature_will: "遗嘱与执行人",
    feature_will_d:
      "指定执行人,制定法律说明,并通过验证码安全交付计划。",
    feature_ice: "紧急情况文件 (ICE)",
    feature_ice_d:
      "完整的 20 章节文件,支持 PDF 导出及可撤销的共享链接面板。",
    dash_pol_checkin: "确认生存",
    pol_title: "生存验证",
    pol_subtitle: "定期确认您仍然健在。如果您停止确认,您的可信联系人将被通知。",
    pol_last: "上次确认",
    pol_next: "下次确认",
    pol_interval: "确认间隔",
    pol_save: "保存设置",
    contacts_title: "可信联系人",
    contacts_subtitle: "在您无法响应时,这些人将得到通知。",

    // Common UI
    save: "保存",
    cancel: "取消",
    saved: "已保存",
    add: "添加",
    edit: "编辑",
    delete: "删除",
    loading: "加载中…",

    plans_title: "套餐",
    plans_sub: "选择最适合您的套餐",

    // ExampleHint blocks (Chinese)
    hint_vault_title: "在这里保存什么",
    hint_vault_1: "例如,保存您的<strong>加密货币钱包助记词</strong>,让家人能找回您的比特币。",
    hint_vault_2: "或者保存<strong>银行账户和重要服务的密码</strong>(Gmail、Apple ID、Netflix 等),以便亲人关闭或转移这些账户。",
    hint_vault_3: "使用 AES-256-GCM 静态加密。您随时可以从自己的账户访问保险库。当生命验证协议激活时,您指定的内容将交付给您选择的继承人。",
    hint_messages_title: "留下永恒的话语",
    hint_messages_1: "例如,为您的<strong>孩子安排 20 条信息</strong>,从现在到他 40 岁,每个生日都收到一条。25 岁那天收到您的语音,结婚那天再收一条,孩子出生时还有一条。",
    hint_messages_2: "或者为您的伴侣录制一段视频,回忆你们的初次约会,让它在每个结婚纪念日送达。",
    hint_messages_3: "您也可以为孙子的毕业日留一封信。爱不会过期。",
    hint_heirs_title: "谁将继承您的数字遗产",
    hint_heirs_1: "例如,指定<strong>您的长子</strong>接收保险库密钥和银行信息,让妹妹接收私人信息。",
    hint_heirs_2: "每位继承人只会收到您分配给他的内容 — 您可以任意组合分配。",
    hint_heirs_3: "当生存验证确认您离世后,KeepSoul 将向每位继承人发送安全邮件,提供他们应得的那部分遗产。",
    hint_assets_title: "不能丢失的资产",
    hint_assets_1: "例如,登记您的<strong>主要银行账户</strong>(IBAN 和绑定手机号),让伴侣知道资金所在。",
    hint_assets_2: "或者您的<strong>加密货币钱包</strong>(Binance、MetaMask、Ledger)及加密的恢复说明。",
    hint_assets_3: "还有社交媒体账户(以便关闭或纪念)、养老金计划、人寿保险、税务记录……",

    // Pricing
    pricing_no_card: "无需信用卡即可开始 · 无意外自动续费 · 随时取消",
    pricing_start_free: "在决定之前试用 KeepSoul",
    pricing_personal_sub: "大多数 KeepSoul 用户的选择",
    plans_personal_monthly_equiv: "相当于每月 €3.25 — 比一杯咖啡还便宜",
    plans_free_explore_hint: "用于了解平台。准备好后,升级到 Personal 套餐。",
    pricing_lifetime_label: "终身版",
    pricing_lifetime_launch: "🔥 发布优惠",
    pricing_lifetime_sub: "一次性付款 — 无需续费",
    pricing_lifetime_once: " 一次性",
    pricing_lifetime_limited: "限 100 位创始用户",
    pricing_per_month: "/月",
    pricing_per_year: "/年",
    pricing_billed_annually: "按年付款",
    pricing_billed_monthly: "按月付款",
    pricing_billed_once: "一次性付款",
    msg_no_body: "此消息仅包含媒体内容。",
    msg_your_message: "您的留言",
    msg_attachment_label: "附件",
    auth_show_password: "显示密码",
    auth_hide_password: "隐藏密码",
    pol_banner_active: "正常",
    pol_banner_active_sub: "您的遗产受到保护。下次确认: {DATE}。",
    pol_banner_due: "需要尽快确认!",
    pol_banner_due_sub: "请在 {DATE} 之前确认您还在,以防止激活。",
    pol_banner_risk: "⚠ 您的遗产可能被激活",
    pol_banner_risk_sub: "已超过预期天数。请立即确认。",
    pol_banner_cta: "我还在",
    pol_banner_config: "配置 →",
    pol_view_details: "查看详情 →",
    pricing_save_yearly: "每年节省 {AMOUNT}",
    pricing_billing_monthly: "月付",
    pricing_billing_annual: "年付",
    pricing_lifetime_savings: "(相当于 38 年的月付套餐)",
    pricing_cta_start_free: "免费开始",
    pricing_cta_start_personal: "选择高级版",
    pricing_cta_claim_lifetime: "领取终身优惠",
    pricing_cta_lifetime_short: "领取优惠",
    pricing_current: "当前套餐",
    pricing_lifetime_permanent: "您的套餐是永久的",
    pricing_cancel_from_settings: "从设置中取消",
    pricing_change_via_support: "套餐变更需联系客服",
    pricing_sold_out: "已售罄",
    pricing_legal: "所有价格含税 · 可随时在设置中取消 · AES-256 加密 · 符合 GDPR",
    pricing_lifetime_slots: "剩余 {N} / {TOTAL} 个名额",
    plans_popular: "最受欢迎",
    plans_lifetime_feat_1: "永久享有个人版的全部功能",
    plans_lifetime_feat_2: "永不再付月费",
    plans_lifetime_feat_3: "KeepSoul 创始会员身份",
    plans_lifetime_feat_4: "新功能优先体验权",
    plans_free_feat_1: "保险库 3 个条目",
    plans_free_feat_2: "1 条未来信息",
    plans_free_feat_3: "1 位继承人",
    plans_free_feat_4: "基础生存验证",
    plans_free_feat_5: "100 MB",
    plans_free_feat_6: "2 位可信联系人",
    plans_free_feat_7: "100 MB 存储",
    plans_personal_feat_1: "保险库 100 个条目",
    plans_personal_feat_2: "20 条未来信息",
    plans_personal_feat_3: "3 位继承人",
    plans_personal_feat_4: "完整数字资产管理",
    plans_personal_feat_5: "10 GB 存储",
    plans_personal_feat_6: "联系人无限制",
    plans_personal_feat_7: "5 位可信联系人",
    plans_personal_feat_8: "30 个数字资产",
    plans_personal_feat_9: "完整生存验证",
    plans_lifetime_full_feat_1: "全部无限制 — 无任何限制",
    plans_lifetime_full_feat_2: "保险库、信息、继承人和资产均无上限",
    plans_lifetime_full_feat_3: "永不再付月费",
    plans_lifetime_full_feat_4: "仅限 {N} 位用户",
    plans_lifetime_full_feat_5: "新功能优先体验权",
    plans_lifetime_full_feat_6: "KeepSoul 创始会员身份",
    plans_lifetime_sold_out_msg: "已售罄 — 请稍后再来",
    plans_lifetime_slots_avail: "🔥 剩余 {N} / {TOTAL} 个名额",
    plans_lifetime_payment_once: "一次性付款 — 永不续费",
    plans_billing_annual_save: "-17%",

    // Setup / onboarding progress (Chinese)
    setup_title: "您的遗产",
    setup_complete: "完成度",
    setup_step_vault: "添加第一个密码到保险库",
    setup_step_msg: "安排您的第一条未来信息",
    setup_step_heir: "指定至少一位继承人",
    setup_step_contact: "添加可信联系人",
    setup_step_assign: "为继承人分配项目",
    setup_step_pol: "配置生存验证",
    discount_have_code: "有优惠码?(可选)",
    discount_applied: "优惠码已应用:",
    discount_full_free: "100% 免费!",
    discount_apply: "应用",
    discount_validating: "验证中…",
    discount_will_apply: "优惠码将在您选择的套餐上生效。",

    // Setup / onboarding progress
    setup_progress_title: "您的遗产",
    setup_progress_done: "完成度",
    setup_pct_remaining: "还剩 {N}% 待完成",
    setup_done_msg: "完成!您的遗产已全部设置好。",

    // === Dashboard / LegacyHealth ===
    dh_title: "遗产健康度",
    dh_status_excellent: "极佳",
    dh_status_good: "良好",
    dh_status_attention: "需要关注",
    dh_status_critical: "紧急",
    dh_heir_no_msg: "{N} 位继承人尚无告别信息",
    dh_heir_no_msg_plural: "{N} 位继承人尚无告别信息",
    dh_heir_no_msg_sub: "录制或写下几句话,让他们收到一份个人留言。",
    dh_heir_no_msg_cta: "前往继承人",
    dh_few_contacts: "仅有 {N} 位可信联系人",
    dh_few_contacts_sub: "建议添加 3 位联系人,这样在有疑问时可有 2 位进行确认。",
    dh_few_contacts_cta: "添加联系人",
    dh_no_assets: "尚未登记数字资产",
    dh_no_assets_sub: "银行、社交媒体、加密货币:未登记的将永远丢失。",
    dh_no_assets_cta: "添加资产",
    dh_pol_title: "生存验证",
    dh_pol_next: "下次验证:",
    dh_pol_confirm: "确认生存",
    dh_pol_state_alive: "正常",
    dh_pol_state_alert: "需要关注",
    dh_pol_state_pending: "待确认",

    // === Vault ===
    vault_title: "保险库",
    vault_subtitle: "您最珍贵的秘密,永久加密保存。",
    vault_sub: "您最珍贵的秘密,永久加密保存。",
    vault_empty: "您的保险库是空的。从保存最重要的事物开始。",
    vault_add: "添加到保险库",
    vault_type_password: "密码",
    vault_type_capsule: "胶囊",
    vault_type_note: "笔记",
    vault_type_credential: "凭证",

    // === Settings / plan card ===
    set_change_plan: "更换套餐",
    set_current_plan: "当前套餐",
    set_pay_recover_q: "已付款但套餐未激活?",
    set_pay_recover_link: "找回付款",
    set_cancel_sub: "取消订阅",
    set_storage_label: "存储空间",
    set_storage_help: "已使用 {PCT}% · AES-256 加密的视频和音频",
    set_share_title: "分享 KeepSoul",
    set_share_sub: "邀请家人保护他们的遗产",
    set_pol_card_title: "生存验证",
    set_pol_card_sub: "配置验证周期和联系人",
    plan_change: "更换套餐",
    set_assets_card_title: "数字资产",
    set_assets_card_sub: "银行、社交、加密货币、设备",
    set_plan_usage_title: "套餐使用情况",
    set_usage_vault: "保险库条目",
    set_usage_messages: "已安排的信息",
    set_usage_heirs: "继承人",
    set_usage_contacts: "可信联系人",
    set_per_month: "/月",
    set_per_year: "/年",
    set_pay_once: "一次性付款",
    set_no_recent_payments: "近 7 天内未找到您名下的已确认付款",
    set_recover_error: "无法检查您的付款。请联系 support@keepsoul.app",
    set_upgrade_plan: "升级您的套餐",
    da_subtitle: "银行账户、设备、加密货币和保险将自动移交给您的继承人。这是一张「拥有什么」的地图 — 实际密码仅保存在加密保险库中。",
    da_cred_placeholder: "在 KeepSoul 保险库 · 1Password · 浏览器管理器 · 纸张存放于保险柜……",
    da_cred_hint: "只描述凭证 在哪里。不要在此处输入密码。",
    da_cred_hint_link: "将其加密保存在保险库 →",
    da_cred_hint_crypto: "切勿在此处粘贴助记词或私钥 — 请加密保存在保险库中。",
    da_legacy_tag: "旧数据",
    da_legacy_password: "密码 (此前已保存)",
    da_legacy_pin: "PIN (此前已保存)",
    da_legacy_seed: "助记词 (此前已保存)",
    da_add: "添加",
    da_empty_for: "您尚未添加任何{LABEL}。",
    da_assigned_to: "已分配给",
    da_heir: "位继承人",
    da_heirs: "位继承人",
    da_no_heirs_assigned: "尚未指定继承人",
    da_warn_sensitive: "此信息极其敏感。已使用 AES-256 加密,仅在确认离世后才会公开。",
    da_warn_seed: "切勿与他人分享。仅在生命验证确认后,才会向您指定的继承人解密。",
    da_security_note: "此数据使用 AES-256-GCM 静态加密保护。仅在生命验证确认您离世后,才会自动向指定继承人公开。",
    da_assign_heirs: "分配给继承人",
    da_label_title: "标题 / 标签",
    da_title_ph: "例:{EXAMPLE}",
    da_eg_bank: "BBVA 主账户",
    da_eg_social: "个人 Instagram",
    da_eg_generic: "简短标签",
    da_instruction_ph: "您希望继承人如何处理…",
    da_edit_asset: "编辑资产",
    da_view_notes: "备注",
    da_view_instruction: "处理指示",
    da_view_encryption: "AES-256-GCM 静态加密 · 仅在生命验证确认您离世后,才会自动交付给继承人。",
    select: "请选择",
    vault_field_password: "密码",
    vault_capsule_label: "时间胶囊",
    vault_capsule_desc: "仅在我去世后才会公开。勾选此项后,继承人只有在生命验证确认您离世后才能收到此内容。",
    hap_default_label: "接收此内容的继承人",
    hap_no_heirs_yet: "您尚未添加继承人。请先前往“继承人”页面添加。",
    hap_no_assignment_warning: "未指定继承人时,此项目不会自动交付。",

    // === Landing — sections ===
    lp_problem: "问题所在",
    lp_problem_title: "失去的,再也回不来。",
    lp_problem_sub: "每年,数百万家庭永远失去密码、照片、加密货币和数字回忆。从未有完整的解决方案 — 直到现在。",
    lp_stat_crypto: "丢失的加密货币",
    lp_stat_passwords: "主人离世后被遗忘的密码",
    lp_stat_accounts: "账户陷入数字遗忘",
    lp_solution: "我们的方案",
    lp_feature_vault: "加密保险库",
    lp_feature_vault_desc: "密码、加密货币密钥和秘密,均使用 AES-256 加密。",
    lp_feature_msg: "未来信息",
    lp_feature_msg_desc: "音频、视频和书信,在您选定的日期送达。",
    lp_feature_pol: "自动生存验证",
    lp_feature_pol_desc: "如果您停止确认,数字继承协议将自动启动。",
    lp_feature_heirs: "数字继承",
    lp_feature_heirs_desc: "指定继承人,安全分配您的遗产。",
    lp_feature_ai: "遗产 AI",
    lp_feature_ai_desc: "与您的遗产对话:讲故事、个人助手。",
    lp_feature_zk: "AES-256-GCM 静态加密",
    lp_feature_zk_desc: "您的敏感数据以 AES-256-GCM 加密存储,仅在协议激活时才会交付给您的继承人。",
    lp_how_title: "当您不在时,这套系统会自动启动一切。",

    // Legacy Health signals
    lh_label: "遗产健康度",
    lh_loading: "正在分析您的遗产…",
    lh_all_good: "一切就绪。做得很好!",
    lh_well_protected: "您的遗产已得到良好保护",
    lh_resending: "发送中…",
    lh_grade_excellent: "极佳",
    lh_grade_good: "良好",
    lh_grade_fair: "可改善",
    lh_grade_weak: "薄弱",
    sig_email_unverified_title: "请确认您的邮箱",
    sig_email_unverified_detail: "在您确认邮箱之前,我们无法投递您的遗产。",
    sig_email_unverified_cta: "重新发送邮件",
    sig_heirs_no_farewell_title: "{N} 位继承人尚无告别信息",
    sig_heirs_no_farewell_title_1: "{N} 位继承人尚无告别信息",
    sig_heirs_no_farewell_detail: "录制或写下几句话,让他们收到一份个人留言。",
    sig_heirs_no_farewell_cta: "前往继承人",
    sig_no_heirs_title: "您尚未添加继承人",
    sig_no_heirs_detail: "没有继承人,我们无法将您的遗产交付给任何人。",
    sig_no_heirs_cta: "添加继承人",
    sig_no_contacts_title: "尚无可信联系人",
    sig_no_contacts_detail: "您至少需要 1 位联系人来验证您的生存验证。",
    sig_no_contacts_cta: "配置生存验证",
    sig_contacts_low_title: "仅有 {N} 位可信联系人",
    sig_contacts_low_title_1: "仅有 {N} 位可信联系人",
    sig_contacts_low_detail: "建议添加 3 位联系人,这样在有疑问时可有 2 位进行确认。",
    sig_contacts_low_cta: "添加联系人",
    sig_vault_empty_title: "您的保险库是空的",
    sig_vault_empty_detail: "至少保存一个密码或重要文件。",
    sig_vault_empty_cta: "前往保险库",
    sig_no_messages_title: "尚无已安排的信息",
    sig_no_messages_detail: "为某人写一条信息 — 生日、告别…",
    sig_no_messages_cta: "创建信息",
    sig_no_assets_title: "尚未登记数字资产",
    sig_no_assets_detail: "银行、社交媒体、加密货币:未登记的将永远丢失。",
    sig_no_assets_cta: "添加资产",
    sig_stale_title: "您的遗产已 {N} 天未更新",
    sig_stale_detail: "请检查所有信息是否仍然有效:密码、继承人、信息。",
    sig_stale_cta: "查看",
    sig_pol_overdue_title: "生存验证已逾期",
    sig_pol_overdue_detail: "请尽快确认您的生存验证,以避免通知您的联系人。",
    sig_pol_overdue_cta: "立即确认",
    sig_pol_soon_title: "{N} 天后需进行生存验证",
    sig_pol_soon_detail: "请记得在到期前确认。",
    sig_pol_soon_cta: "前往生存验证",

    // ============= Massive ZH coverage (auto-added in iter 13) =============
    // Landing
    section_problem_label: "问题所在",
    section_problem_title: "失去的,永不归来。",
    section_problem_body: "每年,数百万家庭永远失去密码、照片、加密货币和数字回忆。从未有完整的解决方案 — 直到现在。",
    section_solution_label: "我们的方案",
    section_solution_title: "守护一切重要的事物。",
    stat_crypto: "丢失的加密货币",
    stat_families: "无法访问账户的家庭",
    stat_planning: "未做数字规划的人",
    landing_compare_title: "为何选择 KeepSoul",
    landing_compare_sub: "唯一一个集所有功能于一体的平台。",
    cta_final_title: "有些东西无法挽回。",
    cta_final_sub: "但它们可以被守护。立即开始。",

    // Login
    login_title: "登录",
    login_sub: "您的遗产在等您。通过邮箱或 Google 登录。",
    login_secure: "AES-256 静态加密 · GDPR 合规",
    login_create: "创建账户",
    login_create_sub: "开始守护最重要的一切",
    auth_name: "姓名",
    auth_email: "邮箱",
    auth_password: "密码",
    auth_min8: "至少 8 个字符",
    auth_password_hint: "至少 12 位,包含大写字母、数字和符号",
    auth_signup_btn: "创建账户",
    auth_login_btn: "登录",
    auth_have_account: "已有账户?点此登录",
    auth_no_account: "还没有账户?立即创建",
    auth_welcome: "欢迎回来",
    auth_created: "账户已创建!",
    auth_forgot: "忘记密码?",
    auth_continue_google: "使用 Google 继续",
    auth_need_help: "需要帮助?",
    auth_generic_error: "发生错误,请重试。",
    consent_terms_required: "您必须接受条款和条件才能创建账户。",
    consent_privacy_required: "您必须接受隐私政策才能创建账户。",
    consent_terms_label: "我已阅读并接受",
    consent_terms_link: "条款和条件",
    consent_privacy_label: "我已阅读并接受",
    consent_privacy_link: "隐私政策",
    consent_marketing_label: "我同意接收 KeepSoul 的营销通讯(可选)。",
    cookie_banner_title: "隐私和 Cookie",
    cookie_banner_msg: "我们使用必要的技术性 Cookie 以确保应用正常运行。默认情况下,我们不使用分析性或广告性 Cookie。您可以选择是否接受。",
    cookie_banner_more: "查看 Cookie 政策",
    cookie_accept_all: "全部接受",
    cookie_reject_all: "全部拒绝",
    cookie_configure: "配置",
    cookie_modal_title: "配置 Cookie",
    cookie_modal_intro: "选择您接受的 Cookie 类型。必要的技术性 Cookie 无法禁用,因为它们是服务运行所必需的。",
    cookie_cat_necessary: "必要的技术性 Cookie",
    cookie_cat_necessary_desc: "登录、记住语言和 Cookie 同意所必需。无法禁用。",
    cookie_cat_analytics: "分析性 Cookie",
    cookie_cat_analytics_desc: "允许我们匿名衡量网站使用情况以进行改进。目前未使用,未来如启用将先征得您的同意。",
    cookie_always_on: "始终启用",
    cookie_save_prefs: "保存偏好",
    auth_session_lost: "账户已创建,但未能自动登录。请使用邮箱和密码手动登录。",

    // Plans (extras)
    free: "免费",
    lifetime: "终身",
    plan_saved: "套餐已保存",

    // Common fields and labels (forms, inputs, modals)
    title: "标题",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    url: "网址",
    username: "用户名",
    notes: "备注",
    optional: "可选",
    content: "内容",
    video: "视频",
    confirm_delete: "确定要删除吗?",
    copied: "已复制",
    deleted: "已删除",
    email_already_verified: "邮箱已确认",
    email_resent: "确认邮件已重新发送",

    // Categories
    cat_password: "密码",
    cat_document: "文件",
    cat_crypto: "加密货币",
    cat_photo: "照片",
    cat_asset: "资产",

    // Heirs
    heir_title: "数字继承人",
    heir_subtitle: "将获得您遗产的人。",
    heir_add: "添加继承人",
    heir_empty: "您还没有继承人。",
    heir_relationship: "关系",
    heir_share: "分配份额",
    heir_relationship_ph: "儿子、妻子、兄弟…",
    heir_emails_label: "继承人邮箱(建议添加多个以确保安全)",
    heir_email_primary_ph: "主邮箱",
    heir_email_backup_ph: "备用邮箱",
    heir_email_primary_tag: "主要",
    heir_remove_email: "移除邮箱",
    heir_add_email: "添加另一个邮箱",
    heir_emails_help: "系统会将遗产发送到所有这些邮箱,以最大程度保障安全。",
    heir_phone_label: "短信电话",
    heir_phone_view_label: "电话(短信备用)",
    heir_at_least_one_email: "至少添加一个邮箱",
    heir_email_invalid: "邮箱无效: {EMAIL}",
    heir_share_range_err: "百分比必须在 1 到 100 之间。",
    heir_share_overflow_err: "您超出了遗产的 100%。可用: {REMAINING}%。",
    heir_share_assigned: "已分配: {N}%",
    heir_share_remaining: "待分配: {N}%",
    heir_share_warning: "您已分配少于 100%。剩余的 {N}% 将没有接收人。是否需要重新检查?",
    heir_share_available: "(可用: {N}%)",
    heir_notify_label: "立即通过电子邮件通知继承人",
    heir_notify_help: "默认不发送任何内容。如果启用,将发送一封中性邮件,通知此人已被加入您的数字遗产计划。不会透露内容。",
    heir_status_complete: "已完成",
    heir_status_pending: "待完成",
    heir_emails_count: "邮箱",
    heir_tooltip_emails: "已配置的邮箱",
    heir_tooltip_sms: "短信备用",
    heir_tooltip_farewell: "告别信息",
    heir_tooltip_assets: "数字资产",
    heir_tooltip_vault: "保险柜项目",
    heir_tooltip_messages: "留言",
    heir_tooltip_capsule: "时间胶囊",
    heir_farewell_title: "告别信息",
    heir_farewell_desc: "这是您离开后他们收到的第一份内容。您可以录制音频、视频、撰写文字或附加个人文件。",
    heir_farewell_input_label: "您的告别",
    heir_nothing_assigned: "您尚未为其分配任何内容。请前往保险柜、留言、时间胶囊或数字资产,选择 {NAME}。",
    heir_will_receive: "将自动接收",
    heir_assigned_assets: "数字资产",
    heir_assigned_vault: "来自保险柜",
    heir_assigned_messages: "留言",
    heir_assigned_capsule: "时间胶囊",
    heir_link_digital_assets: "数字资产",

    vault_category_label: "类别",
    vault_capsule_badge: "时间胶囊",
    vault_capsule_tooltip: "时间胶囊 — 仅在您离世后才会公开",

    media_kind_text: "文字",
    media_kind_audio: "音频",
    media_kind_video: "视频",
    media_kind_file: "文件",

    // Messages
    msg_title: "未来留言",
    msg_subtitle: "将在您选定的日期送达。",
    msg_add: "新建留言",
    msg_empty: "尚无已安排的留言。",
    msg_recipient: "收件人",
    msg_recipient_email: "收件人邮箱",
    msg_subject: "主题",
    msg_body: "内容",
    msg_date: "发送日期",
    msg_type_label: "留言类型",
    msg_cat_date_label: "指定日期",
    msg_cat_date_hint: "生日、婚礼、重要日期…",
    msg_cat_death_label: "离世时",
    msg_cat_death_hint: "在生命验证确认您离世后送达。",
    msg_cat_historia_label: "家族故事",
    msg_cat_historia_hint: "回忆、轶事、人生时刻。将成为继承人收到档案的一部分。",
    msg_date_required: "请选择送达日期",
    msg_assign_heirs_label: "同时分配给继承人",

    // Capsule
    capsule_title: "时间胶囊",
    capsule_subtitle: "仅在我去世后向继承人公开。",
    capsule_add: "添加胶囊",

    // Stories
    historia_title: "我的故事",
    historia_subtitle: "为后代留下您一生的回忆。",
    historia_add: "添加故事",

    // Trusted contacts
    contacts_add: "添加可信联系人",
    contacts_empty_title: "尚未添加联系人",
    contacts_empty_body: "可信联系人会在您未确认生存验证时收到通知。",

    // Dashboard PoL widget
    dash_pol: "生存验证",
    dash_pol_next: "下次确认:",

    // Tour / onboarding
    tour_title: "欢迎来到 KeepSoul",
    tour_sub: "让我们快速了解您将留下的遗产。",
    tour_skip: "跳过教程",
    tour_back: "上一步",
    tour_next: "下一步",
    tour_cta: "开始使用",
    tour_step1_t: "您的保险库",
    tour_step1_d: "在此保存密码、加密货币密钥和重要文件。",
    tour_step2_t: "未来留言",
    tour_step2_d: "为亲人安排在您离世后送达的留言。",
    tour_step3_t: "您的继承人",
    tour_step3_d: "选择由谁来接收您的遗产以及如何分配。",
    tour_step4_t: "生存验证",
    tour_step4_d: "定期确认您仍健在 — 如未确认,系统将自动启动遗产协议。",

    // PWA install hint
    install_title: "安装 KeepSoul",
    install_sub: "在主屏幕上一键打开",
    install_btn: "安装应用",
    install_ios_title: "在 iOS 上安装",
    install_ios_steps: "1) 点击底部的“分享”按钮 2) 选择“添加到主屏幕”",
      /* Founders Program (auto-translated) */
    plans_bridge_text: "想要获得不仅仅是访问权限?创始人计划包含公司真实股权。",
    plan_founders_badge: "创始人版",
    plan_founders_title: "KeepSoul 创始人",
    plan_founders_subtitle: "真实股权 · 永恒传承",
    plan_founders_slots: "{N}/{TOTAL} 席位可用",
    plan_founders_separator: "包含终身计划的全部内容,另外还有:",
    plan_founders_feat_1: "全部无限制 — 无任何限制",
    plan_founders_feat_2: "保险箱、消息、继承人和资产均无上限",
    plan_founders_feat_3: "永久无需支付月费",
    plan_founders_feat_4: "优先访问新测试功能",
    plan_founders_feat_5: "您的个人资料中永久显示「创始人 #XXX」身份",
    plan_founders_feat_6: "创始人私密社区,可直接联系团队",
    plan_founders_feat_7: "KeepSoul S.L. 1 份真实股权 — 占股本的 0.01%",
    plan_founders_feat_8: "自第 5 年起享有分红权",
    plan_founders_feat_9: "若发生收购,参与售价分配(拖售权/跟售权)",
    plan_founders_ownership_title: "成为股东意味着什么?",
    plan_founders_ownership_body: "购买创始人席位,您不仅获得 KeepSoul 的终身访问权 — 您还将获得 KeepSoul S.L. 的真实股权,享有西班牙《资本公司法》认可的法律权利。\n\n🌍 市场:数字遗产管理是一个预计到 2028 年达到 890 亿美元的行业,年增长率为 22%。每年,欧洲有 380 万人去世,留下未经管理的数字资产。\n\n📈 5 年预测(保守情景):\n· 2026 年:2,000 用户 · 年度经常性收入 €168,000 · 分红池:€8,400\n· 2027 年:8,000 用户 · 年度经常性收入 €768,000 · 分红池:€38,400\n· 2028 年:25,000 用户 · 年度经常性收入 €2,700,000 · 分红池:€135,000\n· 2029 年:60,000 用户 · 年度经常性收入 €6,480,000 · 分红池:€324,000\n· 2030 年:120,000 用户 · 年度经常性收入 €14,400,000 · 分红池:€720,000\n累计分红池 5%(2026–2030):€1,225,800\n\n若发生收购:估值 €10M → 您的 0.01% = €1,000 · 估值 €30M → €3,000\n\n⚖️ 法律框架摘要:\n· 根据 RDL 1/2010(《资本公司法》)进行买卖\n· 1 份股权 = KeepSoul S.L. 股本的 0.01%\n· 当管理机构决议时发放分红\n· 前 5 年的转让限制(优先购买权)\n· 拖售权:若出售 100%,您参与售价分配\n· 跟售权:若出售控股权包,您可以跟随出售\n· 保证终身访问权。若关闭:提供 24 个月服务或退还 €195\n\n⚠️ 预测仅供参考,不构成回报保证。",
    plan_founders_legal_link: "📄 查看完整法律条款、预测和招股说明书 →",
    plan_founders_cta: "成为创始人 →",
    plan_founders_trust: "🔒 股权在公证契约中登记 · 仅限 500 个席位",
    founders_page_badge: "创始人计划 — 限量版",
    founders_page_label: "创始人计划",
    founders_page_h1: "成为 KeepSoul 的股东。",
    founders_page_h1_sub: "500 个席位。仅此一次。永久有效。",
    founders_page_cta_reserve: "预订我的席位",
    founders_page_cta_prospect: "阅读完整招股说明书",
    founders_stat_spots: "总席位数",
    founders_stat_price: "一次性价格",
    founders_stat_capital: "占股本",
    founders_stat_lifetime: "终身访问",
    founders_problem_label: "KEEPSOUL 存在的原因",
    founders_problem_title: "每年,数十亿欧元消失。",
    founders_problem_body: "丢失的密码。无法访问的加密货币。被遗忘的账户。从未送达的消息。当有人去世却没有整理好数字遗产时,他们的家人继承的是混乱。KeepSoul 是首个数字遗产保险库,结合 AES-256 加密存储与去世后自动交付 — 由主动生命验证系统协调。",
    founders_market_label: "市场规模",
    founders_market_title: "一个尚未解决的万亿级行业。",
    founders_projection_label: "2026–2031 年预测",
    founders_projection_title: "通往盈利之路。",
    founders_projection_sub: "保守情景。不包括与保险公司或银行的 B2B 协议。",
    founders_projection_disclaimer: "* 预测仅供参考。不构成回报保证。分红取决于实际盈利能力和管理机构的决定。",
    founders_acquisition_upside: "估值 €10M → 您的 0.01% = €1,000 · 估值 €30M → €3,000 · 估值 €100M → €10,000",
    founders_includes_label: "您将获得的内容",
    founders_includes_title: "您的创始人席位。",
    founders_includes_left_title: "平台访问权限",
    founders_includes_platform_1: "KeepSoul 的全部无限制 — 永久无任何限制",
    founders_includes_platform_2: "保险箱、消息、继承人和资产均无上限",
    founders_includes_platform_3: "永久无需支付月费或年费",
    founders_includes_platform_4: "优先访问测试功能",
    founders_includes_platform_5: "您的个人资料中永久显示「创始人 #XXX」徽章",
    founders_includes_platform_6: "创始人私密频道,可直接联系团队",
    founders_includes_right_title: "公司股权",
    founders_includes_ownership_1: "KeepSoul S.L. 1 份真实股权",
    founders_includes_ownership_2: "在公证契约中登记的 0.01% 股本",
    founders_includes_ownership_3: "自第 5 年起享有分红权",
    founders_includes_ownership_4: "若发生收购,参与售价分配",
    founders_includes_ownership_5: "控股权包出售时的跟售权",
    founders_includes_ownership_6: "获得股东协议和公司章程",
    founders_legal_label: "法律框架",
    founders_legal_title: "完全透明。",
    founders_legal_intro: "此优惠按照现行法律构建。这不是众筹,不是代币,不是参与式贷款。这是真实的公司股权。",
    founders_timeline_label: "路线图",
    founders_timeline_title: "未来五年。",
    founders_faq_label: "常见问题",
    founders_faq_title: "您需要了解的一切。",
    founders_cta_title: "您的席位正在等待。",
    founders_cta_subtext: "一次性付款 · 无需续费 · 真实股权",
    founders_cta_trust: "🔒 72 小时内数字签署合同 · 公证股权 · 仅限 500 个席位",
    founders_of: "/",
    founders_spots_available: "席位可用",
    founders_footer_disclaimer: "本页面不构成证券公开发售,也不受西班牙国家证券市场委员会(CNMV)监管。非上市有限责任公司的股权不是受监管市场上可交易的证券。",
    /* Landing additions (auto-translated) */
    nav_founders: "创始会员",
    nav_security: "安全保障",
    nav_signup_cta: "免费开始",
    nav_back_home: "返回首页",
    nav_dashboard_short: "进入控制台",
    landing_trust_aes: "🔒 AES-256 加密",
    landing_trust_gdpr: "🇪🇺 符合 GDPR 标准",
    landing_trust_zk: "🛡️ 零知识架构",
    landing_trust_founders: "⭐ 500 位创始会员",
    landing_how_label: "工作原理",
    landing_how_title: "三个步骤。一份传承。",
    landing_how_1_title: "保存",
    landing_how_1_body: "将密码、文档、消息和数字资产添加到您的加密保险库中。",
    landing_how_2_title: "指定",
    landing_how_2_body: "指定您的继承人,决定每个人获得什么以及何时获得。",
    landing_how_3_title: "自动交付",
    landing_how_3_body: "KeepSoul 定期验证您的状态。如果您没有响应,系统将自动交付您的传承。",
    landing_security_label: "安全保障",
    landing_security_title: "您的传承,只掌握在您手中。",
    landing_security_aes_title: "AES-256-GCM",
    landing_security_aes_body: "与银行和政府用于保护关键信息的同等标准。",
    landing_security_gdpr_title: "GDPR · LOPDGDD",
    landing_security_gdpr_body: "完全符合欧盟和西班牙数据保护法规。",
    landing_security_zk_title: "零知识架构",
    landing_security_zk_body: "数据在离开我们的服务器之前即已加密。即使是我们也无法查看。",
    landing_proof_label: "为什么选择 KEEPSOUL",
    landing_proof_title: "为重要之事而构建。",
    landing_proof_stat1_value: "€140 亿",
    landing_proof_stat1_label: "因未规划而在身故后遗失的加密货币价值",
    landing_proof_stat2_value: "68%",
    landing_proof_stat2_label: "的欧洲成年人没有数字遗产规划",
    landing_proof_stat3_value: "3 分钟",
    landing_proof_stat3_label: "保护您首批资产所需的平均时间",
    landing_final_subtle: "已有 500+ 位创始会员 · AES-256 加密 · 符合 GDPR",
    landing_footer_tagline: "保护重要之事。",
    landing_footer_col_product: "产品",
    landing_footer_col_legal: "法律",
    landing_footer_col_support: "支持",
    landing_footer_about: "© 2026 KeepSoul · 西班牙穆尔西亚",
    upgrade_modal_title: "您已达到当前方案的限制",
    upgrade_modal_body: "免费方案包含 {LIMIT} 个{ITEM}。升级至高级版以无限制继续使用。",
    upgrade_modal_cta: "查看方案 →",
    upgrade_modal_dismiss: "暂不升级",
    payment_success_banner: "🎉 支付完成!您的 {PLAN} 方案现已生效。",
    payment_success_founder: "🏛️ 欢迎,第 #{N} 位创始会员!您对 KeepSoul 的参与已确认。您将在 72 小时内收到合同。",
    payment_cancelled_banner: "支付已取消。您的方案未发生变更。",
    payment_dismiss: "关闭",
    /* Founders funds-allocation + table headers (auto-translated) */
    founders_proj_col_year: "年份",
    founders_proj_col_users: "活跃用户",
    founders_proj_col_arpu: "月度ARPU",
    founders_proj_col_arr: "预估ARR",
    founders_proj_col_div: "分红池5%",
    founders_proj_total: "总计",
    founders_proj_cumulative: "累计",
    founders_arpu_note: "= 付费用户月平均收入（ARPU，Average Revenue Per User）。综合月度订阅用户与年度订阅用户计算。并非所有活跃用户均付费：部分用户使用免费方案。",
    founders_funds_label: "资金用途",
    founders_funds_title: "每一欧元，投向增长。",
    founders_funds_intro: "创始人计划募集资金100%直接再投资于KeepSoul的增长。这不是支出：而是将可靠产品转化为行业标杆的燃料。",
    founders_funds_marketing_title: "市场营销与获客",
    founders_funds_marketing_body: "在西班牙与拉美核心市场开展获客活动、SEO定位、内容营销及品牌曝光，提升知名度。",
    founders_funds_product_title: "产品与技术",
    founders_funds_product_body: "新功能开发、安全性提升、基础设施扩展及平台持续迭代。",
    founders_funds_alliances_title: "战略合作与扩张",
    founders_funds_alliances_body: "与公证处、代理机构、保险公司及银行建立合作关系。拓展新国家市场与语言支持。",
    founders_funds_legal_title: "法律架构与运营",
    founders_funds_legal_body: "有限责任公司设立、合规监管、日常支持与运营事务。",
    founders_funds_closing: "您的投资不会闲置。它将助力KeepSoul攀登顶峰——而您与之同行。",
    /* Landing: remove-zk replacements (auto-translated) */
    landing_trust_encrypted: "🔐 静态加密",
    landing_final_subtle_no_founders: "AES-256 加密 · GDPR · 西班牙穆尔西亚出品",
    landing_security_atrest_title: "静态加密",
    landing_security_atrest_body: "您的敏感数据在存储前即通过 AES-256-GCM 在我们的服务器上加密。即使有人访问数据库,看到的也只是无意义的乱码。",
    /* Bug 3 batch (auto-translated) */
    confirm_email_missing_token: "缺少确认令牌。",
    confirm_email_error_default: "无法确认邮箱。",
    confirm_email_loading_title: "正在确认您的邮箱…",
    confirm_email_loading_body: "请稍候。",
    confirm_email_success_title: "邮箱已确认！",
    confirm_email_success_body: "您的数字遗产现已激活。请登录并配置您的生命证明，开始保护最重要的事物。",
    confirm_email_go_dashboard: "前往我的控制面板",
    confirm_email_go_login: "登录",
    confirm_email_error_title: "无法确认",
    confirm_email_error_help: "链接可能已过期或已被使用。请登录并从控制面板请求新的确认邮件。",
    login_email_confirmed_banner: "您的邮箱已成功确认。请登录进入控制面板。",
    login_tab_email: "邮箱",
    login_any_email_hint: "支持任何邮箱（Gmail、Outlook、ProtonMail 等）",
    settings_share_copied: "消息已复制到剪贴板 ✨",
    settings_share_failed: "无法分享",
    settings_downgrade_confirm: "取消订阅并返回免费计划？您将保留账户和数据。",
    settings_downgrade_done: "订阅已取消。免费计划已激活。",
    settings_generic_error: "错误",
    settings_delete_done: "账户已删除。我们已向您发送确认邮件。",
    settings_delete_failed: "删除账户时出错",
    settings_export_google_warn: "您的账户使用 Google 登录。导出前请先在设置中创建密码。",
    settings_export_started: "下载已开始。请将其保存在安全的地方。",
    pol_confirmed_toast: "生命证明已确认 ✓",
    discount_applied_full: "计划已 100% 激活！",
    evb_already_verified: "您的邮箱已确认。请刷新页面。",
    /* EmailVerifyBanner */
    evb_title: "确认您的邮箱以激活您的遗产",
    evb_body_prefix: "我们已向以下地址发送了一个链接",
    evb_body_suffix: "在您确认之前,生命证明和遗产交付功能处于停用状态。",
    evb_sending: "发送中…",
    evb_resend_cta: "重新发送邮件",
    evb_resent_to: "确认邮件已发送至 {email}",
    evb_resend_failed: "无法发送邮件",
    /* Bug 3 extra (auto-translated) */
    pol_demo_email_sent: "演示邮件已发送至 {EMAIL}。请在几分钟内查收。",
    historia_no_audio_first: "请先录制或上传音频",
    historia_transcribe_done: "转录完成 ✓",
    historia_transcribe_failed: "转录失败",
    settings_export_link_sent: "链接已发送至 {EMAIL}。你有 60 分钟时间下载。",
    media_video_too_long: "视频过长。最长 60 分钟。",
    media_video_low_res: "视频分辨率较低（{W}×{H}）。仍可上传,但建议至少使用 720p 以保存更清晰的回忆。",
    media_audio_limit_30min: "已达到 30 分钟限制。",
    media_mic_denied: "麦克风权限被拒绝。请在浏览器设置中开启。",
    media_mic_failed: "无法开始录制。请检查麦克风。",
    media_file_too_large: "文件过大。最大 {MB}MB。",
    media_file_added: "文件已添加",
    media_file_uploaded: "✓ {NAME} 已上传",
    media_upload_failed: "文件上传失败",
    /* Bug 3 settings extra (auto-translated) */
    settings_export_link_failed: "无法发送链接。",
    settings_password_incorrect: "密码错误。",
    settings_unauthorized: "未授权。",
    settings_export_too_many_requests: "您请求的链接过多，请稍后再试。",
    settings_export_your_email_fallback: "您的邮箱",
    pol_demo_failed_default: "无法发送演示",
    /* Bug 3 set2 (auto-translated) */
    settings_portal_open_failed: "无法打开管理门户。如果您认为这是一个错误,请发送邮件至 support@keepsoul.app。",
    settings_export_failed: "导出失败。",
    settings_export_not_authorized: "未授权导出。",
    settings_export_quota_exhausted: "您已用尽今日的下载次数。请稍后再试。",
    /* Bug 3 auth pages (auto-translated) */
    auth_back_to_login: "返回登录",
    fp_title: "找回密码",
    fp_subtitle: "请输入你的邮箱地址,我们将向你发送重置密码的链接。",
    fp_email_label: "邮箱",
    fp_email_placeholder: "you@email.com",
    fp_sending: "发送中…",
    fp_send_cta: "发送说明",
    fp_check_email_title: "请查收邮件",
    fp_check_email_body_prefix: "如果",
    fp_check_email_body_suffix: "已注册,我们已向你发送重置密码的链接。请同时检查垃圾邮件文件夹。",
    fp_need_help: "需要帮助?",
    rp_missing_token: "链接中缺少恢复令牌。",
    rp_min_12: "密码至少需要12个字符",
    rp_need_lower: "必须包含至少一个小写字母",
    rp_need_upper: "必须包含至少一个大写字母",
    rp_need_digit: "必须包含至少一个数字",
    rp_need_symbol: "必须包含至少一个符号(!@#$...)",
    rp_mismatch: "两次输入的密码不一致",
    rp_success_toast: "密码更新成功",
    rp_link_expired: "此链接已过期,请申请新链接。",
    rp_link_used_or_invalid: "此链接已被使用或无效。",
    rp_update_failed: "无法更新密码。",
    rp_done_title: "完成!",
    rp_done_body: "密码更新成功。正在跳转到登录页…",
    rp_invalid_link_title: "链接无效",
    rp_request_new_link: "申请新链接",
    rp_new_password_h1: "新密码",
    rp_hint: "最少12个字符,包含大写字母、数字和一个符号。",
    rp_confirm_label: "确认密码",
    rp_updating: "更新中…",
    rp_update_cta: "更新密码",
    rp_new_password_label: "新密码",
    /* Premium relaunch + plans welcome (Iter 22) */
    plans_welcome_title: "账户已验证！选择您的方案",
    plans_welcome_sub: "如果您有优惠码,请在选择套餐前输入。",
    plans_skip_for_now: "暂时跳过",
    plans_discount_section_title: "有优惠码吗？",
    plans_discount_placeholder: "在此输入优惠码",
    plans_discount_apply: "应用",
    plans_discount_success_short: "优惠码已成功应用！",
    plans_discount_invalid_short: "优惠码无效",
    plans_personal_monthly_equiv_v2: "相当于每月 €5.83 — 免费赠送 2 个月",
    plans_yearly_save_v2: "每年节省 €14",
    /* Paywall (Iter 24) */
    paywall_title: "解锁 KeepSoul",
    paywall_body: "选择一个方案，开始守护最重要的一切：您的密码、信息和数字遗产。",
    paywall_cta: "查看方案",
    paywall_hint: "高级版 €39/年 · 终身版 €149",
    paywall_locked_badge: "已锁定",
    /* Vault auto-lock (Iter 29) */
    vault_lock_setting_title: "保险库自动锁定",
    vault_lock_setting_body: "在显示您的机密之前，我们会要求您再次输入 KeepSoul 密码，并在 X 分钟无操作后重新锁定保险库。",
    vault_lock_enabled: "已启用",
    vault_lock_disabled: "已停用",
    vault_lock_minutes_label: "锁定时间（分钟）：",
    vault_lock_title: "保险库已锁定",
    vault_lock_body: "为了安全，保险库在 {MIN} 分钟无操作后已锁定。请输入密码以再次查看。",
    vault_lock_pwd_placeholder: "您的 KeepSoul 密码",
    vault_lock_pwd_required: "请输入密码",
    vault_lock_pwd_wrong: "密码错误",
    vault_lock_no_password: "此帐户使用 Google 登录，没有本地密码",
    vault_lock_failed: "无法解锁，请重试",
    vault_lock_cta: "解锁",
    vault_lock_unlocking: "正在解锁…",

    /* Digital Assets — list/grid toggle (Iter 28) */
    da_view_grid: "卡片视图",
    da_view_list: "列表视图",
    da_list_empty: "尚未添加任何数字资产。可从银行账户或社交媒体开始。",
    da_list_col_name: "资产",
    da_list_col_category: "类别",
    da_list_col_heir: "指定继承人",
    da_list_no_heir: "未指定",

    /* Will & Executor (Iter 30) */
    nav_will: "遗嘱",
    nav_ice: "紧急情况",
    will_title: "遗嘱与遗嘱执行人",
    will_subtitle: "告诉家人法律遗嘱保存在何处，以及由谁负责执行。",
    will_info_banner: "KeepSoul 不会保存您的遗嘱本身。本页只是告诉家人在哪里能找到它，以及由谁执行。",
    will_exists_q: "是否有遗嘱？",
    will_exists_yes: "有",
    will_exists_no: "没有",
    will_exists_unknown: "不确定",
    will_location_label: "保管位置 / 保管人",
    will_location_ph: "López 公证处，Mayor 街 12 号，马德里 · 律师事务所 · 家中保险箱…",
    will_location_hint: "公证处、律师、实体存放位置或保管该文件的个人。",
    will_executor_section: "遗嘱执行人",
    will_executor_section_hint: "依法被指定执行您最后意愿的人。",
    will_executor_name: "全名",
    will_executor_relationship: "与您的关系",
    will_executor_relationship_ph: "姐妹、律师、密友…",
    will_executor_phone: "电话",
    will_executor_email: "邮箱",
    will_notes: "其他备注",
    will_notes_ph: "关于遗嘱或执行人的任何相关信息。",
    will_instructions_title: "对执行人的指示",
    will_instructions_hint: "用自由文字说明您希望执行人完成的事项。这些内容也会出现在 ICE 紧急文件中。",
    will_instructions_ph: "请先联系我的伴侣 María，然后打开我书桌上的信封…",
    saving: "保存中…",

    /* ICE Document (Iter 30) */
    ice_title: "紧急情况文件",
    ice_subtitle: "一份汇总文件，包含执行人和继承人需要知道的全部信息。",
    ice_print: "打印 / 保存为 PDF",
    ice_print_short: "保存 PDF",
    ice_warning: "本文件包含敏感信息。仅在必要时打印，并妥善保管。",
    ice_empty: "数据尚不充足。请先添加遗嘱、继承人或数字资产。",
    ice_cover_title: "所有人",
    ice_owner_name: "姓名",
    ice_owner_email: "邮箱",
    ice_generated_at: "生成时间",
    ice_will_title: "遗嘱与执行人",
    ice_will_missing: "所有人表明 没有 法律遗嘱。",
    ice_will_unknown: "所有人尚未说明是否存在遗嘱。",
    ice_no_executor: "尚未指定执行人。",
    ice_add_executor: "添加执行人",
    ice_instructions_title: "对执行人的指示",
    ice_no_instructions: "您尚未写下对执行人的指示。",
    ice_add_instructions: "撰写指示",
    ice_heirs_title: "继承人",
    ice_no_heirs: "尚未添加继承人。",
    ice_assets_title: "数字资产",
    ice_no_assets: "尚未添加数字资产。",
    ice_assets_note: "敏感数据（密码、密钥）不会显示在此处，仅保存在 KeepSoul 加密保险库中。",
    ice_vault_title: "保险库内容",
    ice_no_vault: "保险库为空。",
    ice_vault_note: "仅列出标题。加密内容通过 KeepSoul 交付给被指定的继承人。",
    ice_cat_bank: "银行账户",
    ice_cat_social: "社交媒体",
    ice_cat_crypto: "加密货币",
    ice_cat_email: "邮箱账户",
    ice_cat_device: "设备",
    ice_cat_insurance: "保险与养老金",
    ice_cat_other: "其他",

    /* Physical documents (Iter 30 follow-up) */
    will_phys_title: "重要的纸质文件",
    will_phys_hint: "身份证/护照、房契、纸质保单、原始证书…… 只需说明 在哪里 保管，切勿将文件本身存放在此处。",
    will_phys_add: "添加文件",
    will_phys_empty: "尚未列出任何纸质文件。",
    will_phys_doc_label: "文件",
    will_phys_doc_ph: "身份证 · 房产证 · MAPFRE 寿险保单…",
    will_phys_loc_label: "存放位置 / 保管人",
    will_phys_loc_ph: "书桌最上方抽屉 · BBVA 银行保险柜 · López 公证处…",
    will_phys_notes_label: "备注",
    will_phys_notes_ph: "备用钥匙在阳台花盆里，密码 1234…",
    ice_phys_title: "重要的纸质文件",
    ice_no_phys: "尚未列出任何纸质文件。",
    ice_add_phys: "添加文件",
    ice_phys_loc: "位置",
    delete: "删除",

    /* ICE Editor — Phase 2 (Iter 31) */
    yes: "是",
    no: "否",
    will_no_will_warning: "若没有遗嘱,指定遗嘱执行人可能需要法律程序的批准。建议您与专业人士(公证人或律师)一同立下遗嘱。",
    ice_legal_notice: "本文件 不是 遗嘱。您应另外立一份正式遗嘱。本文件仅协助执行人查找必要信息。法律遗嘱与当地法律始终具有最终权威。",
    ice_mode_edit: "编辑",
    ice_mode_summary: "摘要",
    ice_sec_personal: "个人资料",
    ice_sec_personal_hint: "基本身份信息。",
    ice_p_full_name: "全名",
    ice_p_id_number: "身份证 / 证件号码",
    ice_p_phone_home: "家庭电话",
    ice_p_phone_work: "工作 / 手机",
    ice_p_passport: "护照",
    ice_p_nationality: "国籍",
    ice_p_residence: "居住地",
    ice_p_email: "邮箱",
    ice_sec_marital: "婚姻状况与配偶",
    ice_sec_marital_hint: "您配偶或现任伴侣的资料。",
    ice_m_status: "婚姻状况",
    ice_m_status_ph: "未婚、已婚、事实伴侣、离异、丧偶……",
    ice_m_spouse_name: "配偶 / 伴侣姓名",
    ice_m_spouse_id: "配偶 / 伴侣证件号",
    ice_m_spouse_phone: "电话",
    ice_m_spouse_email: "邮箱",
    ice_sec_divorce: "前次离婚(如适用)",
    ice_sec_divorce_hint: "离婚协议或判决书的存放位置。",
    ice_d_agreement_location: "离婚协议存放位置",
    ice_d_agreement_ph: "档案柜中的法律文件夹 · X 律师事务所 · 第 X 法院……",
    ice_d_notes: "备注",
    ice_sec_heir_overrides: "需通知的家人与联系人",
    ice_sec_heir_overrides_hint: "复用您已添加的继承人。请指明是否要通知他们以及他们将根据遗嘱继承什么。",
    ice_no_heirs_yet: "您尚未添加继承人。请在「继承人」页面添加。",
    ice_h_notify: "通知",
    ice_h_bequest: "根据遗嘱继承内容(可选)",
    ice_h_bequest_ph: "家族房屋、账户的 50%、母亲的珠宝……",
    ice_h_bequest_short: "继承",
    ice_h_do_not_notify: "不要通知",
    ice_sec_children: "子女",
    ice_sec_children_hint: "每位子女的姓名和联系方式。",
    ice_c_name: "姓名",
    ice_c_contact: "联系方式",
    ice_c_contact_ph: "电话 / 邮箱",
    ice_c_add: "添加子女",
    ice_c_empty: "尚未添加子女。",
    ice_sec_guardians: "子女的法定监护人",
    ice_sec_guardians_hint: "若您不在,谁会照顾您未成年的子女。",
    ice_g_name: "姓名",
    ice_g_contact: "联系方式",
    ice_g_add: "添加监护人",
    ice_g_empty: "尚未添加监护人。",
    ice_sec_staff: "家政人员(可选)",
    ice_sec_staff_hint: "与您一同工作或在家中工作的人员。",
    ice_s_name: "姓名",
    ice_s_contact: "联系方式",
    ice_s_contact_ph: "电话 / 邮箱 · 工作类型",
    ice_s_add: "添加",
    ice_s_empty: "无条目。",
    ice_sec_pro_contacts: "专业联系人",
    ice_sec_pro_contacts_hint: "医生、律师、财务顾问 / 会计师。",
    ice_pro_doctor: "医生",
    ice_pro_lawyer: "律师",
    ice_pro_advisor: "财务顾问 / 会计师",
    ice_pro_name: "姓名",
    ice_pro_contact: "电话",
    ice_pro_email: "邮箱",
    ice_sec_medical: "医疗资料",
    ice_sec_medical_hint: "急诊医生可能需要的信息。",
    ice_med_insurance: "医疗保险",
    ice_med_member_id: "会员 / 保单号",
    ice_med_blood_type: "血型",
    ice_med_living_will: "是否有生前遗嘱?",
    ice_med_living_will_unknown: "不确定",
    ice_sec_banks: "财务资料 — 银行",
    ice_sec_banks_hint: "仅填写机构和参考号。凭证仅保存在加密保险库中。",
    ice_b_entity: "机构",
    ice_b_reference: "参考号",
    ice_b_auto_payments: "需取消的自动扣款",
    ice_b_auto_payments_ph: "Netflix、Spotify、健身房、房贷……",
    ice_b_add: "添加账户",
    ice_b_empty: "尚未添加银行账户。",
    ice_b_no_creds: "切勿在此处填写密码、密钥或 PIN。仅填写机构和参考号。",
    ice_sec_investments: "财务资料 — 投资",
    ice_sec_investments_hint: "股票、基金、债券、加密货币、房地产……",
    ice_inv_type: "类型",
    ice_inv_type_ph: "股票、基金、加密货币、房产……",
    ice_inv_platform: "平台 / 机构",
    ice_inv_reference: "参考号",
    ice_inv_add: "添加投资",
    ice_inv_empty: "尚未添加投资。",
    ice_sec_valuables: "资产、珠宝及收藏品",
    ice_sec_valuables_hint: "描述及估值(自由文本)。",
    ice_v_description: "描述",
    ice_v_description_ph: "祖父传下的怀表 · 有签名的 Sorolla 画作……",
    ice_v_estimated_value: "估值",
    ice_v_location: "位置",
    ice_v_add: "添加",
    ice_v_empty: "无条目。",
    ice_sec_credentials: "凭证与访问位置",
    ice_sec_credentials_hint: "您把密码 存放在何处 ,以及执行人 如何 才能访问。切勿在此填写密码本身。",
    ice_cred_type: "密码管理方式",
    ice_cred_type_choose: "请选择……",
    ice_cred_type_pm: "密码管理器 (1Password、Bitwarden、LastPass…)",
    ice_cred_type_browser: "浏览器管理 (Chrome、Safari…)",
    ice_cred_type_paper: "纸上记录",
    ice_cred_type_memory: "仅在记忆中",
    ice_cred_type_mixed: "混合方式",
    ice_cred_where: "存放位置",
    ice_cred_where_ph: "1Password,邮箱 juan@... — 主密钥放在公证处的密封信封中 · 卧室抽屉里的蓝色笔记本……",
    ice_cred_how_to_access: "执行人如何访问",
    ice_cred_how_to_access_ph: "我的伴侣 María 知道主密钥。恢复码信封在 López 公证处……",
    ice_cred_warning: "重要:KeepSoul 在此处 不应 包含您真实的密码。本字段仅用于描述执行人 在哪里 和 如何 访问,而非密码本身。",
    ice_sec_social: "社交媒体",
    ice_sec_social_hint: "平台和用户名(不要填写密码)。",
    ice_soc_platform: "平台",
    ice_soc_username: "用户名",
    ice_soc_add: "添加",
    ice_soc_empty: "无条目。",
    ice_sec_funeral: "葬礼安排(可选)",
    ice_sec_funeral_hint: "您对葬礼的愿望。",
    ice_funeral_ph: "火化、不要献花、播放 Coldplay 的音乐……",
    ice_funeral_priority: "提示:若存在遗嘱,遗嘱优先于这些愿望。",
    ice_sec_notes: "其他备注",
    ice_sec_notes_hint: "您想以书面留下的其他任何事项。",

    /* Inline validation messages (Iter 32) */
    val_invalid_email: "邮箱无效",
    val_invalid_phone: "电话号码无效",

    /* Progress indicator (Iter 32) */
    ice_progress_label: "完成度",
    ice_progress_hint: "您填写的章节越多,这份文件对您的执行人就越有用。",
    ice_progress_done: "文件已完成。建议每 6 个月检查一次。",

    /* Share with executor (Iter 32) */
    ice_share_btn: "发送给执行人",
    ice_share_modal_title: "发送给执行人",
    ice_share_modal_intro: "已将链接邮件发送至 {email}。要打开文件,他们需要下面的 6 位数字密码。",
    ice_share_code_label: "一次性访问密码",
    ice_share_code_warning: "⚠️ 请勿通过邮件发送此密码。请通过电话或当面告知您的执行人。没有该密码,链接无效。",
    ice_share_modal_link: "链接",
    ice_share_modal_expires: "有效期",
    ice_share_done: "完成",
    ice_share_err_no_executor: "请先在「遗嘱」页面设置执行人的邮箱。",
    ice_share_err_generic: "无法创建链接,请重试。",
    ice_share_err_code_required: "请输入 6 位数字密码。",
    ice_share_err_invalid_code: "密码错误。",
    ice_share_err_not_found: "该链接不存在或已被撤销。",
    ice_share_err_expired: "该链接已过期。",
    ice_share_gate_title: "紧急情况文件",
    ice_share_gate_intro: "所有人已通过邮件向您发送了此链接。要打开文件,请输入他们另外提供的 6 位数字密码(通过电话或当面)。",
    ice_share_gate_footer: "如果密码错误 5 次,链接将自动失效,需要重新发送新的链接。",
    ice_share_open: "打开文件",
    ice_share_viewing: "您正在以此身份查看文件",
    copy: "复制",
    copied: "已复制",

    ice_checklist_title: "执行人的后续步骤",
    ice_checklist_intro: "最常见事务的指导。请根据实际情况和当地法律进行调整。",
    ice_checklist_immediate: "立即(48 小时内)",
    ice_checklist_week: "第一周",
    ice_checklist_month: "第一个月",
    ice_checklist_c_imm_1: "申请数份死亡证明(至少 5 份)— 几乎每个步骤都会用到。",
    ice_checklist_c_imm_2: "联系本文件中列出的家属,并按所有人的意愿通知他们。",
    ice_checklist_c_imm_3: "联系殡葬服务并尊重所列的葬礼意愿(如有)。",
    ice_checklist_c_imm_4: "在指定位置找到遗嘱,并交给公证人/律师。",
    ice_checklist_c_wk_1: "通知医疗保险及社会保险。",
    ice_checklist_c_wk_2: "通知主要银行 — 在遗产处理完成前可能会冻结账户。",
    ice_checklist_c_wk_3: "取消列出的自动扣款(Netflix、健身房等)。",
    ice_checklist_c_wk_4: "如已列出,联系所有人的律师以开始继承程序。",
    ice_checklist_c_mo_1: "与公证人和列出的继承人办理继承手续。",
    ice_checklist_c_mo_2: "根据所有人的意愿关闭或纪念其社交媒体账户。",
    ice_checklist_c_mo_3: "访问 KeepSoul 保险库 — 根据凭证说明恢复密码。",
    ice_checklist_c_mo_4: "取消仍在使用的信用卡、订阅和服务。",
    ice_checklist_footer: "本清单不构成法律建议。涉及法律步骤请始终咨询专业人士。",

    /* Active shares panel (Iter 33) */
    ice_shares_panel_title: "已分享的链接",
    ice_shares_empty: "您还没有将文件发送给任何执行人。",
    ice_shares_col_sent: "发送时间",
    ice_shares_col_expires: "到期时间",
    ice_shares_col_views: "查看次数",
    ice_shares_col_failed: "密码错误次数",
    ice_share_status_active: "有效",
    ice_share_status_expired: "已过期",
    ice_share_status_revoked: "已撤销",
    ice_share_status_expired_hint: "已过期 — 如有需要请创建新的链接。",
    ice_share_revoke: "撤销",
    ice_share_revoke_title: "撤销此链接?",
    ice_share_revoke_intro: "执行人将无法再使用此链接打开文件,即使输入正确密码也不行。该操作立即生效且不可撤销。",
    ice_share_revoke_yes: "是的,撤销",
    ice_share_revoke_cancel: "取消",
    ice_share_revoked_toast: "链接已撤销",
    refresh: "刷新",
},
  ko: {
    brand_tagline: "가장 소중한 것을 지키세요",
    nav_features: "기능",
    nav_pricing: "요금제",
    nav_about: "소개",
    nav_login: "로그인",
    cta_start: "시작하기",
    cta_secure_legacy: "유산을 안전하게",
    cta_learn: "더 알아보기",
    hero_title_1: "당신의 유산을,",
    hero_title_2: "영원히 간직하세요.",
    hero_sub: "암호화 금고, 미래 메시지, 생존 확인, 디지털 상속을 통합한 세계 최초의 플랫폼. 가장 소중한 것은 결코 잃지 않습니다.",
    section_problem_label: "문제",
    section_problem_title: "잃어버린 것은 돌아오지 않습니다.",
    section_problem_body: "매년 수백만 가족이 비밀번호, 사진, 암호화폐, 디지털 추억을 영원히 잃습니다. 지금까지 완전한 해결책은 없었습니다.",
    stat_crypto: "잃어버린 암호화폐",
    stat_families: "계정 접근권을 잃은 가족",
    stat_planning: "디지털 계획이 없음",
    section_solution_label: "해결책",
    section_solution_title: "하나의 플랫폼. 모든 것을 보호합니다.",
    feature_vault: "금고",
    feature_vault_d: "AES-256으로 암호화된 비밀번호, 문서, 비밀. 사망 시에만 공개되는 캡슐 모드.",
    feature_messages: "미래 메시지",
    feature_messages_d: "특정 날짜, 사망 시 또는 가족 역사로 전달되는 텍스트, 오디오, 비디오.",
    feature_heirs: "디지털 상속",
    feature_heirs_d: "은행 계좌, 암호화폐, 소셜 미디어, 기기를 상속인에게 자동으로 전달.",
    feature_pol: "생존 확인",
    feature_pol_d: "당신이 더 이상 없을 때 모든 것을 자동으로 활성화하는 시스템.",
    pricing_title: "당신에게 맞는 요금제",
    plan_free: "무료",
    plan_personal: "프리미엄",
    plan_lifetime: "평생",
    plan_popular: "가장 인기",
    dash_welcome: "환영합니다",
    dash_quickactions: "빠른 작업",
    dash_pol: "생존 확인",
    dash_pol_next: "다음 확인",
    dash_pol_checkin: "생존 확인하기",
    dash_status_alive: "활성",
    dash_status_pending: "대기 중",
    pol_state_active: "활성",
    pol_state_pending: "확인 대기",
    pol_state_grace: "유예 기간",
    pol_state_overdue: "기한 초과",

    /* Plans — updated feature list (Iter 34) */
    pricing_top_tier_owned: "이미 최상위 플랜을 보유 중입니다",
    feat_vault: "암호화 금고 (AES-256) 최대 50개 항목",
    feat_vault_unlimited: "무제한 암호화 금고 (AES-256)",
    feat_messages: "미래의 메시지(텍스트·음성·동영상·파일) 최대 20개",
    feat_messages_unlimited: "무제한 미래의 메시지(텍스트·음성·동영상·파일)",
    feat_heirs: "최대 5명의 상속인, 비율 분배",
    feat_heirs_unlimited: "무제한 상속인, 비율 분배",
    feat_contacts: "신뢰할 수 있는 연락처",
    feat_assets: "디지털 자산(은행·암호화폐·소셜·기기) 최대 30개",
    feat_assets_unlimited: "무제한 디지털 자산(은행·암호화폐·소셜·기기)",
    feat_pol: "완전한 생존 확인",
    feat_pol_full: "완전한 생존 확인 및 알림",
    feat_will: "유언장과 집행인",
    feat_ice: "비상시 안내 문서(ICE), 20개 섹션",
    feat_ice_full: "완전한 비상시 안내 문서(ICE), 20개 섹션",
    feat_ice_pdf: "ICE를 PDF로 내보내기",
    feat_share: "검증 코드를 통한 집행인에게 안전한 전송",
    feat_share_panel: "공유 링크 패널, 취소 가능",
    feat_export_gdpr: "전체 데이터 내보내기 (GDPR 제20조)",
    pricing_lifetime_founders_badge: "창립 멤버 에디션 · 좌석 한정",
    plan_free_sub: "무료로 시작하세요, 카드 필요 없음",
    plan_free_billed_never: "결제 없음 · 카드 없음",
    plan_free_cta_default: "현재 요금제",
    plan_free_cta_signup: "무료로 시작",
    plan_free_feat_vault: "암호화 금고 AES-256 (5개 항목)",
    plan_free_feat_pol: "완전한 생존 확인",
    plan_free_feat_heir: "상속인 1명",
    plan_free_feat_contact: "신뢰 연락처 1명",
    plan_free_feat_assets: "디지털 자산 3개",
    plan_free_feat_storage: "저장 공간 1 GB",
    plan_free_feat_messages_blocked: "미래의 메시지",
    plan_free_feat_ice_blocked: "비상시 안내 문서 (ICE)",
    plan_free_feat_will_blocked: "유언과 집행인",
    plans_cancel_anytime: "언제든 취소",
    pricing_per_month_short: "/월",
    plans_native_billing_notice: "요금제는 keepsoul.app에서 관리하세요 · 요금제를 선택하면 브라우저에서 열립니다.",
    feat_contacts_unlimited: "무제한 신뢰 연락처",
    feat_assets_unlimited_v2: "무제한 디지털 자산(은행, 암호화폐, 소셜, 기기, 보험)",
    feat_pol_configurable: "완전하고 구성 가능한 생존 확인",
    feat_executor_checklist: "집행인을 위한 가이드 체크리스트",
    feat_storage_premium: "암호화 저장 공간: 10 GB",
    feat_storage_lifetime: "암호화 저장 공간: 25 GB",
    feat_languages: "4개 언어 (ES, EN, ZH, KO)",
    feature_will: "유언과 집행인",
    feature_will_d:
      "집행인을 지정하고 법적 지시 사항을 작성한 뒤 인증 코드로 안전하게 전달하세요.",
    feature_ice: "비상시 안내 문서 (ICE)",
    feature_ice_d:
      "20개 섹션의 완전한 문서, PDF 내보내기 및 취소 가능한 공유 링크 패널 포함.",
    nav_dashboard: "홈",
    nav_vault: "금고",
    nav_messages: "메시지",
    nav_pol: "생존 확인",
    nav_heirs: "상속",
    nav_assets: "디지털 자산",
    nav_capsule: "캡슐",
    nav_historia: "이야기",
    nav_settings: "설정",
    nav_logout: "로그아웃",
    vault_title: "금고",
    vault_subtitle: "가장 소중한 비밀을 영원히 암호화하여 보관하세요.",
    vault_add: "금고에 추가",
    vault_empty: "금고가 비어 있습니다. 가장 소중한 것을 저장하며 시작하세요.",
    cat_password: "비밀번호",
    cat_document: "문서",
    cat_photo: "사진 / 추억",
    cat_crypto: "암호화폐",
    cat_asset: "자산",
    msg_title: "미래 메시지",
    msg_subtitle: "오늘 작성하세요. 시간이 직접 전달합니다.",
    msg_add: "메시지 작성",
    msg_empty: "예약된 메시지가 없습니다.",
    msg_recipient: "수신인 이름",
    msg_recipient_email: "수신인 이메일",
    msg_subject: "제목",
    msg_body: "메시지",
    msg_date: "전달 날짜",
    msg_type_label: "메시지 유형",
    msg_cat_date_label: "특정 날짜",
    msg_cat_date_hint: "생일, 결혼기념일, 중요한 날…",
    msg_cat_death_label: "내가 세상을 떠날 때",
    msg_cat_death_hint: "생존 증명이 사망을 확인하면 전달됩니다.",
    msg_cat_historia_label: "가족사",
    msg_cat_historia_hint: "기억, 일화, 삶의 순간. 상속인이 받을 기록의 일부입니다.",
    msg_date_required: "전달 날짜를 선택하세요",
    msg_assign_heirs_label: "상속인도 포함",
    heir_title: "상속인",
    heir_subtitle: "당신의 디지털 유산을 누가, 어떻게 받을지 결정하세요.",
    heir_add: "상속인 추가",
    heir_relationship: "관계",
    heir_share: "상속 비율",
    heir_empty: "아직 상속인이 등록되지 않았습니다.",
    heir_relationship_ph: "아들, 아내, 형제…",
    heir_emails_label: "상속인 이메일 (안전을 위해 여러 개 추가)",
    heir_email_primary_ph: "기본 이메일",
    heir_email_backup_ph: "보조 이메일",
    heir_email_primary_tag: "기본",
    heir_remove_email: "이메일 삭제",
    heir_add_email: "이메일 추가",
    heir_emails_help: "안전을 위해 모든 이메일로 유산이 전송됩니다.",
    heir_phone_label: "SMS 전화번호",
    heir_phone_view_label: "전화번호 (SMS 백업)",
    heir_at_least_one_email: "최소 1개의 이메일 추가",
    heir_email_invalid: "유효하지 않은 이메일: {EMAIL}",
    heir_share_range_err: "비율은 1에서 100 사이여야 합니다.",
    heir_share_overflow_err: "유산의 100%를 초과했습니다. 사용 가능: {REMAINING}%.",
    heir_share_assigned: "할당됨: {N}%",
    heir_share_remaining: "남은 비율: {N}%",
    heir_share_warning: "총합이 100%가 되지 않았습니다 ({N}% 남음).",
    heir_share_available: "(사용 가능: {N}%)",
    heir_notify_label: "지금 이메일로 상속인에게 알림",
    heir_notify_help: "기본적으로 아무것도 발송되지 않습니다. 활성화하면 이 분에게 귀하가 디지털 유산 계획에 포함시켰음을 알리는 중립적인 이메일이 발송됩니다. 내용은 공개되지 않습니다.",
    heir_status_complete: "완료",
    heir_status_pending: "대기 중",
    heir_emails_count: "이메일",
    heir_tooltip_emails: "설정된 이메일",
    heir_tooltip_sms: "SMS 백업",
    heir_tooltip_farewell: "작별 메시지",
    heir_tooltip_assets: "디지털 자산",
    heir_tooltip_vault: "금고 항목",
    heir_tooltip_messages: "메시지",
    heir_tooltip_capsule: "캡슐",
    heir_farewell_title: "작별 메시지",
    heir_farewell_desc: "귀하가 떠난 후 가장 먼저 받게 될 것입니다. 오디오, 비디오, 텍스트 또는 개인 파일을 첨부할 수 있습니다.",
    heir_farewell_input_label: "작별 인사",
    heir_nothing_assigned: "아직 아무것도 할당하지 않으셨습니다. 금고, 메시지, 캡슐 또는 디지털 자산으로 이동하여 {NAME}님을 선택해 주세요.",
    heir_will_receive: "자동으로 받게 됩니다",
    heir_assigned_assets: "디지털 자산",
    heir_assigned_vault: "보관함에서",
    heir_assigned_messages: "메시지",
    heir_assigned_capsule: "캡슐",
    heir_link_digital_assets: "디지털 자산",
    vault_category_label: "카테고리",
    vault_capsule_badge: "캡슐",
    vault_capsule_tooltip: "캡슐 — 사망 후에만 공개",
    media_kind_text: "텍스트",
    media_kind_audio: "음성",
    media_kind_video: "영상",
    media_kind_file: "파일",
    contacts_title: "신뢰할 수 있는 연락처",
    contacts_subtitle: "이 분들이 당신이 응답하지 않을 때 생존 확인을 진행합니다.",
    contacts_add: "연락처 추가",
    contacts_empty_title: "아직 신뢰할 수 있는 연락처가 없습니다",
    contacts_empty_body: "신뢰할 수 있는 연락처가 없으면 시스템이 자동으로 유산 상속을 활성화할 수 없습니다. 가까운 가족, 친한 친구 또는 변호사 등 당신이 생존 확인에 응답하지 않을 때 당신의 상태를 확인할 수 있는 신뢰할 수 있는 사람을 최소 2명 이상 추가해 주세요.",
    capsule_title: "핵심 캡슐",
    capsule_subtitle: "당신이 떠난 후에만 공개되는 내용. 당신의 마지막 포옹.",
    capsule_add: "내용 봉인하기",
    historia_title: "스토리",
    historia_subtitle: "목소리와 이야기를 기록하세요. 절대 잊히지 않도록.",
    historia_add: "새 항목",
    pol_title: "생존 증명",
    pol_subtitle: "시스템의 핵심입니다.",
    pol_interval: "주기(일)",
    pol_save: "저장",
    pol_last: "마지막 확인",
    pol_next: "다음 확인",
    save: "저장",
    cancel: "취소",
    delete: "삭제",
    confirm: "확인",
    add: "추가",
    close: "닫기",
    edit: "수정",
    view: "보기",
    show: "표시",
    hide: "숨기기",
    copy: "복사",
    copied: "복사됨",
    saved: "저장됨",
    deleted: "삭제됨",
    confirm_delete: "이 항목을 삭제하시겠습니까? 되돌릴 수 없습니다.",
    name: "이름",
    email: "이메일",
    phone: "전화번호",
    title: "제목",
    notes: "메모",
    content: "내용",
    username: "사용자명",
    url: "URL / 웹사이트",
    optional: "선택사항",
    created_at: "생성일",
    plan_current: "현재 플랜",
    plan_change: "플랜 변경",
    plan_view: "플랜 보기",
    plan_active: "활성 플랜",
    plan_select: "선택",
    plans_title: "요금제 선택",
    plans_sub: "언제든 변경 가능. 소중한 것은 안전하게.",
    plan_saved: "플랜이 업데이트되었습니다",
    login_title: "KeepSoul 입장",
    login_sub: "당신의 유산이 기다리고 있습니다. 이메일 또는 Google로 로그인하세요.",
    login_google: "Google로 계속하기",
    login_secure: "은행급 암호화로 보호됩니다. AES-256 암호화.",
    login_create: "계정 만들기",
    login_create_sub: "가장 소중한 것을 보호하세요",
    auth_name: "이름",
    auth_email: "이메일",
    auth_password: "비밀번호",
    auth_min8: "최소 8자",
    auth_password_hint: "대문자, 숫자, 기호를 포함한 최소 12자",
    auth_signup_btn: "계정 만들기",
    auth_login_btn: "로그인",
    auth_have_account: "이미 계정이 있으신가요? 로그인",
    auth_no_account: "계정이 없으신가요?",
    auth_welcome: "다시 오신 것을 환영합니다",
    auth_created: "계정이 생성되었습니다!",
    auth_forgot: "비밀번호를 잊으셨나요?",
    auth_continue_google: "Google로 계속하기",
    auth_need_help: "도움이 필요하신가요?",
    auth_generic_error: "오류가 발생했습니다. 다시 시도해 주세요.",
    consent_terms_required: "계정을 생성하려면 이용약관에 동의해야 합니다.",
    consent_privacy_required: "계정을 생성하려면 개인정보 처리방침에 동의해야 합니다.",
    consent_terms_label: "다음을 읽고 동의합니다",
    consent_terms_link: "이용약관",
    consent_privacy_label: "다음을 읽고 동의합니다",
    consent_privacy_link: "개인정보 처리방침",
    consent_marketing_label: "KeepSoul로부터 마케팅 정보 수신에 동의합니다 (선택).",
    cookie_banner_title: "개인정보 및 쿠키",
    cookie_banner_msg: "앱 작동에 필수적인 쿠키만 사용합니다. 분석이나 광고 쿠키는 기본적으로 사용하지 않습니다. 허용할 항목을 선택하실 수 있습니다.",
    cookie_banner_more: "쿠키 정책 보기",
    cookie_accept_all: "모두 허용",
    cookie_reject_all: "모두 거부",
    cookie_configure: "설정",
    cookie_modal_title: "쿠키 설정",
    cookie_modal_intro: "허용할 쿠키를 선택해 주세요. 필수 쿠키는 서비스 운영에 필수적이므로 비활성화할 수 없습니다.",
    cookie_cat_necessary: "필수 쿠키",
    cookie_cat_necessary_desc: "로그인, 언어 선택 및 쿠키 동의 기억에 필수적입니다. 비활성화할 수 없습니다.",
    cookie_cat_analytics: "분석 쿠키",
    cookie_cat_analytics_desc: "익명으로 사이트 사용을 측정하여 개선할 수 있도록 합니다. 현재 사용하지 않으나 향후 귀하의 동의 하에 활성화될 수 있습니다.",
    cookie_always_on: "항상 사용",
    cookie_save_prefs: "설정 저장",
    auth_session_lost: "계정이 생성되었으나 자동 로그인에 실패했습니다. 이메일과 비밀번호로 직접 로그인해 주세요.",
    setup_title: "나의 유산",
    setup_complete: "완료",
    setup_step_vault: "보관함에 첫 비밀번호 추가",
    setup_step_msg: "첫 미래 메시지 예약",
    setup_step_heir: "최소 1명의 상속인 지정",
    setup_step_contact: "신뢰할 수 있는 연락처 추가",
    setup_step_assign: "상속인에게 항목 배정",
    setup_step_pol: "생존 증명 설정",
    tour_title: "KeepSoul에 오신 것을 환영합니다",
    tour_sub: "30초 안에 디지털 유산 작동 방식을 설명해 드립니다",
    tour_step1_t: "당신의 금고",
    tour_step1_d: "비밀번호, 암호화폐 키, 중요한 문서를 보관하세요.",
    tour_step2_t: "미래 메시지",
    tour_step2_d: "사랑하는 사람들에게 떠난 후 전달될 메시지를 예약하세요.",
    tour_step3_t: "상속인",
    tour_step3_d: "누가 무엇을, 어떻게 받을지 결정하세요.",
    tour_step4_t: "생존 확인",
    tour_step4_d: "정기적으로 살아있음을 확인하세요. 그렇지 않으면 유산 프로토콜이 활성화됩니다.",
    tour_cta: "설정 시작하기",
    tour_skip: "튜토리얼 건너뛰기",
    tour_back: "이전",
    tour_next: "다음",
    install_title: "KeepSoul 설치",
    install_sub: "홈 화면에서 한 번에 열기",
    install_btn: "앱 설치",
    install_ios_title: "iOS에 설치",
    install_ios_steps: "1) 하단의 '공유' 버튼을 탭하세요  2) '홈 화면에 추가'를 선택하세요",
    save_success: "보관함에 저장됨",
    saved_secure: "암호화되어 안전함",
    landing_compare_title: "KeepSoul이 특별한 이유",
    landing_compare_sub: "모든 것을 결합한 유일한 플랫폼.",
    cta_final_title: "되돌릴 수 없는 것들이 있습니다.",
    cta_final_sub: "하지만 보존할 수 있습니다. 오늘 시작하세요.",
    pricing_no_card: "시작 시 카드 불필요 · 자동 갱신 없음 · 언제든 취소",
    pricing_start_free: "결정 전에 KeepSoul 체험",
    pricing_personal_sub: "대부분의 KeepSoul 사용자가 선택",
    plans_personal_monthly_equiv: "월 €3.25 — 커피 한 잔보다 저렴합니다",
    plans_free_explore_hint: "플랫폼 탐색을 위해 설계되었습니다. 준비되면 Personal로 업그레이드하세요.",
    pricing_lifetime_label: "평생",
    pricing_lifetime_launch: "🔥 출시 기념",
    pricing_lifetime_sub: "1회 결제 — 갱신 없음",
    pricing_lifetime_once: " 1회 결제",
    pricing_lifetime_limited: "창립 멤버 100명 한정",
    pricing_per_month: "/월",
    pricing_per_year: "/년",
    pricing_billed_annually: "연간 결제",
    pricing_billed_monthly: "월간 결제",
    pricing_billed_once: "1회 결제",
    msg_no_body: "이 메시지에는 미디어 콘텐츠만 포함되어 있습니다.",
    msg_your_message: "당신의 메시지",
    msg_attachment_label: "첨부 파일",
    auth_show_password: "비밀번호 표시",
    auth_hide_password: "비밀번호 숨기기",
    pol_banner_active: "활성",
    pol_banner_active_sub: "당신의 유산이 보호되고 있습니다. 다음 확인: {DATE}.",
    pol_banner_due: "곧 확인이 필요합니다!",
    pol_banner_due_sub: "활성화를 방지하려면 {DATE} 전에 생존을 확인하세요.",
    pol_banner_risk: "⚠ 유산이 활성화될 수 있습니다",
    pol_banner_risk_sub: "예상보다 더 많은 날이 지났습니다. 지금 확인하세요.",
    pol_banner_cta: "생존 확인",
    pol_banner_config: "설정 →",
    pol_view_details: "자세히 보기 →",
    pricing_save_yearly: "연간 {AMOUNT} 절약",
    pricing_billing_monthly: "월간",
    pricing_billing_annual: "연간",
    pricing_lifetime_savings: "(월간 요금제 38년분에 해당)",
    pricing_cta_start_free: "무료로 시작",
    pricing_cta_start_personal: "프리미엄 시작",
    pricing_cta_claim_lifetime: "평생 요금제 신청",
    pricing_cta_lifetime_short: "신청하기",
    pricing_current: "현재 요금제",
    pricing_lifetime_permanent: "영구 요금제입니다",
    pricing_cancel_from_settings: "설정에서 취소",
    pricing_change_via_support: "요금제 변경은 고객지원을 통해",
    pricing_sold_out: "매진",
    pricing_legal: "모든 가격은 세금 포함 · 설정에서 언제든 취소 · AES-256 암호화 · GDPR",
    pricing_lifetime_slots: "{TOTAL}석 중 {N}석 남음",
    plans_popular: "가장 인기",
    plans_lifetime_feat_1: "모든 Personal 기능, 평생",
    plans_lifetime_feat_2: "월 결제 없음",
    plans_lifetime_feat_3: "KeepSoul 창립 멤버 자격",
    plans_lifetime_feat_4: "신규 기능 우선 이용",
    plans_free_feat_1: "보관함 항목 3개",
    plans_free_feat_2: "미래 메시지 1개",
    plans_free_feat_3: "상속인 1명",
    plans_free_feat_4: "기본 생존 증명",
    plans_free_feat_5: "100 MB",
    plans_free_feat_6: "신뢰 연락처 2명",
    plans_free_feat_7: "저장공간 100 MB",
    plans_personal_feat_1: "보관함 100개 항목",
    plans_personal_feat_2: "미래 메시지 20개",
    plans_personal_feat_3: "상속인 3명",
    plans_personal_feat_4: "디지털 자산 전체",
    plans_personal_feat_5: "저장공간 10GB",
    plans_personal_feat_6: "연락처 무제한",
    plans_personal_feat_7: "신뢰 연락처 5명",
    plans_personal_feat_8: "디지털 자산 30개",
    plans_personal_feat_9: "생존 증명 전체",
    plans_lifetime_full_feat_1: "모든 기능 무제한 — 제약 없음",
    plans_lifetime_full_feat_2: "보관함, 메시지, 상속인, 자산 무제한",
    plans_lifetime_full_feat_3: "월 결제 없음",
    plans_lifetime_full_feat_4: "{N}명 한정",
    plans_lifetime_full_feat_5: "신규 기능 우선 이용",
    plans_lifetime_full_feat_6: "KeepSoul 창립 멤버 자격",
    plans_lifetime_sold_out_msg: "매진 — 곧 다시 확인하세요",
    plans_lifetime_slots_avail: "🔥 {TOTAL}석 중 {N}석 남음",
    plans_lifetime_payment_once: "1회 결제 — 갱신 없음",
    plans_billing_annual_save: "-17%",
    discount_have_code: "할인 코드가 있으신가요? (선택사항)",
    discount_applied: "코드 적용됨:",
    discount_full_free: "100% 무료!",
    discount_apply: "적용",
    discount_validating: "확인 중…",
    discount_will_apply: "선택하신 플랜에 코드가 적용됩니다.",
    setup_progress_title: "나의 유산",
    setup_progress_done: "완료",
    setup_pct_remaining: "{N}% 남음",
    setup_done_msg: "완료되었습니다! 유산 설정이 모두 끝났습니다.",
    dh_title: "유산 건강도",
    dh_status_excellent: "완벽함",
    dh_status_good: "양호함",
    dh_status_attention: "주의 필요",
    dh_status_critical: "위험",
    dh_heir_no_msg: "작별 메시지가 없는 상속인 {N}명",
    dh_heir_no_msg_plural: "작별 메시지가 없는 상속인 {N}명",
    dh_heir_no_msg_sub: "개인적인 메시지를 받을 수 있도록 몇 마디 남겨보세요.",
    dh_heir_no_msg_cta: "상속인으로 이동",
    dh_few_contacts: "신뢰 연락처 {N}명",
    dh_few_contacts_sub: "의심스러운 상황에 대비해 2명이 확인할 수 있도록 3명을 권장합니다.",
    dh_few_contacts_cta: "연락처 추가",
    dh_no_assets: "등록된 디지털 자산 없음",
    dh_no_assets_sub: "은행, 소셜미디어, 암호화폐: 여기 없는 것은 사라집니다.",
    dh_no_assets_cta: "자산 추가",
    dh_pol_title: "생존 증명",
    dh_pol_next: "다음 체크인:",
    dh_pol_confirm: "생존 증명 확인",
    dh_pol_state_alive: "활성",
    dh_pol_state_alert: "주의 필요",
    dh_pol_state_pending: "대기 중",
    vault_sub: "영원히 암호화된, 가장 소중한 비밀.",
    vault_type_password: "비밀번호",
    vault_type_capsule: "캡슐",
    vault_type_note: "메모",
    vault_type_credential: "인증정보",
    set_change_plan: "플랜 변경",
    set_current_plan: "현재 플랜",
    set_pay_recover_q: "결제했는데 플랜이 활성화되지 않았나요?",
    set_pay_recover_link: "결제 복구",
    set_cancel_sub: "구독 취소",
    set_storage_label: "저장 공간",
    set_storage_help: "{PCT}% 사용 중 · AES-256 암호화된 영상 및 음성",
    set_share_title: "KeepSoul 공유",
    set_share_sub: "가족을 초대하여 소중한 유산을 보호하세요",
    set_pol_card_title: "생존 증명",
    set_pol_card_sub: "체크인 및 연락처 설정",
    set_assets_card_title: "디지털 자산",
    set_assets_card_sub: "은행, 소셜미디어, 암호화폐, 기기",
    set_plan_usage_title: "플랜 사용량",
    set_usage_vault: "보관함 항목",
    set_usage_messages: "예약된 메시지",
    set_usage_heirs: "상속인",
    set_usage_contacts: "신뢰할 수 있는 연락처",
    set_per_month: "/월",
    set_per_year: "/년",
    set_pay_once: "1회 결제",
    set_no_recent_payments: "최근 7일 내에 확인된 결제 내역이 없습니다",
    set_recover_error: "결제 내역을 확인할 수 없습니다. support@keepsoul.app으로 문의해 주세요",
    set_upgrade_plan: "플랜 업그레이드",
    da_subtitle: "계정, 기기, 암호화폐, 보험 등 상속인에게 자동으로 전달될 자산입니다. 이 페이지는 「무엇이 존재하는지」를 보여주는 지도이며, 실제 비밀번호는 암호화된 금고에만 보관됩니다.",
    da_cred_placeholder: "KeepSoul 금고 · 1Password · 브라우저 관리자 · 금고 안의 종이…",
    da_cred_hint: "어디에 있는지만 설명하세요. 비밀번호 자체는 여기에 입력하지 마세요.",
    da_cred_hint_link: "금고에 암호화하여 보관하기 →",
    da_cred_hint_crypto: "여기에 시드 구문이나 개인 키를 절대 붙여넣지 마세요 — 금고에 암호화하여 보관하세요.",
    da_legacy_tag: "이전 데이터",
    da_legacy_password: "비밀번호 (이전에 저장됨)",
    da_legacy_pin: "PIN (이전에 저장됨)",
    da_legacy_seed: "시드 구문 (이전에 저장됨)",
    da_add: "추가",
    da_empty_for: "아직 {LABEL}을(를) 추가하지 않았습니다.",
    da_assigned_to: "지정 대상",
    da_heir: "상속인",
    da_heirs: "상속인",
    da_no_heirs_assigned: "지정된 상속인 없음",
    da_warn_sensitive: "매우 민감한 정보입니다. AES-256으로 암호화되어 있으며 사망 확인 시에만 공개됩니다.",
    da_warn_seed: "절대 누구에게도 공유하지 마세요. 생존 증명이 확인된 후에만 지정된 상속인에게 복호화됩니다.",
    da_security_note: "이 데이터는 AES-256-GCM으로 암호화되어 저장됩니다. 생존 증명이 귀하의 사망을 확인할 때만 지정된 상속인에게 자동으로 공개됩니다.",
    da_assign_heirs: "상속인 지정",
    da_label_title: "제목 / 라벨",
    da_title_ph: "예: {EXAMPLE}",
    da_eg_bank: "BBVA 주계좌",
    da_eg_social: "개인 Instagram",
    da_eg_generic: "간단한 라벨",
    da_instruction_ph: "상속인이 이것으로 무엇을 하기를 원하시나요…",
    da_edit_asset: "자산 수정",
    da_view_notes: "메모",
    da_view_instruction: "지침",
    da_view_encryption: "AES-256-GCM 암호화 저장 · 생존 증명이 사망을 확인할 때만 상속인에게 자동으로 전달됩니다.",
    select: "선택",
    vault_field_password: "비밀번호",
    vault_capsule_label: "캡슐",
    vault_capsule_desc: "사망 후에만 공개됩니다. 생존 증명을 통해 사망이 확인된 후 상속인이 받을 항목에 체크하세요.",
    hap_default_label: "이것을 받을 상속인",
    hap_no_heirs_yet: "아직 상속인을 추가하지 않으셨습니다. '상속인'으로 이동하여 먼저 추가해주세요.",
    hap_no_assignment_warning: "상속인이 지정되지 않아 이 항목은 자동으로 전달되지 않습니다.",
    lp_problem: "문제",
    lp_problem_title: "잃어버린 것은 돌아오지 않습니다.",
    lp_problem_sub: "매년 수백만 가족이 비밀번호, 사진, 암호화폐, 디지털 추억을 영원히 잃습니다. 완전한 솔루션은 존재하지 않았습니다. 지금까지는.",
    lp_stat_crypto: "손실된 암호화폐",
    lp_stat_passwords: "소유자 사망 시 잊혀진 비밀번호",
    lp_stat_accounts: "디지털 공백에 남겨진 계정",
    lp_solution: "해결책",
    lp_feature_vault: "암호화 보관함",
    lp_feature_vault_desc: "비밀번호, 암호화폐 키, 비밀 정보를 AES-256으로 암호화.",
    lp_feature_msg: "미래 메시지",
    lp_feature_msg_desc: "선택한 날짜에 전달되는 음성, 영상, 편지.",
    lp_feature_pol: "자동 생존 증명",
    lp_feature_pol_desc: "확인을 중단하면 디지털 상속 프로토콜이 활성화됩니다.",
    lp_feature_heirs: "디지털 상속",
    lp_feature_heirs_desc: "상속인을 지정하고 유산을 안전하게 분배하세요.",
    lp_feature_ai: "레거시 AI",
    lp_feature_ai_desc: "유산과 대화하세요: 이야기를 나누고, 개인 비서로 활용하세요.",
    lp_feature_zk: "AES-256-GCM 암호화",
    lp_feature_zk_desc: "민감한 데이터는 AES-256-GCM으로 암호화되어 저장됩니다. 프로토콜이 활성화될 때만 상속인에게 공개됩니다.",
    lp_how_title: "당신이 더 이상 여기 없을 때, 모든 것을 자동으로 활성화하는 시스템.",
    lh_label: "유산 상태",
    lh_loading: "유산을 분석하는 중…",
    lh_all_good: "완벽합니다. 잘하셨어요!",
    lh_well_protected: "유산이 잘 보호되고 있습니다",
    lh_resending: "발송 중…",
    lh_grade_excellent: "훌륭함",
    lh_grade_good: "좋음",
    lh_grade_fair: "개선 필요",
    lh_grade_weak: "미흡",
    sig_email_unverified_title: "이메일 인증 필요",
    sig_email_unverified_detail: "이메일 인증 전까지 유산이 전달되지 않습니다.",
    sig_email_unverified_cta: "이메일 재전송",
    sig_heirs_no_farewell_title: "작별 인사 없는 상속인 {N}명",
    sig_heirs_no_farewell_title_1: "작별 인사 없는 상속인 {N}명",
    sig_heirs_no_farewell_detail: "개인적인 메시지를 남길 수 있도록 몇 마디 녹음하거나 작성해 주세요.",
    sig_heirs_no_farewell_cta: "상속인으로 이동",
    sig_no_heirs_title: "아직 상속인을 추가하지 않았습니다",
    sig_no_heirs_detail: "상속인이 없으면 유산을 전달할 수 없습니다.",
    sig_no_heirs_cta: "상속인 추가",
    sig_no_contacts_title: "신뢰할 수 있는 연락처 없음",
    sig_no_contacts_detail: "생존 증명을 확인하려면 최소 1명의 연락처가 필요합니다.",
    sig_no_contacts_cta: "생존 증명 설정",
    sig_contacts_low_title: "신뢰할 수 있는 연락처 {N}명만 등록됨",
    sig_contacts_low_title_1: "신뢰할 수 있는 연락처 {N}명만 등록됨",
    sig_contacts_low_detail: "의심스러운 상황 발생 시 2명이 확인할 수 있도록 3명을 권장합니다.",
    sig_contacts_low_cta: "연락처 추가",
    sig_vault_empty_title: "보관함이 비어 있습니다",
    sig_vault_empty_detail: "최소 하나의 비밀번호 또는 중요 문서를 저장하세요.",
    sig_vault_empty_cta: "보관함으로 이동",
    sig_no_messages_title: "예약된 메시지 없음",
    sig_no_messages_detail: "누군가를 위한 메시지를 작성해 보세요 — 생일 축하, 작별 인사…",
    sig_no_messages_cta: "메시지 작성",
    sig_no_assets_title: "등록된 디지털 자산 없음",
    sig_no_assets_detail: "은행, SNS, 암호화폐 등 여기에 없는 것은 모두 사라집니다.",
    sig_no_assets_cta: "자산 추가",
    sig_stale_title: "{N}일 동안 유산이 업데이트되지 않았습니다",
    sig_stale_detail: "비밀번호, 상속인, 메시지가 최신 상태인지 확인해 주세요.",
    sig_stale_cta: "검토하기",
    sig_pol_overdue_title: "생존 증명 기한 초과",
    sig_pol_overdue_detail: "연락처에 알림이 가지 않도록 빠르게 생존 증명을 확인해 주세요.",
    sig_pol_overdue_cta: "지금 확인",
    sig_pol_soon_title: "{N}일 후 생존 증명",
    sig_pol_soon_detail: "기한 전에 확인해 주세요.",
    sig_pol_soon_cta: "생존 증명 확인하기",
    hint_vault_title: "여기에 보관할 내용",
    hint_vault_1: "예를 들어, <strong>암호화폐 지갑의 시드 구문</strong>을 저장하여 가족이 귀하의 Bitcoin을 복구할 수 있도록 하세요.",
    hint_vault_2: "또는 <strong>은행 계좌와 중요한 서비스의 비밀번호</strong> (Gmail, Apple ID, Netflix…)를 저장하여 사랑하는 사람들이 필요한 것을 폐쇄하거나 이전할 수 있도록 하세요.",
    hint_vault_3: "AES-256-GCM으로 암호화되어 보관됩니다. 언제든지 계정에서 금고에 접근할 수 있습니다. 생명 증명 프로토콜이 활성화되면, 귀하가 할당한 콘텐츠가 지정한 상속인에게 전달됩니다.",
    hint_messages_title: "마음에 남는 메시지",
    hint_messages_1: "예를 들어, <strong>자녀에게 20개의 메시지</strong>를 예약하여 40세가 될 때까지 생일마다 하나씩 전달하세요. 25세에는 음성 메시지, 결혼식 날 또 다른 메시지, 첫 아이가 태어났을 때 또 다른 메시지를.",
    hint_messages_2: "또는 파트너를 위해 첫 데이트를 회상하는 영상을 녹화하여 매년 기념일마다 도착하도록 하세요.",
    hint_messages_3: "손주가 졸업하는 날 열어볼 편지를 남길 수도 있습니다. 사랑은 만료되지 않습니다.",
    hint_heirs_title: "디지털 유산을 물려받을 사람",
    hint_heirs_1: "예를 들어, <strong>장남</strong>에게 금고 키와 은행 정보를 받도록 지정하고, 여동생에게 개인 메시지를 받도록 지정하세요.",
    hint_heirs_2: "각 상속인은 귀하가 할당한 것만 받습니다. 원하는 대로 조합하세요.",
    hint_heirs_3: "생명 증명이 귀하의 사망을 확인하면, KeepSoul이 각 상속인에게 유산의 해당 부분이 담긴 보안 이메일을 발송합니다.",
    hint_assets_title: "잃어버려서는 안 되는 자산",
    hint_assets_1: "예를 들어, <strong>주 은행 계좌</strong>를 IBAN 및 연결된 전화번호와 함께 등록하여 파트너가 자금 위치를 알 수 있도록 하세요.",
    hint_assets_2: "또는 <strong>암호화폐 지갑</strong> (Binance, MetaMask, Ledger)을 암호화된 복구 지침과 함께 등록하세요.",
    hint_assets_3: "SNS 계정 (폐쇄 또는 추모), 연금 계획, 생명보험, 세금 기록도 포함할 수 있습니다…",
      /* Founders Program (auto-translated) */
    plans_bridge_text: "접근 이상을 원하시나요? 창립자 플랜에는 회사의 실제 지분이 포함됩니다.",
    plan_founders_badge: "창립자 에디션",
    plan_founders_title: "KeepSoul 창립자",
    plan_founders_subtitle: "실제 지분 · 영원한 레거시",
    plan_founders_slots: "{TOTAL}석 중 {N}석 이용 가능",
    plan_founders_separator: "평생 플랜의 모든 혜택 + 추가:",
    plan_founders_feat_1: "모든 것이 무제한 — 제한 없음",
    plan_founders_feat_2: "금고, 메시지, 상속인 및 자산 무제한",
    plan_founders_feat_3: "월 결제 영구 면제",
    plan_founders_feat_4: "신규 베타 기능 우선 접근",
    plan_founders_feat_5: "프로필에 영구 표시되는 '창립자 #XXX' 지위",
    plan_founders_feat_6: "팀 직접 접근 가능한 창립자 전용 커뮤니티",
    plan_founders_feat_7: "KeepSoul S.L.의 실제 지분 1좌 — 자본금의 0.01%",
    plan_founders_feat_8: "5년차부터 배당 수령 권리",
    plan_founders_feat_9: "인수 시 매각 대금 참여 (drag-along / tag-along)",
    plan_founders_ownership_title: "지분 소유자가 된다는 의미는?",
    plan_founders_ownership_body: "창립자 석을 획득하면, KeepSoul 평생 접근권만 구매하는 것이 아닙니다 — 스페인 자본회사법(Ley de Sociedades de Capital)에 의해 법적으로 인정되는 권리를 가진 KeepSoul S.L.의 실제 사회적 지분을 받게 됩니다.\n\n🌍 시장: 디지털 레거시 관리는 2028년까지 890억 달러 규모로 추정되며, 연간 22% 성장하는 산업입니다. 매년 유럽에서만 380만 명이 관리되지 않은 디지털 자산을 남긴 채 사망합니다.\n\n📈 5개년 전망 (보수적 시나리오):\n· 2026: 2,000명 사용자 · ARR €168,000 · 배당 풀: €8,400\n· 2027: 8,000명 사용자 · ARR €768,000 · 배당 풀: €38,400\n· 2028: 25,000명 사용자 · ARR €2,700,000 · 배당 풀: €135,000\n· 2029: 60,000명 사용자 · ARR €6,480,000 · 배당 풀: €324,000\n· 2030: 120,000명 사용자 · ARR €14,400,000 · 배당 풀: €720,000\n누적 배당 풀 5% (2026–2030): €1,225,800\n\n인수 시: 기업가치 €10M → 귀하의 0.01% = €1,000 · 기업가치 €30M → €3,000\n\n⚖️ 법률 프레임워크 요약:\n· RDL 1/2010 (자본회사법)에 따른 매매\n· 지분 1좌 = KeepSoul S.L. 자본금의 0.01%\n· 배당은 경영진이 결정할 때 지급\n· 최초 5년간 양도 제한 (우선매수권)\n· Drag-along: 100% 매각 시 매각 대금 참여\n· Tag-along: 대주주 지분 매각 시 동반 참여 가능\n· 평생 접근 보장. 서비스 종료 시: 24개월 서비스 제공 또는 €195 환불\n\n⚠️ 전망치는 참고용이며 수익을 보장하지 않습니다.",
    plan_founders_legal_link: "📄 전체 법률 근거, 전망 및 투자설명서 보기 →",
    plan_founders_cta: "창립자 되기 →",
    plan_founders_trust: "🔒 공증 증서에 등록된 지분 · 단 500석 한정",
    founders_page_badge: "창립자 프로그램 — 한정 에디션",
    founders_page_label: "창립자 프로그램",
    founders_page_h1: "KeepSoul의 소유자가 되세요.",
    founders_page_h1_sub: "500석. 단 한 번. 영원히.",
    founders_page_cta_reserve: "내 자리 예약하기",
    founders_page_cta_prospect: "전체 투자설명서 읽기",
    founders_stat_spots: "총 좌석 수",
    founders_stat_price: "단일 가격",
    founders_stat_capital: "자본금 비율",
    founders_stat_lifetime: "평생 접근",
    founders_problem_label: "KEEPSOUL이 존재하는 이유",
    founders_problem_title: "매년 수십억 유로가 사라집니다.",
    founders_problem_body: "분실된 비밀번호. 접근 불가능한 암호화폐. 잊혀진 계정들. 전달되지 못한 메시지들. 누군가 정리된 디지털 레거시 없이 사망하면, 가족은 혼란을 상속받습니다. KeepSoul은 AES-256 암호화 저장소와 사망 시 자동 전달을 결합한 최초의 디지털 레거시 금고입니다 — 능동적 생존 확인 시스템으로 조율됩니다.",
    founders_market_label: "시장 규모",
    founders_market_title: "해결되지 않은 수조 규모의 산업.",
    founders_projection_label: "2026–2031 전망",
    founders_projection_title: "수익성으로 가는 길.",
    founders_projection_sub: "보수적 시나리오. 보험사 또는 은행과의 B2B 계약 미포함.",
    founders_projection_disclaimer: "* 전망치는 참고용입니다. 수익을 보장하지 않습니다. 배당은 실제 수익성과 경영진의 결정에 따라 달라집니다.",
    founders_acquisition_upside: "기업가치 €10M → 귀하의 0.01% = €1,000 · 기업가치 €30M → €3,000 · 기업가치 €100M → €10,000",
    founders_includes_label: "받게 되는 혜택",
    founders_includes_title: "귀하의 창립자 석.",
    founders_includes_left_title: "플랫폼 접근권",
    founders_includes_platform_1: "KeepSoul의 모든 것 무제한 — 영구적으로 제한 없음",
    founders_includes_platform_2: "금고, 메시지, 상속인 및 자산 무제한",
    founders_includes_platform_3: "월간 또는 연간 결제 영구 면제",
    founders_includes_platform_4: "베타 기능 우선 접근",
    founders_includes_platform_5: "프로필에 영구 표시되는 '창립자 #XXX' 배지",
    founders_includes_platform_6: "팀 직접 접근 가능한 창립자 전용 채널",
    founders_includes_right_title: "회사 지분",
    founders_includes_ownership_1: "KeepSoul S.L.의 실제 사회적 지분 1좌",
    founders_includes_ownership_2: "공증 증서에 등록된 자본금의 0.01%",
    founders_includes_ownership_3: "5년차부터 배당 수령 권리",
    founders_includes_ownership_4: "인수 시 매각 대금 참여",
    founders_includes_ownership_5: "대주주 지분 매각 시 tag-along 권리",
    founders_includes_ownership_6: "주주 계약 및 정관 열람 권한",
    founders_legal_label: "법률 프레임워크",
    founders_legal_title: "완전한 투명성.",
    founders_legal_intro: "이 제안은 현행 법률에 따라 구성되었습니다. 크라우드펀딩, 토큰, 참여형 대출이 아닙니다. 실제 법인 지분입니다.",
    founders_timeline_label: "로드맵",
    founders_timeline_title: "향후 5년.",
    founders_faq_label: "자주 묻는 질문",
    founders_faq_title: "알아야 할 모든 것.",
    founders_cta_title: "귀하의 자리가 기다립니다.",
    founders_cta_subtext: "단일 결제 · 갱신 없음 · 실제 지분",
    founders_cta_trust: "🔒 72시간 내 디지털 계약 체결 · 공증 지분 · 단 500석 한정",
    founders_of: "/",
    founders_spots_available: "석 이용 가능",
    founders_footer_disclaimer: "이 페이지는 공개 증권 제안이 아니며 CNMV 감독 대상이 아닙니다. 비상장 유한회사의 지분은 규제 시장에서 거래 가능한 증권이 아닙니다.",
    /* Landing additions (auto-translated) */
    nav_founders: "창립 멤버",
    nav_security: "보안",
    nav_signup_cta: "무료로 시작하기",
    nav_back_home: "홈",
    nav_dashboard_short: "대시보드로 이동",
    landing_trust_aes: "🔒 AES-256 암호화",
    landing_trust_gdpr: "🇪🇺 GDPR 준수",
    landing_trust_zk: "🛡️ 제로 지식",
    landing_trust_founders: "⭐ 500명의 창립 멤버",
    landing_how_label: "작동 방식",
    landing_how_title: "세 단계. 하나의 유산.",
    landing_how_1_title: "보관",
    landing_how_1_body: "암호화된 금고에 비밀번호, 문서, 메시지 및 디지털 자산을 추가합니다.",
    landing_how_2_title: "지정",
    landing_how_2_body: "상속인을 지명하고 각 상속인이 무엇을 언제 받을지 결정합니다.",
    landing_how_3_title: "자동 전달",
    landing_how_3_body: "KeepSoul은 정기적으로 귀하의 안부를 확인합니다. 응답이 없으면 자동으로 유산을 전달합니다.",
    landing_security_label: "보안",
    landing_security_title: "귀하의 유산, 오직 귀하의 손에만.",
    landing_security_aes_title: "AES-256-GCM",
    landing_security_aes_body: "은행과 정부가 중요 정보를 보호하기 위해 사용하는 동일한 표준입니다.",
    landing_security_gdpr_title: "GDPR · LOPDGDD",
    landing_security_gdpr_body: "유럽 및 스페인 데이터 보호 규정을 완전히 준수합니다.",
    landing_security_zk_title: "제로 지식",
    landing_security_zk_body: "데이터는 서버를 떠나기 전에 암호화됩니다. 저희조차도 볼 수 없습니다.",
    landing_proof_label: "왜 KEEPSOUL인가",
    landing_proof_title: "중요한 것을 위해 만들어졌습니다.",
    landing_proof_stat1_value: "€14.000M",
    landing_proof_stat1_label: "계획 없이 사망하여 손실된 암호화폐 금액",
    landing_proof_stat2_value: "68%",
    landing_proof_stat2_label: "디지털 유산 계획이 없는 유럽 성인의 비율",
    landing_proof_stat3_value: "3분",
    landing_proof_stat3_label: "첫 자산을 보호하는 데 걸리는 평균 시간",
    landing_final_subtle: "이미 500명 이상의 창립 멤버 · AES-256 암호화 · GDPR",
    landing_footer_tagline: "중요한 것을 보호하십시오.",
    landing_footer_col_product: "제품",
    landing_footer_col_legal: "법률",
    landing_footer_col_support: "지원",
    landing_footer_about: "© 2026 KeepSoul · 스페인 무르시아",
    upgrade_modal_title: "플랜의 한도에 도달했습니다",
    upgrade_modal_body: "무료 플랜에는 {LIMIT}개의 {ITEM}이(가) 포함됩니다. 제한 없이 계속하려면 프리미엄으로 업그레이드하십시오.",
    upgrade_modal_cta: "플랜 보기 →",
    upgrade_modal_dismiss: "나중에",
    payment_success_banner: "🎉 결제가 완료되었습니다! {PLAN} 플랜이 이제 활성화되었습니다.",
    payment_success_founder: "🏛️ 환영합니다, 창립 멤버 #{N}! KeepSoul 참여가 확인되었습니다. 72시간 내에 계약서를 받으실 것입니다.",
    payment_cancelled_banner: "결제가 취소되었습니다. 플랜은 변경되지 않았습니다.",
    payment_dismiss: "닫기",
    /* Founders funds-allocation + table headers (auto-translated) */
    founders_proj_col_year: "연도",
    founders_proj_col_users: "활성 사용자",
    founders_proj_col_arpu: "월 ARPU",
    founders_proj_col_arr: "예상 ARR",
    founders_proj_col_div: "배당 풀 5%",
    founders_proj_total: "총계",
    founders_proj_cumulative: "누적",
    founders_arpu_note: "= 유료 사용자당 월평균 수익 (Average Revenue Per User, ARPU). 월간 및 연간 구독자를 결합한 수치입니다. 모든 활성 사용자가 유료 결제를 하는 것은 아니며, 일부는 무료 플랜을 사용합니다.",
    founders_funds_label: "자금 사용 계획",
    founders_funds_title: "모든 유로, 성장으로.",
    founders_funds_intro: "파운더스 프로그램을 통해 조달된 자본의 100%는 KeepSoul의 성장을 위해 직접 재투자됩니다. 이는 단순한 지출이 아닙니다. 탄탄한 제품을 업계의 기준으로 만들기 위한 연료입니다.",
    founders_funds_marketing_title: "마케팅 및 고객 확보",
    founders_funds_marketing_body: "스페인과 라틴아메리카 핵심 시장에서의 고객 유치 캠페인, SEO 포지셔닝, 콘텐츠 제작 및 브랜드 인지도 확대를 위한 활동입니다.",
    founders_funds_product_title: "제품 및 기술",
    founders_funds_product_body: "신규 기능 개발, 보안 강화, 인프라 확장 및 플랫폼의 지속적인 개선 작업입니다.",
    founders_funds_alliances_title: "제휴 및 확장",
    founders_funds_alliances_body: "공증인, 행정사, 보험사, 은행과의 제휴 계약 체결 및 신규 국가·언어로의 진출입니다.",
    founders_funds_legal_title: "법적 구조 및 운영",
    founders_funds_legal_body: "유한회사(S.L.) 설립, 규정 준수, 지원 및 일상 운영 업무입니다.",
    founders_funds_closing: "귀하의 투자는 정체되지 않습니다. KeepSoul을 정상으로 이끌기 위해 — 그리고 귀하를 함께 — 끊임없이 일합니다.",
    /* Landing: remove-zk replacements (auto-translated) */
    landing_trust_encrypted: "🔐 저장 시 암호화",
    landing_final_subtle_no_founders: "AES-256 암호화 · GDPR · 스페인 무르시아에서 제작",
    landing_security_atrest_title: "저장 시 암호화",
    landing_security_atrest_body: "민감한 데이터는 저장 전에 AES-256-GCM으로 서버에서 암호화됩니다. 누군가 데이터베이스에 접근하더라도 무의미한 암호문만 보게 됩니다.",
    /* Bug 3 batch (auto-translated) */
    confirm_email_missing_token: "확인 토큰이 없습니다.",
    confirm_email_error_default: "이메일을 확인할 수 없습니다.",
    confirm_email_loading_title: "이메일을 확인하는 중…",
    confirm_email_loading_body: "잠시만 기다려 주세요.",
    confirm_email_success_title: "이메일이 확인되었습니다!",
    confirm_email_success_body: "이제 디지털 유산이 활성화되었습니다. 로그인하여 생명 증명을 설정하고 가장 중요한 것을 보호하기 시작하세요.",
    confirm_email_go_dashboard: "대시보드로 이동",
    confirm_email_go_login: "로그인",
    confirm_email_error_title: "확인할 수 없습니다",
    confirm_email_error_help: "링크가 만료되었거나 이미 사용되었을 수 있습니다. 로그인하여 대시보드에서 새 확인 이메일을 요청하세요.",
    login_email_confirmed_banner: "이메일이 정상적으로 확인되었습니다. 로그인하여 대시보드에 접속하세요.",
    login_tab_email: "이메일",
    login_any_email_hint: "모든 이메일과 호환됩니다 (Gmail, Outlook, ProtonMail 등)",
    settings_share_copied: "메시지가 클립보드에 복사되었습니다 ✨",
    settings_share_failed: "공유할 수 없습니다",
    settings_downgrade_confirm: "구독을 취소하고 무료 플랜으로 돌아가시겠습니까? 계정과 데이터는 유지됩니다.",
    settings_downgrade_done: "구독이 취소되었습니다. 무료 플랜이 활성화되었습니다.",
    settings_generic_error: "오류",
    settings_delete_done: "계정이 삭제되었습니다. 확인 이메일을 보내드렸습니다.",
    settings_delete_failed: "계정 삭제 중 오류가 발생했습니다",
    settings_export_google_warn: "계정이 Google을 사용하고 있습니다. 내보내기 전에 설정에서 비밀번호를 생성하세요.",
    settings_export_started: "다운로드가 시작되었습니다. 안전한 곳에 보관하세요.",
    pol_confirmed_toast: "생명 증명이 확인되었습니다 ✓",
    discount_applied_full: "플랜이 100% 활성화되었습니다!",
    evb_already_verified: "이메일이 이미 확인되었습니다. 페이지를 새로고침하세요.",
    /* EmailVerifyBanner */
    evb_title: "유산 활성화를 위해 이메일을 확인하세요",
    evb_body_prefix: "다음 주소로 링크를 보내드렸습니다",
    evb_body_suffix: "확인하실 때까지 생존 확인 및 유산 전달이 비활성화되어 있습니다.",
    evb_sending: "전송 중…",
    evb_resend_cta: "이메일 재전송",
    evb_resent_to: "{email}(으)로 확인 이메일이 전송되었습니다",
    evb_resend_failed: "이메일을 전송할 수 없습니다",
    /* Bug 3 extra (auto-translated) */
    pol_demo_email_sent: "{EMAIL}로 데모 이메일이 발송되었습니다. 몇 분 내에 받은편지함을 확인해 주세요.",
    historia_no_audio_first: "먼저 오디오를 녹음하거나 업로드해 주세요",
    historia_transcribe_done: "전사 완료 ✓",
    historia_transcribe_failed: "전사할 수 없습니다",
    settings_export_link_sent: "{EMAIL}로 링크가 발송되었습니다. 다운로드 가능 시간은 60분입니다.",
    media_video_too_long: "동영상이 너무 깁니다. 최대 60분까지 가능합니다.",
    media_video_low_res: "동영상 해상도가 낮습니다({W}×{H}). 업로드는 가능하지만, 소중한 추억을 위해 최소 720p를 권장합니다.",
    media_audio_limit_30min: "30분 제한에 도달했습니다.",
    media_mic_denied: "마이크 권한이 거부되었습니다. 브라우저 설정에서 활성화해 주세요.",
    media_mic_failed: "녹음을 시작할 수 없습니다. 마이크를 확인해 주세요.",
    media_file_too_large: "이 파일은 너무 큽니다. 최대 {MB}MB까지 가능합니다.",
    media_file_added: "파일이 추가되었습니다",
    media_file_uploaded: "✓ {NAME} 업로드 완료",
    media_upload_failed: "파일 업로드 중 오류가 발생했습니다",
    /* Bug 3 settings extra (auto-translated) */
    settings_export_link_failed: "링크를 전송할 수 없습니다.",
    settings_password_incorrect: "비밀번호가 올바르지 않습니다.",
    settings_unauthorized: "권한이 없습니다.",
    settings_export_too_many_requests: "너무 많은 링크를 요청하셨습니다. 나중에 다시 시도해 주십시오.",
    settings_export_your_email_fallback: "귀하의 이메일",
    pol_demo_failed_default: "데모를 전송할 수 없습니다",
    /* Bug 3 set2 (auto-translated) */
    settings_portal_open_failed: "관리 포털을 열 수 없습니다. 오류라고 생각되시면 support@keepsoul.app으로 문의해 주시기 바랍니다.",
    settings_export_failed: "내보내기에 실패했습니다.",
    settings_export_not_authorized: "내보내기 권한이 없습니다.",
    settings_export_quota_exhausted: "오늘의 다운로드 한도를 모두 사용하셨습니다. 나중에 다시 시도해 주시기 바랍니다.",
    /* Bug 3 auth pages (auto-translated) */
    auth_back_to_login: "로그인으로 돌아가기",
    fp_title: "비밀번호 복구",
    fp_subtitle: "이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
    fp_email_label: "이메일",
    fp_email_placeholder: "you@email.com",
    fp_sending: "전송 중…",
    fp_send_cta: "안내 메일 보내기",
    fp_check_email_title: "이메일을 확인하세요",
    fp_check_email_body_prefix: "만약",
    fp_check_email_body_suffix: "주소가 등록되어 있다면, 비밀번호 재설정 링크를 보내드렸습니다. 스팸 폴더도 확인해 주시기 바랍니다.",
    fp_need_help: "도움이 필요하신가요?",
    rp_missing_token: "링크에 복구 토큰이 없습니다.",
    rp_min_12: "비밀번호는 최소 12자 이상이어야 합니다",
    rp_need_lower: "소문자를 최소 1개 이상 포함해야 합니다",
    rp_need_upper: "대문자를 최소 1개 이상 포함해야 합니다",
    rp_need_digit: "숫자를 최소 1개 이상 포함해야 합니다",
    rp_need_symbol: "특수문자(!@#$...)를 최소 1개 이상 포함해야 합니다",
    rp_mismatch: "비밀번호가 일치하지 않습니다",
    rp_success_toast: "비밀번호가 정상적으로 업데이트되었습니다",
    rp_link_expired: "이 링크는 만료되었습니다. 새 링크를 요청해 주세요.",
    rp_link_used_or_invalid: "이 링크는 이미 사용되었거나 유효하지 않습니다.",
    rp_update_failed: "비밀번호를 업데이트할 수 없습니다.",
    rp_done_title: "완료!",
    rp_done_body: "비밀번호가 정상적으로 업데이트되었습니다. 로그인 페이지로 이동합니다…",
    rp_invalid_link_title: "유효하지 않은 링크",
    rp_request_new_link: "새 링크 요청",
    rp_new_password_h1: "새 비밀번호",
    rp_hint: "최소 12자, 대문자, 숫자 및 특수문자 1개 포함.",
    rp_confirm_label: "비밀번호 확인",
    rp_updating: "업데이트 중…",
    rp_update_cta: "비밀번호 업데이트",
    rp_new_password_label: "새 비밀번호",
    /* Premium relaunch + plans welcome (Iter 22) */
    plans_welcome_title: "계정이 확인되었습니다! 플랜을 선택하세요",
    plans_welcome_sub: "할인 코드가 있다면 요금제를 선택하기 전에 적용하세요.",
    plans_skip_for_now: "지금은 건너뛰기",
    plans_discount_section_title: "할인 코드가 있으신가요?",
    plans_discount_placeholder: "여기에 코드를 입력하세요",
    plans_discount_apply: "적용",
    plans_discount_success_short: "코드가 성공적으로 적용되었습니다!",
    plans_discount_invalid_short: "유효하지 않은 코드입니다",
    plans_personal_monthly_equiv_v2: "월 €5.83에 해당합니다 — 2개월 무료",
    plans_yearly_save_v2: "연간 €14 절약",
    /* Paywall (Iter 24) */
    paywall_title: "KeepSoul 잠금 해제",
    paywall_body: "가장 중요한 것을 지키기 시작하려면 플랜을 선택하세요: 비밀번호, 메시지, 디지털 유산.",
    paywall_cta: "플랜 보기",
    paywall_hint: "프리미엄 €39/년 · 평생 €149",
    paywall_locked_badge: "잠김",
    /* Vault auto-lock (Iter 29) */
    vault_lock_setting_title: "보관함 자동 잠금",
    vault_lock_setting_body: "비밀을 표시하기 전에 KeepSoul 비밀번호를 다시 요청하며, X분 동안 활동이 없으면 보관함을 다시 잠급니다.",
    vault_lock_enabled: "사용 중",
    vault_lock_disabled: "사용 안 함",
    vault_lock_minutes_label: "잠금 시간(분):",
    vault_lock_title: "보관함 잠김",
    vault_lock_body: "보안을 위해 {MIN}분 동안 활동이 없어 보관함이 잠겼습니다. 다시 보려면 비밀번호를 입력하세요.",
    vault_lock_pwd_placeholder: "KeepSoul 비밀번호",
    vault_lock_pwd_required: "비밀번호를 입력하세요",
    vault_lock_pwd_wrong: "잘못된 비밀번호입니다",
    vault_lock_no_password: "이 계정은 Google 로그인을 사용하며 로컬 비밀번호가 없습니다",
    vault_lock_failed: "잠금을 해제할 수 없습니다. 다시 시도하세요",
    vault_lock_cta: "잠금 해제",
    vault_lock_unlocking: "잠금 해제 중…",

    /* Digital Assets — list/grid toggle (Iter 28) */
    da_view_grid: "카드 보기",
    da_view_list: "목록 보기",
    da_list_empty: "아직 추가된 디지털 자산이 없습니다. 은행 계좌나 소셜 미디어부터 시작해 보세요.",
    da_list_col_name: "자산",
    da_list_col_category: "카테고리",
    da_list_col_heir: "지정된 상속인",
    da_list_no_heir: "지정되지 않음",

    /* Will & Executor (Iter 30) */
    nav_will: "유언장",
    nav_ice: "비상시 안내",
    will_title: "유언장 및 유언 집행인",
    will_subtitle: "법적 유언장이 어디에 보관되어 있는지, 그리고 누가 그것을 집행할지 가족에게 알려주세요.",
    will_info_banner: "KeepSoul은 유언장 자체를 보관하지 않습니다. 이 페이지는 유언장이 어디에 있고 누가 집행해야 하는지를 가족에게 알려줄 뿐입니다.",
    will_exists_q: "유언장이 있습니까?",
    will_exists_yes: "예",
    will_exists_no: "아니요",
    will_exists_unknown: "잘 모르겠음",
    will_location_label: "보관 위치 / 보관자",
    will_location_ph: "López 공증사무소, Mayor 거리 12, 마드리드 · Pérez 변호사 사무소 · 집안 금고…",
    will_location_hint: "공증인, 변호사, 물리적 보관 장소 또는 문서를 가지고 있는 사람.",
    will_executor_section: "유언 집행인",
    will_executor_section_hint: "마지막 유지를 집행하도록 법적으로 지정된 사람.",
    will_executor_name: "성명",
    will_executor_relationship: "관계",
    will_executor_relationship_ph: "자매, 변호사, 친한 친구…",
    will_executor_phone: "전화",
    will_executor_email: "이메일",
    will_notes: "추가 메모",
    will_notes_ph: "유언장 또는 집행인에 관한 관련 정보.",
    will_instructions_title: "집행인을 위한 지시 사항",
    will_instructions_hint: "집행인이 무엇을 해야 하는지 자유롭게 작성하세요. 이 내용은 ICE 문서에도 표시됩니다.",
    will_instructions_ph: "먼저 제 동반자 María에게 연락한 후, 책상 위의 봉투를 열어 주세요…",
    saving: "저장 중…",

    /* ICE Document (Iter 30) */
    ice_title: "비상시 안내 문서",
    ice_subtitle: "유언 집행인과 상속인이 알아야 할 모든 것을 담은 단일 요약본.",
    ice_print: "인쇄 / PDF로 저장",
    ice_print_short: "PDF 저장",
    ice_warning: "이 문서에는 민감한 정보가 포함되어 있습니다. 꼭 필요한 경우에만 인쇄하고 안전한 곳에 보관하세요.",
    ice_empty: "아직 데이터가 충분하지 않습니다. 유언장, 상속인, 디지털 자산부터 추가해 보세요.",
    ice_cover_title: "소유자",
    ice_owner_name: "이름",
    ice_owner_email: "이메일",
    ice_generated_at: "생성 일시",
    ice_will_title: "유언장 및 집행인",
    ice_will_missing: "소유자는 법적 유언장이 없다고 표시했습니다.",
    ice_will_unknown: "소유자가 유언장 존재 여부를 표시하지 않았습니다.",
    ice_no_executor: "아직 집행인이 지정되지 않았습니다.",
    ice_add_executor: "집행인 추가",
    ice_instructions_title: "집행인을 위한 지시 사항",
    ice_no_instructions: "아직 집행인을 위한 지시 사항을 작성하지 않았습니다.",
    ice_add_instructions: "지시 사항 작성",
    ice_heirs_title: "상속인",
    ice_no_heirs: "아직 추가된 상속인이 없습니다.",
    ice_assets_title: "디지털 자산",
    ice_no_assets: "아직 추가된 디지털 자산이 없습니다.",
    ice_assets_note: "민감한 데이터(비밀번호, 키)는 여기에 표시되지 않으며 KeepSoul 암호화 금고 안에만 보관됩니다.",
    ice_vault_title: "금고 내용",
    ice_no_vault: "금고가 비어 있습니다.",
    ice_vault_note: "제목만 표시됩니다. 암호화된 내용은 KeepSoul을 통해 지정된 상속인에게 전달됩니다.",
    ice_cat_bank: "은행 계좌",
    ice_cat_social: "소셜 미디어",
    ice_cat_crypto: "암호화폐",
    ice_cat_email: "이메일 계정",
    ice_cat_device: "기기",
    ice_cat_insurance: "보험 및 연금",
    ice_cat_other: "기타",

    /* Physical documents (Iter 30 follow-up) */
    will_phys_title: "중요한 종이 문서",
    will_phys_hint: "주민등록증/여권, 부동산 등기, 종이 보험증권, 원본 증명서… 어디에 있는지만 알려주고, 문서 자체는 여기에 보관하지 마세요.",
    will_phys_add: "문서 추가",
    will_phys_empty: "아직 등록된 종이 문서가 없습니다.",
    will_phys_doc_label: "문서",
    will_phys_doc_ph: "여권 · 부동산 등기 · MAPFRE 생명보험 증권…",
    will_phys_loc_label: "보관 장소 / 보관자",
    will_phys_loc_ph: "책상 맨 위 서랍 · BBVA 은행 안전 금고 · López 공증사무소…",
    will_phys_notes_label: "메모",
    will_phys_notes_ph: "예비 열쇠는 발코니 화분에, 비밀번호 1234…",
    ice_phys_title: "중요한 종이 문서",
    ice_no_phys: "아직 등록된 종이 문서가 없습니다.",
    ice_add_phys: "문서 추가",
    ice_phys_loc: "위치",
    delete: "삭제",

    /* ICE Editor — Phase 2 (Iter 31) */
    yes: "예",
    no: "아니요",
    will_no_will_warning: "유언장이 없는 경우, 유언 집행인의 지정에 법적 승인이 필요할 수 있습니다. 공증인이나 변호사와 함께 유언장을 작성하시기를 권장합니다.",
    ice_legal_notice: "이 문서는 유언장이 아닙니다. 별도의 유언장이 필요합니다. 이 문서는 단지 집행인이 필요한 정보를 찾는 데 도움을 줄 뿐입니다. 유언장과 현지 법률이 항상 우선합니다.",
    ice_mode_edit: "편집",
    ice_mode_summary: "요약",
    ice_sec_personal: "개인 정보",
    ice_sec_personal_hint: "기본 신원 정보.",
    ice_p_full_name: "성명",
    ice_p_id_number: "주민등록증 / 신분증 번호",
    ice_p_phone_home: "집 전화",
    ice_p_phone_work: "직장 / 휴대전화",
    ice_p_passport: "여권 번호",
    ice_p_nationality: "국적",
    ice_p_residence: "거주지",
    ice_p_email: "이메일",
    ice_sec_marital: "혼인 관계와 배우자",
    ice_sec_marital_hint: "배우자 또는 현재 동반자에 대한 정보.",
    ice_m_status: "혼인 상태",
    ice_m_status_ph: "미혼, 기혼, 사실혼, 이혼, 사별…",
    ice_m_spouse_name: "배우자 / 동반자 이름",
    ice_m_spouse_id: "배우자 / 동반자 신분증",
    ice_m_spouse_phone: "전화",
    ice_m_spouse_email: "이메일",
    ice_sec_divorce: "이전 이혼 (해당 시)",
    ice_sec_divorce_hint: "이혼 합의서나 판결문이 보관된 위치.",
    ice_d_agreement_location: "이혼 합의서 보관 위치",
    ice_d_agreement_ph: "서류함의 법률 폴더 · X 변호사 사무소 · 법원 번호…",
    ice_d_notes: "메모",
    ice_sec_heir_overrides: "통보할 가족과 연락처",
    ice_sec_heir_overrides_hint: "이미 추가한 상속인을 재사용합니다. 통보 여부와 유언장에 따른 상속 내용을 명시하세요.",
    ice_no_heirs_yet: "아직 상속인을 추가하지 않았습니다. 상속인 섹션에서 추가하세요.",
    ice_h_notify: "통보",
    ice_h_bequest: "유언장에 따른 상속 내용 (선택)",
    ice_h_bequest_ph: "가족 집, 계좌의 50%, 어머니의 보석…",
    ice_h_bequest_short: "상속 내용",
    ice_h_do_not_notify: "통보하지 않음",
    ice_sec_children: "자녀",
    ice_sec_children_hint: "자녀 한 명 한 명의 이름과 연락처.",
    ice_c_name: "이름",
    ice_c_contact: "연락처",
    ice_c_contact_ph: "전화 / 이메일",
    ice_c_add: "자녀 추가",
    ice_c_empty: "아직 자녀를 추가하지 않았습니다.",
    ice_sec_guardians: "자녀의 법정 후견인",
    ice_sec_guardians_hint: "당신이 없을 경우 미성년 자녀를 돌볼 사람.",
    ice_g_name: "이름",
    ice_g_contact: "연락처",
    ice_g_add: "후견인 추가",
    ice_g_empty: "아직 후견인을 추가하지 않았습니다.",
    ice_sec_staff: "가사 도우미 (선택)",
    ice_sec_staff_hint: "당신과 함께 일하거나 집에서 일하는 사람.",
    ice_s_name: "이름",
    ice_s_contact: "연락처",
    ice_s_contact_ph: "전화 / 이메일 · 업무 종류",
    ice_s_add: "추가",
    ice_s_empty: "항목 없음.",
    ice_sec_pro_contacts: "전문가 연락처",
    ice_sec_pro_contacts_hint: "주치의, 변호사, 재무 자문 / 회계사.",
    ice_pro_doctor: "의사",
    ice_pro_lawyer: "변호사",
    ice_pro_advisor: "재무 자문 / 회계사",
    ice_pro_name: "이름",
    ice_pro_contact: "전화",
    ice_pro_email: "이메일",
    ice_sec_medical: "의료 정보",
    ice_sec_medical_hint: "응급 의사가 필요로 할 수 있는 정보.",
    ice_med_insurance: "의료 보험",
    ice_med_member_id: "회원 / 보험 증권 번호",
    ice_med_blood_type: "혈액형",
    ice_med_living_will: "사전의료의향서가 있습니까?",
    ice_med_living_will_unknown: "잘 모르겠음",
    ice_sec_banks: "재무 정보 — 은행",
    ice_sec_banks_hint: "기관과 참조 번호만 작성하세요. 자격 증명은 암호화된 금고에만 보관됩니다.",
    ice_b_entity: "기관",
    ice_b_reference: "참조 번호",
    ice_b_auto_payments: "취소해야 할 자동 결제",
    ice_b_auto_payments_ph: "Netflix, Spotify, 헬스장, 주택담보대출…",
    ice_b_add: "계좌 추가",
    ice_b_empty: "아직 추가된 은행 계좌가 없습니다.",
    ice_b_no_creds: "이곳에 절대 비밀번호, 키, PIN을 적지 마세요. 기관과 참조 번호만 작성합니다.",
    ice_sec_investments: "재무 정보 — 투자",
    ice_sec_investments_hint: "주식, 펀드, 채권, 암호화폐, 부동산…",
    ice_inv_type: "종류",
    ice_inv_type_ph: "주식, 펀드, 암호화폐, 부동산…",
    ice_inv_platform: "플랫폼 / 기관",
    ice_inv_reference: "참조 번호",
    ice_inv_add: "투자 추가",
    ice_inv_empty: "아직 추가된 투자가 없습니다.",
    ice_sec_valuables: "자산, 보석 및 수집품",
    ice_sec_valuables_hint: "설명과 추정 가치 (자유 텍스트).",
    ice_v_description: "설명",
    ice_v_description_ph: "할아버지께 물려받은 시계 · 서명이 있는 Sorolla 그림…",
    ice_v_estimated_value: "추정 가치",
    ice_v_location: "위치",
    ice_v_add: "추가",
    ice_v_empty: "항목 없음.",
    ice_sec_credentials: "자격 증명과 접근 위치",
    ice_sec_credentials_hint: "비밀번호를 어디에 보관하는지, 집행인이 어떻게 접근할 수 있는지. 절대로 이곳에 비밀번호 자체를 적지 마세요.",
    ice_cred_type: "비밀번호 관리 방식",
    ice_cred_type_choose: "선택…",
    ice_cred_type_pm: "비밀번호 관리자 (1Password, Bitwarden, LastPass…)",
    ice_cred_type_browser: "브라우저 관리자 (Chrome, Safari…)",
    ice_cred_type_paper: "종이에 기록",
    ice_cred_type_memory: "기억 속에만",
    ice_cred_type_mixed: "혼합",
    ice_cred_where: "보관 위치",
    ice_cred_where_ph: "1Password, 이메일 juan@... — 마스터 키는 공증사무소의 봉인된 봉투 안 · 침실 서랍의 파란색 노트…",
    ice_cred_how_to_access: "집행인이 접근하는 방법",
    ice_cred_how_to_access_ph: "동반자 María가 마스터 키를 알고 있음. 복구 코드 봉투는 López 공증사무소…",
    ice_cred_warning: "중요: 이곳에 KeepSoul이 실제 비밀번호를 포함해서는 안 됩니다. 이 필드는 집행인이 어디에서 그리고 어떻게 접근할 수 있는지만 설명하는 용도이며, 비밀번호 자체는 포함하지 않습니다.",
    ice_sec_social: "소셜 미디어",
    ice_sec_social_hint: "플랫폼과 사용자명 (비밀번호는 적지 마세요).",
    ice_soc_platform: "플랫폼",
    ice_soc_username: "사용자명",
    ice_soc_add: "추가",
    ice_soc_empty: "항목 없음.",
    ice_sec_funeral: "장례 희망 사항 (선택)",
    ice_sec_funeral_hint: "장례에 관한 희망 사항.",
    ice_funeral_ph: "화장, 꽃 없음, Coldplay 음악…",
    ice_funeral_priority: "참고: 유언장이 있다면 유언장이 이 희망 사항보다 우선합니다.",
    ice_sec_notes: "추가 메모",
    ice_sec_notes_hint: "글로 남기고 싶은 그 외의 모든 것.",

    /* Inline validation messages (Iter 32) */
    val_invalid_email: "유효하지 않은 이메일",
    val_invalid_phone: "유효하지 않은 전화번호",

    /* Progress indicator (Iter 32) */
    ice_progress_label: "완성도",
    ice_progress_hint: "더 많은 섹션을 작성할수록 집행인에게 더 유용한 문서가 됩니다.",
    ice_progress_done: "문서가 완성되었습니다. 6개월마다 검토하시기를 권장합니다.",

    /* Share with executor (Iter 32) */
    ice_share_btn: "집행인에게 보내기",
    ice_share_modal_title: "집행인에게 보내기",
    ice_share_modal_intro: "{email}로 문서 링크를 이메일로 보냈습니다. 문서를 열려면 아래 6자리 코드가 필요합니다.",
    ice_share_code_label: "일회용 접근 코드",
    ice_share_code_warning: "⚠️ 이 코드를 이메일로 보내지 마세요. 전화나 직접 만남으로 집행인에게 전달하세요. 이 코드 없이는 링크는 사용할 수 없습니다.",
    ice_share_modal_link: "링크",
    ice_share_modal_expires: "만료까지",
    ice_share_done: "완료",
    ice_share_err_no_executor: "먼저 유언 페이지에서 집행인 이메일을 설정하세요.",
    ice_share_err_generic: "링크를 생성할 수 없습니다. 다시 시도하세요.",
    ice_share_err_code_required: "6자리 코드를 입력하세요.",
    ice_share_err_invalid_code: "코드가 올바르지 않습니다.",
    ice_share_err_not_found: "이 링크는 존재하지 않거나 취소되었습니다.",
    ice_share_err_expired: "이 링크는 만료되었습니다.",
    ice_share_gate_title: "비상시 안내 문서",
    ice_share_gate_intro: "소유자가 이메일로 이 링크를 보냈습니다. 문서를 열려면 별도로 알려준 6자리 코드(전화 또는 직접)를 입력하세요.",
    ice_share_gate_footer: "코드 입력에 5회 실패하면 링크는 자동으로 차단되며 새 링크를 보내야 합니다.",
    ice_share_open: "문서 열기",
    ice_share_viewing: "이 문서를 다음의 자격으로 보고 있습니다",
    copy: "복사",
    copied: "복사됨",

    ice_checklist_title: "집행인의 다음 단계",
    ice_checklist_intro: "가장 흔한 업무에 대한 안내입니다. 실제 상황과 현지 법률에 맞게 조정하세요.",
    ice_checklist_immediate: "즉시 (48시간 이내)",
    ice_checklist_week: "첫 주",
    ice_checklist_month: "첫 달",
    ice_checklist_c_imm_1: "사망 증명서를 여러 부 신청하세요(최소 5부) — 거의 모든 절차에서 필요합니다.",
    ice_checklist_c_imm_2: "이 문서에 명시된 가족 구성원에게 연락하여 소유자의 뜻에 따라 알리세요.",
    ice_checklist_c_imm_3: "장례식장과 연락하고, 명시된 장례 희망 사항이 있다면 따르세요.",
    ice_checklist_c_imm_4: "지정된 위치에서 유언장을 찾아 공증인/변호사에게 전달하세요.",
    ice_checklist_c_wk_1: "의료 보험 및 사회 보장기관에 통보하세요.",
    ice_checklist_c_wk_2: "주요 은행에 통보하세요 — 상속 절차가 끝날 때까지 계좌가 동결될 수 있습니다.",
    ice_checklist_c_wk_3: "명시된 자동 결제(Netflix, 헬스장 등)를 취소하세요.",
    ice_checklist_c_wk_4: "소유자의 변호사가 명시되어 있다면 상속 절차를 시작하기 위해 연락하세요.",
    ice_checklist_c_mo_1: "공증인과 명시된 상속인과 함께 상속 절차를 진행하세요.",
    ice_checklist_c_mo_2: "소유자의 뜻에 따라 소셜 미디어 계정을 닫거나 추모 계정으로 전환하세요.",
    ice_checklist_c_mo_3: "KeepSoul 금고에 접근하세요 — 자격 증명 안내에 따라 비밀번호를 복구하세요.",
    ice_checklist_c_mo_4: "아직 활성 상태인 신용카드, 구독 및 서비스를 해지하세요.",
    ice_checklist_footer: "이 목록은 법률 자문이 아닙니다. 법적 절차는 항상 전문가와 상담하세요.",

    /* Active shares panel (Iter 33) */
    ice_shares_panel_title: "공유된 링크",
    ice_shares_empty: "아직 어떤 집행인에게도 문서를 보내지 않았습니다.",
    ice_shares_col_sent: "보낸 일시",
    ice_shares_col_expires: "만료 일시",
    ice_shares_col_views: "조회 수",
    ice_shares_col_failed: "코드 실패",
    ice_share_status_active: "활성",
    ice_share_status_expired: "만료됨",
    ice_share_status_revoked: "취소됨",
    ice_share_status_expired_hint: "만료됨 — 필요하면 새 링크를 만드세요.",
    ice_share_revoke: "취소",
    ice_share_revoke_title: "이 링크를 취소할까요?",
    ice_share_revoke_intro: "집행인은 더 이상 이 링크로 문서를 열 수 없습니다(올바른 코드를 입력해도 마찬가지). 이 작업은 즉시 적용되며 되돌릴 수 없습니다.",
    ice_share_revoke_yes: "예, 취소합니다",
    ice_share_revoke_cancel: "닫기",
    ice_share_revoked_toast: "링크가 취소되었습니다",
    refresh: "새로고침",
},
};

const I18nContext = createContext({
  t: (k) => k,
  lang: "es",
  setLang: () => {},
  theme: "dark",
  setTheme: () => {},
});

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ks_lang") || "es");
  const [theme, setTheme] = useState(() => localStorage.getItem("ks_theme") || "dark");

  // Persist + sync language to backend so emails are localized.
  useEffect(() => {
    localStorage.setItem("ks_lang", lang);
    const timer = setTimeout(() => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/auth/lang`;
        fetch(url, {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ lang }),
        }).catch(() => {});
      } catch (_) { /* ignore */ }
    }, 200);
    return () => clearTimeout(timer);
  }, [lang]);

  // Persist theme + apply it to <html> so CSS variables switch globally.
  useEffect(() => {
    localStorage.setItem("ks_theme", theme);
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    // Update browser chrome color too (status bar on iOS PWA)
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "light" ? "#F2EDE4" : "#0A0A0A");
  }, [theme]);

  const t = useCallback(
    (k) => translations[lang]?.[k] || translations.en[k] || translations.es[k] || k,
    [lang]
  );
  const value = useMemo(() => ({ t, lang, setLang, theme, setTheme }), [t, lang, theme]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
